// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../svg/union.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/check.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../svg/check.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../svg/menu_hamburger.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../img/search.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../svg/user_circle.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../svg/heart_fav_outline.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../svg/cart.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../svg/mail_envelope.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../svg/chevron_right.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../svg/heart_fav_solid-active-blue.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../svg/chevron_down_small.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../svg/check-white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../svg/star_outline.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../svg/star_solid.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../svg/delete_trash_bin.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../svg/delete_trash_bin-error.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../svg/user_circle-main.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../svg/info_circle outline-grey.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../svg/check-main.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../svg/chevron_right_smal-blue.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";

/* TOP SALE */
.top {
    height: 32px;
    background: var(--color-periwinkle-crayola);
    font-size: 12px;
    font-family: "RalewayRegular";
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

@media screen and (max-width: 1024px) {
    .top {
        display: none;
    }
}

.top-close {
    position: absolute;
    top: 10px;
    right: 15px;
    width: 12px;
    height: 12px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
    background-size: contain;
    cursor: pointer;
}


/* CLOSE */
.close {
    position: absolute;
    width: 48px;
    height: 48px;
    cursor: pointer;
    border-radius: 50%;
    background: var(--color-periwinkle-crayola);
    display: flex;
    justify-content: center;
    align-items: center;
}

.overlay {
    opacity: 0;
    visibility: hidden;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
}

.overlay._active {
    opacity: 1;
    visibility: visible;
}

/* CURTAIN */
.curtain {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.2);
    -webkit-backdrop-filter: blur(4px);
    backdrop-filter: blur(4px);
    z-index: 11;
    overflow: hidden;
    opacity: 0;
    visibility: hidden;
}

.curtain._active {
    opacity: 1;
    visibility: visible;
}

.curtain-wrap {
    position: fixed;
    top: 0;
    right: 0;
    width: 728px;
    height: 100vh;
    background: var(--color-white);
    padding: 32px 64px 0 64px;
    overflow-y: auto;
}

@media screen and (max-width: 1024px) {
    .curtain-wrap {
        width: 100%;
        top: 32px;
        bottom: 0;
        height: calc(100% - 100px);
        padding: 16px 20px;
    }
}

.curtain-close {
    top: 24px;
    right: 28px;
    cursor: pointer;
    z-index: 11;
}

@media screen and (max-width: 1024px) {
    .curtain-close {
        top: 12px;
        right: 16px;
        width: 32px;
        height: 32px;
    }
}

.curtain-back {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 24px;
    cursor: pointer;
}

.curtain-back svg {
    width: 30px;
    height: 30px;
}

@media screen and (max-width: 1024px) {
    .curtain-back svg {
        width: 24px;
        height: 24px;
    }
}

.curtain-title {
    font-size: 24px;
    line-height: 32px;
    font-family: "RalewaySemiBold";
    color: var(--color-granite);
    display: flex;
    align-items: center;
}

.curtain-title span {
    font-size: 18px;
    line-height: 28px;
    font-family: "RalewayRegular";
}

@media screen and (max-width: 1024px) {
    .curtain-title {
        font-size: 20px;
        line-height: 26px;
        width: 90%;
    }
}

.curtain .detail-left {
    max-height: 467px;
    height: 100%;
}

/* /CURTAIN */
/* MAP */
.ymaps-2-1-78-controls__toolbar_right {
    display: none;
}

/* /MAP */
/* HEADER */
.header {
    position: relative;
    z-index: 30;
}

.header-wrapper {
    /*background: rgba(255, 255, 255, 0.5);*/
    background-color: #ffffff;
    z-index: 100;
}

.header-top {
    /*padding: 25px 0 10px 0;*/
    padding: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

@media screen and (max-width: 1024px) {
    .header-top {
        justify-content: center;
        /*padding-top: 20px;*/
    }
}

.header-mobile__back {
    display: none;
    position: absolute;
    top: 15px;
    left: 21px;
    width: 24px;
    height: 24px;
}

@media screen and (max-width: 1024px) {
    .header-mobile__back {
        display: block;
    }
}

.header-left {
    display: flex;
    align-items: center;
    width: 256px;
    /*padding: 25px 0 10px 7px;*/
    padding: 0 0 0 7px;
    white-space: nowrap;
    gap: 15px;
}

@media screen and (max-width: 1024px) {
    .header-left {
        display: none;
    }
}


.header-lang {
    position: relative;
}

.header-lang a {
    font-size: 12px;
    line-height: 24px;
    color: #6F707A;
    height: 24px;
    margin-right: 24px;
    display: flex;
    align-items: center;
}

@media screen and (max-width: 1024px) {
    .header-lang a {
        margin-right: 14px;
    }
}

.header-lang a svg {
    margin-right: 2px;
}

@media screen and (max-width: 1024px) {
    .header-lang a svg {
        margin-right: 5px;
    }
}

.header-back {
    display: flex;
    flex-direction: column;
}

.header-back__mobile {
    padding: 20px;
    gap: 15px;
    align-items: center;
}

.header-back__mobile > div,
.header-back__mobile > a {
    text-decoration: none !important;
    outline: none !important;
    cursor: pointer;
    display: block;
}

.header-back__phone {
    font-size: 16px;
    line-height: 22px;
    color: var(--color-main);
    font-family: "RalewayBold";
}

.header-back__all {
    font-size: 12px;
    line-height: 16px;
    color: #6F707A;
}

.header-back__all svg {
    display: none;
}

.header-logo {
    display: block;
    margin-top: 7px;
}

@media screen and (max-width: 1024px) {
    .header-logo {
        margin-top: 0;
    }
}

.header-logo__img {
    width: 165px;
    /*height: 24px;*/
}

@media screen and (max-width: 1024px) {
    .header-logo__img {
        width: 100px;
    }
}

.header-right {
    position: relative;
    padding: 0;
}

.header-right__pc {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 256px;
    position: relative;
}

@media screen and (max-width: 1024px) {
    .header-right__pc {
        display: none;
    }
}

.header-lk {
    width: 24px;
    height: 24px;
    margin-right: 23px;
    position: relative;
}

.header-lk-auth {
    font-size: 12px;
    line-height: 16px;
    color: var(--color-white);
    position: absolute;
    top: -10px;
    height: 16px;
    min-width: 16px;
    right: -10px;
    text-align: center;
}

.header-lk-auth:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    height: 16px;
    width: 16px;
    display: inline-block;
}

.header-favorite {
    width: 24px;
    height: 24px;
    position: relative;
    margin-right: 25px;
}

.header-auth__wrap {
    width: 400px;
    max-width: 100%;
    margin: 40px auto 0;
}

.header-auth__container {
    padding: 20px;
}

.user-menu {

}

.user-menu__item {
    box-sizing: border-box;
    cursor: pointer;
    padding-top: 20px;
    padding-bottom: 15px;
}

.header-auth__wrap .checkout-label__text {
    font-size: 14px;
    line-height: 18px;
}

.header-auth__wrap .checkout-label__text a {
    color: var(--color-blackberry);
}

@media screen and (max-width: 1024px) {
    .header-auth__wrap .checkout-label {
        display: block;
    }
}

.header-auth__label {
    background: var(--color-light-periwinkle-crayola);
    border-radius: 4px;
    display: flex;
    flex-direction: row;
}


.header-auth__title {
    font-size: 16px;
    line-height: 22px;
    color: var(--color-granite);
    margin-bottom: 16px;
}

.header-auth__title-comment {
    font-size: 0.8em;
    color: var(--color-blackberry);
}

.header-auth__title {
    font-size: 16px;
    line-height: 22px;
    color: var(--color-granite);
    margin-bottom: 16px;
}

.header-auth__title a {
    color: var(--color-blue-steel);
}

.header-auth__input {
    border-radius: 4px;
    width: 100%;
    height: 40px;
    padding: 8px 8px 8px 0;
    border: none;
    position: relative;
    background: transparent;
    display: inline-block;
    box-sizing: border-box;
    font-size: 20px;
}

@media screen and (max-width: 1024px) {
}

.header-auth__input:focus {
    outline: none;
}

.header-auth__text {
    font-size: 16px;
    line-height: 22px;
    color: var(--color-blackberry);
    margin-top: 16px;
}

.header-auth__btn {
    display: block;
    width: 100%;
    border: none;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    font-family: "RalewaySemiBold";
    margin: 16px 0;
    padding: 8px 0;
}

.header-auth__email {
    display: inline-block;
    font-size: 16px;
    line-height: 22px;
    color: var(--color-blue-steel);
}

.header-auth__success {
    position: fixed;
    top: 16px;
    right: 16px;
    border-radius: 16px;
    background: var(--color-main);
    width: 320px;
    height: 92px;
    padding: 20px 24px;
    display: none;
}

@media screen and (max-width: 360px) {
    .header-auth__success {
        left: 16px;
        width: auto;
    }
}

.header-auth__success._active {
    display: block;
    z-index: 10;
}

.header-auth__success-close {
    position: absolute;
    top: 14px;
    right: 14px;
}

.header-auth__success-close svg path {
    fill: var(--color-white);
}

.header-auth__success-text {
    font-size: 20px;
    line-height: 26px;
    color: var(--color-white);
    font-family: "RalewaySemiBold";
}

/* /HEADER */
/* BURGER MENU */
.burger {
    position: absolute;
    top: 80px;
    left: 0;
    width: 100%;
    background: var(--color-white);
    box-shadow: 0px 1px 4px rgba(8, 11, 48, 0.2);
    opacity: 0;
    visibility: hidden;
    z-index: 11;
}

.burger._active {
    opacity: 1;
    visibility: visible;
}

.burger:before {
    position: absolute;
    content: '';
    top: -3px;
    left: 0;
    width: 100%;
    height: 3px;
    background: var(--color-white);
}

.burger-menu {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    /*height: 520px;*/
    /*width: 864px;*/
    margin: 0 auto;
    justify-content: center;
    padding: 20px;
}

.burger-list {
    margin-bottom: 27px;
    margin-right: 48px;
    width: 180px;
    margin-top: 20px;
}

.burger-list:last-child {
    margin-right: 0;
}

.burger-item {
    margin-bottom: 12px;
}

.burger-item:first-child {
    font-size: 16px;
    line-height: 22px;
    font-family: "RalewaySemiBold";
    color: var(--color-blackberry);
}

.burger-item:last-child {
    margin-bottom: 0;
}

.burger-link {
    font-size: 16px;
    line-height: 22px;
    color: var(--color-granite);
}

/* /BURGER MENU */
/* LANG */
.lang {
    position: absolute;
    top: 30px;
    left: 0;
    width: 160px;
    background: var(--color-white);
    box-shadow: 0px 4px 16px rgba(8, 11, 48, 0.2);
    border-radius: 4px;
    padding: 16px 22px 16px 20px;
    opacity: 0;
    visibility: hidden;
    z-index: 11;
}

.lang._active {
    opacity: 1;
    visibility: visible;
}

@media screen and (max-width: 1024px) {
    .lang {
        left: initial;
        right: 0;
    }
}

.lang-link {
    display: block;
    font-size: 16px !important;
    line-height: 24px;
    color: var(--color-granite);
    padding-left: 36px;
    margin-bottom: 16px;
}

.lang-link:last-child {
    margin-bottom: 0;
}

.lang-link._active {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat top left;
    background-size: 22px 28px;
}

/* /LANG */

/* ALL CONNECTIONS */
.connection-list {
    margin: 64px auto;
    width: 200px;
}

.connection-item {
    margin-bottom: 24px;
}

.connection-link {
    font-size: 18px;
    line-height: 28px;
    color: var(--color-granite);
    display: flex;
    align-items: center;
}

.connection-link svg {
    margin-right: 20px;
}

/* /ALL CONNECTIONS */
/* MENU MOBILE */
.menu {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 68px;
    background: var(--color-light-periwinkle-crayola);
    display: none;
    opacity: 0;
    /*visibility: hidden;*/
}

.menu-mobile-bottom {
}

.menu-mobile-bottom .icon {
    position: relative;
}

.menu-mobile-bottom .header-count {
    top: -10px;
    right: -10px;
}

@media screen and (max-width: 1024px) {
    .menu {
        opacity: 1;
        visibility: visible;
        display: block;
        z-index: 1000;
    }
}

.menu-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.menu-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-width: 70px;
    height: 68px;
}

@Media screen and (max-width: 350px) {
    .menu-item {
        min-width: 60px;
    }
}

.menu-item._active {
    background: var(--color-main);
}

.menu-item._active .menu-link {
    color: var(--color-white);
}

.menu-item._active svg path {
    fill: #fff;
}

.menu-item__avatar {
    border-radius: 50%;
}

.menu-icon {
    width: 24px;
    height: 24px;
    margin: 0 auto 8px;
    background-size: contain;
}

.menu-link {
    font-size: 10px;
    line-height: 12px;
    font-family: "RalewayMedium";
    text-align: center;
    color: var(--color-blackberry);
}

.menu-burger {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat;
}

.menu-search {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat;
}

.menu-lk {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat;
}

.menu-favorite {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat;
}

.menu-basket {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat;
}


/* /OPEN MOBILE MENU */

/* NAV */


/* /NAV */
/* FOOTER */
.footer {
    padding-bottom: 54px;
}

@media screen and (max-width: 1024px) {
    .footer {
        padding-bottom: 132px;
    }
}

.footer-logo {
    text-align: center;
    margin-bottom: 29px;
}

.footer-menu {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    /*height: 518px;*/
    /*width: 864px;*/
    margin: 0 auto;
    justify-content: center;
    z-index: 100;
}

@media screen and (max-width: 1024px) {
    .footer-menu {
        width: 180px;
        height: auto;
    }
}

.footer-list {
    margin-bottom: 32px;
    margin-right: 48px;
    width: 180px;
}

.footer-list__mobile {
    margin-bottom: 0;
    margin-right: 0;
    width: auto;
}

@media screen and (max-width: 1024px) {
    .footer-list {
        display: none;
    }

    .footer-list:nth-child(3) {
        margin-right: 0;
        text-align: center;
        display: block;
    }
}

.footer-list:last-child {
    margin-right: 0;
}

.footer-item {
    margin-bottom: 12px;
}

.footer-item:first-child {
    font-size: 16px;
    line-height: 22px;
    font-family: "RalewaySemiBold";
    color: var(--color-blackberry);
}

.footer-item:last-child {
    margin-bottom: 0;
}

.footer-link {
    font-size: 16px;
    line-height: 22px;
    color: var(--color-granite);
}

.footer-subscription {
    text-align: center;
    height: 198px;
    background: var(--color-periwinkle-crayola);
    padding-top: 32px;
    margin-bottom: 50px;
}

@media screen and (max-width: 1024px) {
    .footer-subscription {
        height: auto;
        padding: 32px 20px;
    }
}

.footer-subscription__title {
    font-size: 16px;
    line-height: 22px;
    font-family: "RalewaySemiBold";
    margin-bottom: 4px;
    color: var(--color-granite);
}

.footer-subscription__text {
    font-size: 14px;
    line-height: 20px;
    color: var(--color-blackberry);
    margin-bottom: 15px;
}

.footer-subscription__condition {
    font-size: 12px;
    line-height: 16px;
    color: var(--color-blackberry);
    margin-top: 16px;
}

.footer-subscription__condition a {
    font-size: 12px;
    line-height: 16px;
    color: var(--color-blackberry);
    text-decoration: underline;
}

.footer-form {
    display: flex;
    justify-content: center;
    align-items: center;
}

.footer-form__label {
    width: 320px;
    position: relative;
}

.footer-form__label:before {
    position: absolute;
    content: '';
    left: 12px;
    top: 8px;
    width: 24px;
    height: 24px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat;
    background-size: contain;
}

.footer-form__input {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blackberry);
    padding: 8px 0 8px 44px;
    font-family: "RalewayRegular";
    width: 100%;
    height: 40px;
    border-radius: 4px;
    background: var(--color-white);
    border: none;
}

.footer-form__input:focus {
    outline: none;
}

.footer-form__btn {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border: none;
    margin-left: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.footer-form__btn:focus {
    outline: none;
}

.footer-soc {
    margin: 16px 0 48px 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

.footer-soc__link {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: var(--color-periwinkle-crayola);
    margin-right: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
}

@media screen and (max-width: 767px) {
    .footer-soc__link {
        width: 44px;
        height: 44px;
        margin-right: 8px;
    }
}

.footer-soc__link:last-child {
    margin-right: 0;
}

.footer-bottom {
    display: flex;
    justify-content: center;
    align-items: center;
}

@media screen and (max-width: 767px) {
    .footer-bottom {
        flex-direction: column;
    }
}

.footer-bottom__item {
    margin-right: 24px;
}

@media screen and (max-width: 767px) {
    .footer-bottom__item {
        margin-right: 0;
    }
}

.footer-bottom__item:last-child {
    margin-right: 0;
}

.footer-bottom__link {
    font-size: 14px;
    line-height: 20px;
    color: var(--color-blackberry);
}

.footer-copy {
    margin-top: 16px;
    text-align: center;
    font-size: 14px;
    line-height: 20px;
    color: var(--color-blackberry);
    text-transform: uppercase;
}

/* /FOOTER */
/* BREADCRUMBS */
.breadcrumbs {
    font-size: 12px;
    line-height: 20px;
    color: var(--color-blackberry);
    text-align: center;
    margin-top: 13px;
}

@media screen and (max-width: 1024px) {
    .breadcrumbs {
        display: none;
    }
}

.breadcrumbs-link {
    margin-right: 20px;
    color: var(--color-blackberry);
}

.breadcrumbs-arrow {
    position: relative;
}

.breadcrumbs-arrow:after {
    position: absolute;
    content: '';
    top: 2px;
    right: -15px;
    width: 10px;
    height: 10px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat;
    background-size: contain;
}

/* /BREADCRUMBS */
/* CATALOG */
.catalog {
    margin-top: 56px;
}

@media screen and (max-width: 1024px) {
    .catalog {
        margin-top: 22px;
    }
}

.catalog-wrap {
    display: flex;
}

@media screen and (max-width: 1024px) {
    .catalog-wrap {
        flex-direction: column;
    }
}

.catalog-right {
    width: 100%;
    margin-left: 60px;
}

@media screen and (max-width: 1170px) {
    .catalog-right {
        margin-left: 30px;
    }
}

@media screen and (max-width: 1024px) {
    .catalog-right {
        margin-left: 0;
    }
}

.catalog-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

@media screen and (max-width: 1024px) {
    .catalog-top._fixed {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 32px;
        background: var(--color-white);
        z-index: 11;
        padding: 15px;
    }

    /*
        .catalog-top._fixed .catalog-filter {
            margin-top: 0;
        }

     */
}

/*
.catalog-filter {
    display: flex;
    align-items: center;
}

@media screen and (max-width: 1024px) {
    .catalog-filter {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        margin-top: 42px;
    }
}

@media screen and (max-width: 576px) {
    .catalog-filter {
        margin-top: 13px;
    }
}

.catalog-filter__item {
    position: relative;
    display: inline-block;
    cursor: pointer;
    margin-right: 8px;
}

@media screen and (max-width: 1024px) {
    .catalog-filter__item {
        display: block;
        flex-shrink: 0;
    }
}

.catalog-filter__item:first-child .catalog-filter__title {
    padding: 4px 12px 4px 9px;
}

@media screen and (max-width: 1024px) {
    .catalog-filter__item:first-child .catalog-filter__title {
        border: none;
        margin-right: 0;
    }
}

.catalog-filter__item:first-child .catalog-filter__wrap {
    width: 240px;
}

.catalog-filter__item:last-child {
    margin-right: 0;
}

.catalog-filter__item:last-child._active span:first-child {
    display: none;
}

.catalog-filter__item:last-child._active .catalog-filter__count {
    font-size: 14px;
    line-height: 20px;
    font-family: "RalewayRegular";
    background: transparent;
    color: var(--color-main);
    margin-left: 0;
}

@media screen and (max-width: 1024px) {
    .catalog-filter__item:last-child._active .catalog-filter__count {
        font-size: 16px;
        line-height: 22px;
        font-family: "RalewayRegular";
        color: var(--color-blackberry);
    }
}

.catalog-filter__item._active {
    background: var(--color-light-periwinkle-crayola);
}

@media screen and (max-width: 1024px) {
    .catalog-filter__item._active {
        background: var(--color-white);
    }
}

.catalog-filter__link {
    display: none;
    font-size: 14px;
    line-height: 22px;
    color: var(--color-main);
}

.catalog-filter__link svg {
    width: 18px;
    height: 16px;
    margin-right: 11px;
}

.catalog-filter__link svg path {
    fill: var(--color-gray-window);
}

@media screen and (max-width: 1024px) {
    .catalog-filter__link {
        display: flex;
        align-items: center;
        margin-left: 42px;
    }
}

@media screen and (max-width: 576px) {
    .catalog-filter__link {
        margin-left: 15px;
    }
}

.catalog-filter__mobile {
    display: flex;
}

@media screen and (max-width: 1024px) {
    .catalog-filter__mobile {
        display: none;
        opacity: 0;
        visibility: hidden;
        position: fixed;
        bottom: 0;
        left: 0;
        height: calc(100vh - 32px);
        width: 100%;
        background: var(--color-white);
        box-shadow: 0px 4px 16px rgba(8, 11, 48, 0.2);
        padding: 12px 16px 16px 20px;
        z-index: 51;
    }

    .catalog-filter__mobile._active {
        display: block;
        opacity: 1;
        visibility: visible;
    }

    .catalog-filter__mobile .catalog-filter__item {
        border-bottom: 1px solid var(--color-light-periwinkle-crayola);
    }

    .catalog-filter__mobile .catalog-filter__item:first-child {
        border-top: 1px solid var(--color-light-periwinkle-crayola);
    }

    .catalog-filter__mobile .catalog-filter__title {
        font-size: 20px;
        line-height: 22px;
        font-family: "RalewaySemiBold";
        border: none;
        padding: 15px 0;
        display: flex;
        align-items: center;
        height: auto;
    }

    .catalog-filter__mobile .catalog-filter__title svg {
        width: 18px;
        height: 18px;
    }
}

@media screen and (max-width: 576px) {
    .catalog-filter__mobile .catalog-filter__title {
        font-size: 16px;
        line-height: 22px;
        padding: 18px 0 12px 0;
    }
}

.catalog-filter__mobile-top {
    display: none;
}

@media screen and (max-width: 1024px) {
    .catalog-filter__mobile-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 40px;
    }
}

@media screen and (max-width: 576px) {
    .catalog-filter__mobile-top {
        margin-bottom: 27px;
    }
}

.catalog-filter__mobile-title {
    font-size: 20px;
    line-height: 26px;
    color: var(--color-granite);
    font-family: "RalewaySemiBold";
}

.catalog-filter__mobile-close {
    width: 32px;
    height: 32px;
    cursor: pointer;
    border-radius: 50%;
    background: var(--color-periwinkle-crayola);
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 20px;
}

.catalog-filter__mobile .catalog-filter__text {
    padding-left: 29px;
}

.catalog-filter__title {
    font-size: 14px;
    line-height: 20px;
    color: var(--color-main);
    padding: 4px 12px 4px 12px;
    border: 1px solid var(--color-light-periwinkle-crayola);
    border-radius: 4px;
    display: flex;
    align-items: center;
    height: 30px;
    position: relative;
}

.catalog-filter__title svg {
    width: 24px;
    height: 24px;
    margin-right: 2px;
}

.catalog-filter__count {
    font-size: 10px;
    line-height: 16px;
    font-family: "RalewaySemiBold";
    color: var(--color-white);
    background: var(--color-main);
    border-radius: 50%;
    display: none;
    margin-left: 8px;
    padding: 0 5px 0 4px;
    text-align: center;
    width: 100%;
}

@media screen and (max-width: 1024px) {
    .catalog-filter__count {
        padding: 0 4px;
    }
}

.catalog-filter__count._active {
    display: inline-block;
}

@media screen and (max-width: 1024px) {
    .catalog-filter__count._active {
        width: auto;
    }
}

.catalog-filter__wrap {
    display: none;
    background: var(--color-white);
    box-shadow: 0px 4px 16px rgba(8, 11, 48, 0.2);
    border-radius: 4px;
    position: absolute;
    top: 40px;
    left: 0;
    width: 260px;
    padding: 16px 16px 16px 20px;
    z-index: 5;
}

@media screen and (max-width: 1024px) {
    .catalog-filter__wrap {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100% !important;
        height: calc(100vh - 32px);
        z-index: 51;
    }
}

.catalog-filter__wrap._active {
    display: block;
}

.catalog-filter__wrap-max {
    width: 260px;
    height: 400px;
    overflow: hidden;
    padding: 0 0 16px 20px;
}

@media screen and (max-width: 1024px) {
    .catalog-filter__wrap-max {
        width: 100%;
        top: 32px;
        height: calc(100vh - 32px);
    }
}

.catalog-filter__wrap-max .catalog-filter__text:before {
    position: absolute;
    content: '';
    left: 0;
    top: 2px;
    width: 20px;
    height: 20px;
    background: var(--color-light-periwinkle-crayola);
    border-radius: 3px;
}

.catalog-filter__wrap-back {
    display: none;
}

@media screen and (max-width: 1024px) {
    .catalog-filter__wrap-back {
        display: flex;
        align-items: center;
        font-size: 20px;
        line-height: 26px;
        color: var(--color-granite);
        margin-top: 18px;
    }

    .catalog-filter__wrap-back svg {
        width: 21px;
        height: 21px;
        margin-right: 21px;
    }
}

.catalog-filter__wrap-count {
    display: none;
}

@media screen and (max-width: 1024px) {
    .catalog-filter__wrap-count {
        display: inline-block;
        font-size: 18px;
        line-height: 24px;
        color: var(--color-blackberry);
        margin-left: 10px;
    }
}

.catalog-filter__scroll {
    height: 344px;
    overflow-y: auto;
    padding-top: 16px;
    padding-right: 16px;
    padding-bottom: 16px;
}

@media screen and (max-width: 1024px) {
    .catalog-filter__scroll {
        height: 100%;
    }
}

.catalog-filter__min {
    height: 200px;
}

@media screen and (max-width: 1024px) {
    .catalog-filter__min {
        padding-top: 16px;
    }
}

.catalog-filter__label {
    display: block;
    width: 100%;
    margin-bottom: 8px;
}

.catalog-filter__label:last-child {
    margin-bottom: 0;
}

.catalog-filter__radio {
    opacity: 0;
    visibility: hidden;
    z-index: -1;
    position: absolute;
}

.catalog-filter__radio:checked + .catalog-filter__text:after {
    position: absolute;
    content: '';
    left: -4px;
    top: 0;
    width: 24px;
    height: 24px;
    background: url("../svg/check-main.svg") no-repeat;
    background-size: contain;
}

.catalog-filter__check {
    opacity: 0;
    visibility: hidden;
    z-index: -1;
    position: absolute;
}

.catalog-filter__check:checked + .catalog-filter__text:after {
    position: absolute;
    content: '';
    left: 0;
    top: 1px;
    width: 20px;
    height: 20px;
    background: url("../svg/check-white.svg") no-repeat var(--color-main);
    background-size: contain;
    border-radius: 3px;
}

.catalog-filter__check-clear {
    width: 20px;
    height: 20px;
    display: none;
    margin-left: 10px;
}

.catalog-filter__check-clear svg {
    width: 20px;
    height: 20px;
}

.catalog-filter__check-clear._active {
    display: block;
    z-index: 2;
}

@media screen and (max-width: 1024px) {
    .catalog-filter__check-clear._active {
        position: absolute;
        right: 24px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        width: 18px;
        height: 18px;
    }
}

.catalog-filter__text {
    position: relative;
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
    padding-left: 36px;
    display: flex;
    align-items: center;
}

.catalog-filter__color {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 8px;
}

.catalog-filter__buttons {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 56px;
    background: var(--color-white);
    border-top: 1px solid var(--color-light-periwinkle-crayola);
    display: flex;
    justify-content: center;
    align-items: center;
}

.catalog-filter__success {
    font-size: 14px;
    line-height: 22px;
    border: 1px solid var(--color-main);
    height: 32px;
    width: 106px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
}

.catalog-filter__clear {
    font-size: 14px;
    line-height: 22px;
    color: var(--color-main);
    background: var(--color-white);
    border: 1px solid var(--color-pale-blue);
    border-radius: 4px;
    height: 32px;
    width: 106px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.catalog-filter__search {
    position: relative;
    display: block;
    margin-bottom: 18px;
}

.catalog-filter__search:before {
    position: absolute;
    content: '';
    top: 8px;
    left: 10px;
    width: 24px;
    height: 24px;
    background: url("../svg/search.svg") no-repeat;
    background-size: contain;
}

.catalog-filter__search-input {
    border-radius: 4px;
    background: var(--color-light-periwinkle-crayola);
    height: 40px;
    width: 100%;
    padding: 8px 8px 8px 44px;
    display: block;
    border: none;
}

.catalog-filter__search-input:focus {
    outline: none;
}

.catalog-filter__search-input:active {
    outline: none;
}

.catalog-filter__search-clear {
    position: absolute;
    top: 7px;
    right: 12px;
    opacity: 0;
    visibility: hidden;
}

.catalog-filter__search-clear._active {
    opacity: 1;
    visibility: visible;
}

.catalog-filter__price {
    margin-top: 8px;
    margin-bottom: 34px;
}

.catalog-filter__price-input {
    background: var(--color-light-periwinkle-crayola);
    border-radius: 4px;
    border: none;
    padding: 8px 12px;
    font-size: 16px;
    line-height: 24px;
    color: var(--color-gray-window);
    height: 40px;
    width: 87px;
}

.catalog-filter__price-input::-webkit-outer-spin-button, .catalog-filter__price-input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.catalog-filter__price-input:focus {
    outline: none;
}

.catalog-filter__price-input:active {
    outline: none;
}

@media screen and (max-width: 1024px) {
    .catalog-filter__price-input {
        width: 44%;
    }
}

@media screen and (max-width: 440px) {
    .catalog-filter__price-input {
        width: 42%;
    }
}

@media screen and (max-width: 340px) {
    .catalog-filter__price-input {
        width: 41%;
    }
}

.catalog-filter__price-min {
    margin-right: 4px;
}

.catalog-filter__price-max {
    margin: 0 4px;
}

.catalog-filter__range {
    position: relative;
    margin-bottom: 20px;
    display: block;
    padding-bottom: 20px;
}

.catalog-filter__range-input {
    pointer-events: none;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    outline: none;
    margin: 0;
    padding: 0;
    border-radius: 8px;
    -webkit-appearance: none;
    height: 4px;
    background: var(--color-main);
}

.catalog-filter__range-input::-webkit-slider-thumb {
    pointer-events: all;
    position: relative;
    z-index: 1;
    outline: 0;
    -webkit-appearance: none;
    height: 16px;
    width: 16px;
    border-radius: 12px;
}

.catalog-filter__range-input::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 2px solid #fff;
    background: var(--color-white);
    cursor: pointer;
    box-shadow: 0px 1px 4px rgba(8, 11, 48, 0.2);
}

.catalog-filter__range-input::-webkit-scrollbar-button {
    width: 4px;
}

.catalog-filter__range-input::-webkit-resizer {
    width: 3px;
}

.catalog-filter__range-input::-webkit-scrollbar {
    width: 3px;
}
*/
.catalog-grid {
    display: flex;
    align-items: center;
    border: 1px solid var(--color-light-periwinkle-crayola);
    border-radius: 4px;
}

@media screen and (max-width: 1024px) {
    .catalog-grid {
        display: none;
    }
}

.catalog-grid__item {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 32px;
    cursor: pointer;
}

.catalog-grid__item svg {
    width: 20px;
    height: 20px;
}

.catalog-grid__item._active {
    cursor: initial;
    background: var(--color-light-periwinkle-crayola);
}

.catalog-grid__item._active svg path {
    fill: var(--color-granite);
}

/* PRODUCT */
.product-grid__3 .product-item {
    width: calc(33.33333% - 32px);
}

@media screen and (max-width: 1300px) {
    .product-grid__3 .product-item {
        width: calc(33.33333% - 16px);
        margin: 0 8px 16px 8px;
    }
}

@media screen and (max-width: 767px) {
    .product-grid__3 .product-item {
        width: calc(50% - 16px);
    }
}

@media screen and (max-width: 576px) {
    .product-grid__3 .product-item {
        width: calc(50% - 8px);
        margin: 0 4px 16px 4px;
    }
}

.product-grid__3 .product-item__img {
    height: 494px;
}

@media screen and (max-width: 1300px) {
    .product-grid__3 .product-item__img {
        height: 440px;
    }
}

@media screen and (max-width: 1200px) {
    .product-grid__3 .product-item__img {
        height: 380px;
    }
}

@media screen and (max-width: 440px) {
    .product-grid__3 .product-item__img {
        height: 260px;
    }
}

.product-grid__3 .product-banner {
    width: calc(33.33333% - 32px);
}

@media screen and (max-width: 767px) {
    .product-grid__3 .product-banner {
        width: calc(50% - 32px);
    }
}

@media screen and (max-width: 576px) {
    .product-grid__3 .product-banner {
        width: calc(50% - 8px);
    }
}

.product-grid__3 .product-banner__img {
    height: 494px;
}

@media screen and (max-width: 1300px) {
    .product-grid__3 .product-banner__img {
        height: 440px;
    }
}

@media screen and (max-width: 1200px) {
    .product-grid__3 .product-banner__img {
        height: 380px;
    }
}

@media screen and (max-width: 440px) {
    .product-grid__3 .product-banner__img {
        height: 260px;
    }
}

.product-grid__4 .product-item,
.product-grid__4 .product-banner {
    width: calc(25% - 32px);
}

@media screen and (max-width: 1350px) {
    .product-grid__4 .product-item,
    .product-grid__4 .product-banner {
        margin: 0 8px 32px 8px;
        width: calc(25% - 16px);
    }
}

@media screen and (max-width: 1024px) {
    .product-grid__4 .product-item,
    .product-grid__4 .product-banner {
        width: calc(33.33333% - 16px);
        margin: 0 8px 32px 8px;
    }
}

@media screen and (max-width: 767px) {
    .product-grid__4 .product-item,
    .product-grid__4 .product-banner {
        width: calc(50% - 16px);
    }
}

@media screen and (max-width: 576px) {
    .product-grid__4 .product-item,
    .product-grid__4 .product-banner {
        width: calc(50% - 8px);
        margin: 0 4px 32px 4px;
    }
}

.product-grid__4 .product-item__img,
.product-grid__4 .product-banner__img {
    height: 360px;
}

@media screen and (max-width: 1300px) {
    .product-grid__4 .product-item__img,
    .product-grid__4 .product-banner__img {
        height: 320px;
    }
}

@media screen and (max-width: 1200px) {
    .product-grid__4 .product-item__img,
    .product-grid__4 .product-banner__img {
        height: 280px;
    }
}

@media screen and (max-width: 1024px) {
    .product-grid__4 .product-item__img,
    .product-grid__4 .product-banner__img {
        height: 380px;
    }
}

@media screen and (max-width: 440px) {
    .product-grid__4 .product-item__img,
    .product-grid__4 .product-banner__img {
        height: 260px;
    }
}

.product-grid__4 .product-banner__full img {
    height: 100%;
}

@media screen and (max-width: 1440px) {
    .product-grid__4 .product-item__color {
        position: relative;
        top: initial;
        right: initial;
        margin-top: 4px;
    }
}

@media screen and (max-width: 1440px) {
    .product-grid__4 .product-item__color-item {
        margin-right: 6px;
        margin-left: 0;
    }
}

.product-list {
    display: flex;
    flex-wrap: wrap;
    margin-top: 30px;
}

@media screen and (max-width: 576px) {
    .product-list {
        margin-top: 15px;
    }
}

.product-item {
    position: relative;
    display: block;
    margin: 0 16px 32px 16px;
}

@media screen and (max-width: 576px) {
    .product-item {
        margin: 0 4px 32px 4px;
    }
}

.product-item:hover .product-item__favorite {
    display: block;
}

.product-item:hover .product-item__fast {
    display: flex;
}

.product-item__favorite {
    position: absolute;
    top: 24px;
    right: 24px;
    display: none;
    width: 24px;
    height: 24px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat;
    background-size: contain;
    z-index: 2;
}

@media screen and (max-width: 576px) {
    .product-item__favorite {
        top: 14px;
        right: 14px;
    }
}

.product-item__favorite._active {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat;
    background-size: contain;
}

.product-item__actions {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 16px;
    left: 16px;
    z-index: 1;
}

.product-item__actions__item {
    display: flex;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    font-size: 12px;
    line-height: 20px;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px;
}

.product-item__news {
    background: var(--color-blue-steel);
    color: var(--color-white);
}

@media screen and (max-width: 576px) {
    .product-item__actions__item {
        width: 28px;
        height: 28px;
        top: 8px;
        left: 8px;
        font-size: 9px;
    }
}

.product-item__discount {
    background: var(--color-yellow-pink);
    color: var(--color-white);
}

@media screen and (max-width: 576px) {
    .product-item__discount {
    }
}

.product-item__wrapper {
    position: relative;
}

.product-item__link {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
    text-align: center;
}

.product-item__img {
    width: 100%;
    height: auto;
    -o-object-fit: contain;
    object-fit: contain;
    display: block;
}

@media screen and (max-width: 576px) {
    .product-item__img {
        height: 260px;
    }
}

.product-item__body {
    margin-top: 16px;
    position: relative;
}

@media screen and (max-width: 576px) {
    .product-item__body {
        margin-top: 12px;
    }
}

.product-item__color {
    display: flex;
    align-items: center;
    margin-top: 4px;
    justify-content: center;
}

@media screen and (max-width: 1140px) {
    .product-item__color {
        position: relative;
        top: initial;
        right: initial;
        margin-top: 4px;
    }
}

.product-item__color-item {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 6px;
    border: 1px solid #bbbbbb;
}

@media screen and (max-width: 1140px) {
    .product-item__color-item {
        margin-right: 6px;
        margin-left: 0;
    }
}

.product-item__color-more {
    background: var(--color-light-periwinkle-crayola);
    display: flex;
    justify-content: center;
    align-items: center;
}

.product-item__prices {
    display: flex;
    align-items: center;
    margin-top: 4px;
    justify-content: center;
}

.product-item__new {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
    font-family: "RalewaySemiBold";
    margin-right: 8px;
}

.product-item__old {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blackberry);
    text-decoration: line-through;
}

.product-item__size {
    margin-top: 4px;
    font-size: 12px;
    line-height: 20px;
    color: var(--color-blackberry);
    text-transform: uppercase;
}

.product-item__fast {
    display: none;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 32px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    width: 185px;
    height: 32px;
    border-radius: 4px;
    padding: 5px 10px;
    background: rgba(255, 255, 255, 0.8);
    font-size: 14px;
    line-height: 22px;
    font-family: "RalewaySemiBold";
    color: var(--color-main);
}

.product-item__fast._inactive {
    display: none !important;
}

.product-item__fast svg {
    margin-right: 8px;
}

.product-banner {
    margin: 0 16px;
}

@media screen and (max-width: 576px) {
    .product-banner {
        margin: 0 4px;
    }
}

.product-banner__full {
    width: 100%;
    height: 140px;
    margin: 16px 16px 49px 16px;
    overflow: hidden;
}

@media screen and (max-width: 1024px) {
    .product-banner__full {
        margin: 0 4px 32px 4px;
        height: 200px;
    }
}

.product-banner__full .product-banner__img {
    height: 140px;
}

.product-banner__full .product-banner__img:last-child {
    display: none;
}

@media screen and (max-width: 576px) {
    .product-banner__full .product-banner__img:first-child {
        display: none;
    }

    .product-banner__full .product-banner__img:last-child {
        display: block;
        height: 200px;
        -o-object-fit: cover;
        object-fit: cover;
    }
}

.product-banner__fix {
    height: 92px;
}

.product-banner__img {
    display: block;
    width: 100%;
    max-height: 576px;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
}

@media screen and (max-width: 1600px) {
    .product-banner__img {
        height: 494px;
    }
}

@media screen and (max-width: 1300px) {
    .product-banner__img {
        height: 440px;
    }
}

@media screen and (max-width: 1200px) {
    .product-banner__img {
        height: 380px;
    }
}

@media screen and (max-width: 440px) {
    .product-banner__img {
        height: 260px;
    }
}

.product .curtain-wrap {
    width: 800px;
    padding-bottom: 100px;
}

@media screen and (max-width: 1024px) {
    .product .curtain-wrap {
        width: 100%;
    }
}

.product-wrap {
    display: flex;
    position: relative;
}

@media screen and (max-width: 767px) {
    .product-wrap {
        flex-direction: column;
    }
}

.product-wrap .detail-left {
    width: 66%;
}

.product-wrap .detail-right {
    width: 34%;
}

@media screen and (max-width: 767px) {
    .product-wrap .detail-right {
        margin: 0 auto;
    }
}

.product-wrap .detail-full img,
.product-wrap .detail-full .detail-full__video {
    width: 100%;
    max-width: 312px;
    height: 467px;
}

.product-wrap .detail-informations {
    margin-left: 0;
}

.product-wrap .detail-prices {
    flex-wrap: wrap;
}

.product-wrap .detail-full__prev {
    left: 0;
}

.product-wrap .detail-full__next {
    right: 0;
}

.product-more {
    position: fixed;
    bottom: 32px;
    right: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    background: var(--color-light-periwinkle-crayola);
    height: 48px;
    max-width: 672px;
    width: 100%;
    font-size: 16px;
    line-height: 24px;
    font-family: "RalewaySemiBold";
    color: var(--color-main);
    z-index: 10;
}

/* /CATALOG */
/* ASIDE */
.aside {
    max-width: 180px;
    width: 100%;
    align-self: baseline;
    flex-shrink: 0;
}

@media screen and (max-width: 1170px) {
    .aside {
        max-width: 180px;
    }
}

@media screen and (max-width: 1024px) {
    .aside {
        max-width: 100%;
        text-align: center;
    }
}

.aside-title {
    font-size: 24px;
    line-height: 32px;
    font-family: "RalewaySemiBold";
    color: var(--color-granite);
    margin-bottom: 4px;
    padding: 0 8px;
}

@media screen and (max-width: 576px) {
    .aside-title {
        font-size: 20px;
        line-height: 26px;
        margin-bottom: 8px;
    }
}

.aside-count {
    font-size: 12px;
    line-height: 20px;
    color: var(--color-blackberry);
    padding: 0 8px;
}

@media screen and (max-width: 1024px) {
    .aside-count {
        display: flex;
        justify-content: center;
        align-items: center;
    }
}

.aside-all {
    font-size: 16px;
    line-height: 24px;
    font-family: "RalewaySemiBold";
    color: var(--color-granite);
    display: block;
    padding: 4px 8px;
    background: var(--color-light-periwinkle-crayola);
    border-radius: 4px;
    margin: 24px 8px 32px 8px;
}

@media screen and (max-width: 1024px) {
    .aside-all {
        text-align: center;
        background: var(--color-white);
        border: 1px solid var(--color-pale-blue);
        margin: 20px 8px 8px 8px;
        padding: 7px 8px;
    }
}

.aside-all span {
    font-size: 12px;
    line-height: 20px;
    color: var(--color-gray-window);
    font-family: "RalewayRegular";
}

.aside-subtitle {
    font-size: 16px;
    line-height: 22px;
    font-weight: 500;
    color: var(--color-blackberry);
    text-transform: uppercase;
    padding: 0 8px;
}

@media screen and (max-width: 1024px) {
    .aside-subtitle {
        display: none;
    }
}

.aside-other .aside-mobile {
    height: calc(100vh - 60px);
}

.aside-other .aside-mobile .curtain-wrap {
    height: 100%;
    padding-bottom: 36px;
}

.aside-other .accordion {
    margin: 16px 8px 32px 8px;
}

@media screen and (max-width: 1024px) {
    .aside-other .accordion {
        display: none;
    }
}

.aside-other .aside-subtitle {
    padding: 0 16px;
}

.aside-other .accordion-title span,
.aside-other .accordion-link span {
    font-size: 12px;
    line-height: 20px;
    color: var(--color-gray-window);
    font-family: "RalewayRegular";
}

/* /ASIDE */
/* ACCORDION */
.accordion {
    margin: 32px 0;
}

@media screen and (max-width: 1024px) {
    .accordion {
        margin-top: 0;
        margin-bottom: 8px;
    }
}

.accordion-block {
    margin-bottom: 8px;
}

.accordion-block._active .accordion-arrow {
    -webkit-transform: scaleY(-1);
    transform: scaleY(-1);
    margin-right: 4px;
}

.accordion-block._active .accordion-body {
    display: block;
}

@media screen and (max-width: 1024px) {
    .accordion-block {
        display: none;
    }

    .accordion-block:first-child {
        display: block;
    }
}

.accordion-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 4px;
}

@media screen and (max-width: 1024px) {
    .accordion-top {
        display: none;
    }
}

.accordion-top._active {
    background: var(--color-light-periwinkle-crayola);
}

.accordion-title {
    padding: 4px 8px;
    font-size: 16px;
    line-height: 22px;
}

.accordion-down {
    font-size: 16px;
    line-height: 24px;
    font-family: "RalewaySemiBold";
    color: var(--color-granite);
}

.accordion-arrow {
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
    cursor: pointer;
    transition: all .3s linear;
}

.accordion-body {
    display: none;
}

@media screen and (max-width: 1024px) {
    .accordion-body {
        display: block;
        overflow-x: auto;
    }
}

.accordion-list {
    margin-top: 13px;
}

@media screen and (max-width: 1024px) {
    .accordion-list {
        display: flex;
        align-items: center;
        width: 1000px;
        margin-top: 6px;
    }
}

.accordion-item {
    margin-bottom: 18px;
    position: relative;
    border-radius: 4px;
}

@media screen and (max-width: 1024px) {
    .accordion-item {
        margin-bottom: 0;
    }

    .accordion-item:before {
        content: '•';
    }

    .accordion-item:first-child:before {
        display: none;
    }
}

.accordion-item._active {
    background: var(--color-light-periwinkle-crayola);
}

.accordion-item:last-child {
    margin-bottom: 0;
}

.accordion-link {
    font-size: 16px;
    line-height: 22px;
    color: var(--color-granite);
    padding: 5px 8px;
    display: block;
}

/* /ACCORDION */
/* PAGINATIONS */
.paginations-more {
    display: block;
    width: 100%;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: var(--color-main);
    padding: 12px 0;
    border: 1px solid var(--color-pale-blue);
    border-radius: 4px;
    margin-bottom: 15px;
}

@media screen and (max-width: 576px) {
    .paginations-more {
        margin-bottom: 20px;
    }
}

.paginations {
    margin-top: 15px;
    margin-bottom: 15px;
}

.paginations-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
}

.paginations-prev, .paginations-next {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-gray-blue);
    border: 1px solid var(--color-pale-blue);
    border-radius: 4px;
    padding: 4px 8px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
}

@media screen and (max-width: 767px) {
    .paginations-prev {
        display: none;
    }
}

.paginations-prev svg {
    margin-right: 12px;
}

@media screen and (max-width: 767px) {
    .paginations-next {
        display: none;
    }
}

.paginations-next svg {
    margin-left: 12px;
}

.paginations-list {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
}

@media screen and (max-width: 767px) {
    .paginations-list {
        width: 100%;
    }
}

.paginations-item {
    margin-right: 8px;
}

.paginations-item:last-child {
    margin-right: 0;
}

.paginations-item__ellipsis .paginations-link {
    width: 20px;
    border: none;
}

.paginations-link {
    font-size: 16px;
    line-height: 25px;
    color: var(--color-gray-blue);
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid var(--color-pale-blue);
    width: 40px;
    height: 40px;
}

.paginations-link._active {
    color: var(--color-white);
    border: 1px solid var(--color-main);
    background: var(--color-main);
}

/* /PAGINATIONS */
/* LIKED */
.liked {
    position: relative;
    margin: 144px 0 120px 0;
    overflow: hidden;
}

@media screen and (max-width: 1024px) {
    .liked {
        margin: 63px 0;
    }
}

@media screen and (max-width: 576px) {
    .liked {
        margin: 50px 0;
    }
}

.liked .product-item__favorite {
    top: 9px;
    right: 7px;
}

.liked .container {
    overflow: hidden;
}

/* /LIKED */
/* SLIDER */
.slider {
    position: relative;
}

.slider._noslider .slider-container {
    justify-content: center;
}

.slider._noslider .slider-prev,
.slider._noslider .slider-next {
    display: none;
}

.slider-title {
    font-size: 32px;
    line-height: 40px;
    font-family: "RalewaySemiBold";
    color: var(--color-granite);
    margin-bottom: 32px;
    text-align: center;
}

@media screen and (max-width: 1024px) {
    .slider-title {
        font-size: 24px;
        line-height: 32px;
        margin-bottom: 24px;
    }
}

.slider-prev {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    position: absolute;
    top: 50%;
    left: -20px;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    width: 48px;
    height: 48px;
    border-radius: 50%;
    overflow: hidden;
    background: var(--color-white);
    box-shadow: 0px 1px 4px rgba(8, 11, 48, 0.2);
    z-index: 2;
}

.slider-prev._disabled {
    opacity: .5;
    cursor: default;
}

@media screen and (max-width: 1024px) {
    .slider-prev {
        display: none;
    }
}

.slider-next {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    position: absolute;
    top: 50%;
    right: -20px;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    width: 48px;
    height: 48px;
    border-radius: 50%;
    overflow: hidden;
    background: var(--color-white);
    box-shadow: 0px 1px 4px rgba(8, 11, 48, 0.2);
    z-index: 2;
}

.slider-next._disabled {
    opacity: .5;
    cursor: default;
}

@media screen and (max-width: 1024px) {
    .slider-next {
        display: none;
    }
}

.slider-wrap {
    overflow: hidden;
    margin: 0 -16px;
    padding: 0 16px;
}

.slider .product-item {
    margin: 0;
}

@media screen and (max-width: 576px) {
    .slider .product-item {
        width: 180px;
        display: block;
    }
}

/* /SLIDER */
/* DETAIL PAGE PRODUCT */


/* /DETAIL PAGE PRODUCT */
/* DETAIL CART */
.cart .success-images {
    margin-top: 48px;
}

@media screen and (max-width: 1024px) {
    .cart .success-images {
        margin-top: 36px;
    }

    .cart .success-images__title {
        font-size: 18px;
        line-height: 24px;
    }
}

.cart .success-images:last-child {
    margin-top: 40px;
}

.cart-wrap {
    margin-top: 24px;
}

@media screen and (max-width: 1024px) {
    .cart-wrap {
        margin-top: 31px;
    }
}

.cart-wrap__bottom {
    display: flex;
    align-items: center;
    margin-top: 20px;
}

@media screen and (max-width: 576px) {
    .cart-wrap__bottom {
        flex-direction: column;
        margin-top: 15px;
    }
}

.cart-wrap__btn {
    border-radius: 4px;
    background: var(--color-main);
    height: 48px;
    border: none;
    font-size: 16px;
    line-height: 24px;
    font-family: "RalewaySemiBold";
    color: var(--color-white);
    padding: 12px 20px;
    margin-right: 12px;
}

@media screen and (max-width: 576px) {
    .cart-wrap__btn {
        width: 100%;
        height: 40px;
        padding: 8px 20px;
        text-align: center;
        margin-right: 0;
        margin-bottom: 12px;
    }
}

.cart-wrap__link {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-main);
    font-family: "RalewaySemiBold";
    border: 1px solid var(--color-pale-blue);
    border-radius: 4px;
    height: 48px;
    padding: 12px 20px;
    display: block;
}

@media screen and (max-width: 576px) {
    .cart-wrap__link {
        width: 100%;
        height: 40px;
        padding: 8px 20px;
        text-align: center;
        margin-right: 0;
        margin-bottom: 12px;
    }
}

.cart-item {
    display: flex;
    position: relative;
    margin-bottom: 32px;
}

.cart-item__img {
    width: 80px;
    height: 120px;
    -o-object-fit: cover;
    object-fit: cover;
    display: block;
}

.cart-item__body {
    margin-left: 16px;
}

.cart-item__title {
    font-size: 14px;
    line-height: 18px;
    color: var(--color-granite);
    margin-bottom: 4px;
}

.cart-calc {
    width: 112px;
}

.cart-total {
    font-size: 18px;
    line-height: 28px;
    color: var(--color-granite);
    display: flex;
    align-items: center;
}

.cart-total__basket {
    position: relative;
    margin-right: 8px;
    width: 24px;
    height: 24px;
}

.cart-total__count {
    position: absolute;
    top: 4px;
    right: -4px;
    width: auto;
    height: 16px;
    border-radius: 50%;
    background: var(--color-yellow-pink);
    font-size: 10px;
    line-height: 16px;
    color: var(--color-white);
    padding: 0 4px;
}

.cart-total span {
    font-family: "RalewaySemiBold";
}

/* /DETAIL CART */
/* DETAIL SLIDER COMPLEMENT */
.complement {
    margin: 80px 0;
    overflow: hidden;
}

@media screen and (max-width: 1024px) {
    .complement {
        margin: 50px 0;
    }
}

.complement .container {
    overflow: hidden;
}

.complement-title {
    font-size: 24px;
    line-height: 32px;
}

/* /DETAIL SLIDER COMPLEMENT */
/* BLOCK AVAILABILITY */
.availability .detail-color:after {
    right: 9px;
}

.availability .detail-size:after {
    right: 9px;
}

.availability-wrap {
    margin-top: 32px;
}

@media screen and (max-width: 1024px) {
    .availability-wrap {
        margin-top: 25px;
    }
}

.availability-city {
    position: relative;
    cursor: pointer;
}

.availability-city:after {
    position: absolute;
    content: '';
    top: 50%;
    right: 16px;
    width: 24px;
    height: 24px;
    -webkit-transform: translateY(-50%) scale(1);
    transform: translateY(-50%) scale(1);
    background: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat;
    background-size: contain;
}

.availability-city._active:after {
    -webkit-transform: translateY(-50%) scale(-1);
    transform: translateY(-50%) scale(-1);
}

.availability-city._active .detail-color__body {
    display: block;
    opacity: 1;
    visibility: visible;
}

.availability-city .detail-size__top {
    height: 40px;
    background: var(--color-light-periwinkle-crayola);
}

.availability-options {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
}

@media screen and (max-width: 576px) {
    .availability-options {
        flex-direction: column;
    }
}

.availability-options .detail-color,
.availability-options .detail-size {
    height: 56px;
    width: calc(50% - 8px);
    margin: 0;
}

@media screen and (max-width: 576px) {
    .availability-options .detail-color,
    .availability-options .detail-size {
        width: 100%;
    }
}

@media screen and (max-width: 576px) {
    .availability-options .detail-color {
        margin-bottom: 16px;
    }
}

.availability-options .detail-color__top-img {
    height: 54px;
}

.availability-list {
    margin-top: 32px;
}

.availability-item {
    padding: 15px 12px;
    border-top: 1px solid var(--color-light-periwinkle-crayola);
    border-left: 1px solid var(--color-light-periwinkle-crayola);
    border-right: 1px solid var(--color-light-periwinkle-crayola);
    cursor: pointer;
}

.availability-item._active .availability-item__body {
    display: block;
    opacity: 1;
    visibility: visible;
}

.availability-item:first-child {
    border-radius: 4px 4px 0px 0px;
}

.availability-item:last-child {
    border-radius: 0px 0px 4px 4px;
    border-bottom: 1px solid var(--color-light-periwinkle-crayola);
}

.availability-item__title {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
}

.availability-item__body {
    display: none;
    opacity: 0;
    visibility: hidden;
    margin: 16px -4px 0 -4px;
}

.availability-item__body-title {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
    font-family: "RalewaySemiBold";
    margin: 8px 0 16px 4px;
}

@media screen and (max-width: 1024px) {
    .availability-item__body-title {
        margin: 8px 0 11px 4px;
    }
}

.availability-item__body-title span {
    font-family: "RalewayRegular";
    color: var(--color-blackberry);
}

.availability-item__body-wrap {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.availability-item__size {
    font-size: 16px;
    line-height: 22px;
    color: var(--color-granite);
    font-family: "RalewayMedium";
    width: 108px;
    height: 48px;
    background: var(--color-white);
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 4px;
    cursor: pointer;
    border: 1px solid var(--color-pale-blue);
}

@media screen and (max-width: 1024px) {
    .availability-item__size {
        width: 92px;
    }
}

.availability-item__size._active {
    background: var(--color-periwinkle-crayola);
    border: 1px solid var(--color-main);
}

.availability-item__size._not {
    color: var(--color-gray-window);
    cursor: default;
}

.availability-item__reservation {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-white);
    font-family: "RalewaySemiBold";
    background: var(--color-main);
    padding: 8px 16px;
    border-radius: 4px;
    display: inline-block;
    margin-top: 16px;
    margin-left: 4px;
}

/* /BLOCK AVAILABILITY */
/* BLOCK RESERVATION */
.reservation {
    z-index: 12;
}

.reservation-top {
    display: flex;
    padding-bottom: 24px;
    border-bottom: 1px solid var(--color-light-periwinkle-crayola);
}

@media screen and (max-width: 767px) {
    .reservation-top {
        flex-direction: column;
        padding-bottom: 29px;
    }
}

.reservation-top__title {
    font-size: 20px;
    line-height: 26px;
    color: var(--color-granite);
    margin-bottom: 8px;
}

.reservation-top__address {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
    margin-bottom: 8px;
}

.reservation-top__link {
    display: inline-block;
    font-size: 16px;
    line-height: 25px;
    color: var(--color-blue-steel);
}

.reservation-shop {
    margin-right: 24px;
    max-width: 253px;
    width: 100%;
}

@media screen and (max-width: 767px) {
    .reservation-shop {
        margin-bottom: 32px;
        max-width: 100%;
    }
}

.reservation-product__wrap {
    display: flex;
}

.reservation-product__img {
    width: 120px;
    height: 180px;
    -o-object-fit: cover;
    object-fit: cover;
    display: block;
}

.reservation-product__info {
    margin-left: 16px;
}

.reservation-product__title {
    font-size: 20px;
    line-height: 26px;
    color: var(--color-granite);
    margin-bottom: 8px;
}

.reservation-product__text {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blackberry);
}

.reservation-product__price-new {
    margin-top: 8px;
    font-size: 16px;
    line-height: 24px;
    font-family: "RalewaySemiBold";
    color: var(--color-granite);
}

.reservation-product__price-old {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blackberry);
    text-decoration: line-through;
}

.reservation-form {
    margin-top: 24px;
}

.reservation-form__text {
    font-size: 16px;
    line-height: 22px;
    color: var(--color-granite);
    margin-bottom: 8px;
}

.reservation-form__input {
    background: var(--color-light-periwinkle-crayola);
    height: 40px;
    max-width: 320px;
    width: 100%;
    margin-bottom: 16px;
    display: block;
    border-radius: 4px;
    border: none;
    padding: 8px 12px;
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blackberry);
}

.reservation-form__input:focus {
    outline: none;
}

.reservation-form__input:active {
    outline: none;
}

.reservation-form__label {
    position: relative;
    margin-top: 25px;
    display: block;
}

.reservation-form__check {
    opacity: 0;
    visibility: hidden;
    z-index: -1;
    position: absolute;
}

.reservation-form__check:checked + .reservation-form__span:after {
    position: absolute;
    content: '';
    left: 0;
    top: 1px;
    width: 20px;
    height: 20px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat var(--color-main);
    background-size: contain;
    border-radius: 3px;
}

.reservation-form__span {
    position: relative;
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
    padding-left: 30px;
}

.reservation-form__span:before {
    position: absolute;
    content: '';
    left: 0;
    top: 0;
    width: 20px;
    height: 20px;
    border-radius: 3px;
    background: var(--color-light-periwinkle-crayola);
}

.reservation-form__btn {
    font-size: 18px;
    line-height: 28px;
    color: var(--color-white);
    display: flex;
    justify-content: center;
    align-items: center;
    height: 56px;
    border-radius: 4px;
    background: var(--color-main);
    width: 240px;
    margin: 24px 0;
    border: none;
}

.reservation-form__info {
    font-size: 14px;
    line-height: 20px;
    color: var(--color-blackberry);
}

.reservation-form__info a {
    text-decoration: underline;
    font-size: 14px;
    line-height: 20px;
    color: var(--color-blackberry);
}

/* /BLOCK RESERVATION */
/* BLOCK SUCCESS */
.success-wrap {
    margin-top: 25px;
}

.success .curtain-back {
    border: none;
    width: 24px;
    height: 24px;
    margin-right: 12px;
}

.success-text {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
    margin-top: 24px;
    margin-bottom: 32px;
}

.success-images {
    margin-top: 32px;
}

.success-images__wrap {
    overflow-x: auto;
}

.success-images__title {
    font-size: 18px;
    line-height: 24px;
    font-family: "RalewaySemiBold";
    color: var(--color-granite);
    margin-bottom: 16px;
}

@media screen and (max-width: 1024px) {
    .success-images__title {
        font-size: 24px;
        line-height: 32px;
    }
}

.success-images__list {
    display: flex;
}

@media screen and (max-width: 767px) {
    .success-images__list {
        width: 650px;
        padding-bottom: 15px;
    }
}

.success-images__item {
    margin-right: 24px;
    display: flex;
}

@media screen and (max-width: 1024px) {
    .success-images__item {
        flex-direction: column;
    }
}

.success-images__item:last-child {
    margin-right: 0;
}

.success-images__img {
    width: 80px;
    height: 120px;
    -o-object-fit: cover;
    object-fit: cover;
    display: block;
    margin-right: 16px;
}

@media screen and (max-width: 1024px) {
    .success-images__img {
        width: 180px;
        height: 272px;
        margin-bottom: 16px;
    }
}

.success-images__name {
    font-size: 14px;
    line-height: 18px;
    color: var(--color-granite);
    margin-bottom: 4px;
}

@media screen and (max-width: 1024px) {
    .success-images__name {
        font-size: 16px;
        line-height: 22px;
    }
}

@media screen and (max-width: 1024px) {
    .success-images__price {
        display: flex;
    }
}

.success-images__price-new {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
    font-family: "RalewaySemiBold";
}

@media screen and (max-width: 1024px) {
    .success-images__price-new {
        margin-right: 12px;
    }
}

.success-images__price-old {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blackberry);
    text-decoration: line-through;
}

/* /BLOCK SUCCESS */
/* BLOCK IMAGES */
.images .curtain-title {
    display: flex;
    align-items: center;
}

.images .curtain-title span {
    font-size: 18px;
    line-height: 28px;
    color: var(--color-blackberry);
    font-family: "RalewayRegular";
    display: inline-block;
    margin-left: 8px;
}

.images-wrap {
    display: flex;
    flex-wrap: wrap;
    margin: 32px -16px 0 -16px;
}

@media screen and (max-width: 1024px) {
    .images-wrap {
        margin: 24px -8px 0 -8px;
    }
}

@media screen and (max-width: 576px) {
    .images-wrap {
        margin: 24px -16px 0 -16px;
    }
}

.images-link {
    display: block;
}

.images-img {
    width: 178px;
    height: 268px;
    -o-object-fit: cover;
    object-fit: cover;
    display: block;
    margin: 0 16px 32px 16px;
}

@media screen and (max-width: 1024px) {
    .images-img {
        width: 168px;
        height: 252px;
        margin: 0 4px 8px 4px;
    }
}

/* /BLOCK IMAGES */
/* TABLE SIEZ */
.size-wrap {
    width: 1018px;
}

@media screen and (max-width: 1024px) {
    .size-wrap {
        width: 100%;
    }
}

.size-wrap__scroll {
    overflow-y: auto;
}

.size-wrap__block {
    width: 890px;
}

.size-img {
    width: 100%;
    height: 750px;
    -o-object-fit: contain;
    object-fit: contain;
    display: block;
    margin-top: 34px;
}

/* /TABLE SIEZ */
/* BLOCK REVIEWS / REVIEWS-ADD */
.reviews .curtain-title span {
    font-size: 14px;
    line-height: 22px;
    font-family: "RalewaySemiBold";
    color: #6F707A;
}

.reviews .curtain-title svg {
    margin: 0 6px;
    width: 18px;
    height: 18px;
}

.reviews .reviews-filter__label {
    margin-left: 10px;
}

.reviews .reviews-filter__span {
    font-size: 14px;
    line-height: 20px;
    padding-left: 44px;
}

.reviews-top {
    margin-top: 24px;
    display: flex;
    align-items: center;
}

@media screen and (max-width: 576px) {
    .reviews-top {
        flex-direction: column;
        align-items: flex-start;
    }
}

.reviews-top__add {
    font-size: 14px;
    line-height: 22px;
    padding: 4px 12px;
    margin-right: 24px;
    height: 32px;
    display: block;
}

.reviews-top__bonus {
    font-size: 14px;
    line-height: 20px;
    color: var(--color-blackberry);
    display: flex;
    align-items: center;
}

@media screen and (max-width: 576px) {
    .reviews-top__bonus {
        margin-top: 10px;
    }
}

.reviews-top__bonus svg {
    width: 20px;
    height: 20px;
}

.reviews-filter {
    display: flex;
    align-items: center;
    margin-top: 40px;
    margin-bottom: 24px;
}

@media screen and (max-width: 576px) {
    .reviews-filter {
        flex-wrap: wrap;
        margin-top: 34px;
    }
}

@media screen and (max-width: 380px) {
    .reviews-filter .catalog-filter__item {
        margin-right: 4px;
    }
}

@media screen and (max-width: 1024px) {
    .reviews-filter .catalog-filter__item .catalog-filter__title {
        border: 1px solid var(--color-light-periwinkle-crayola);
    }
}

.reviews-filter__label {
    position: relative;
    display: block;
    margin-bottom: 1px;
}

@media screen and (max-width: 576px) {
    .reviews-filter__label {
        display: block;
        width: 100%;
        margin-top: 16px;
    }
}

.reviews-filter__input {
    opacity: 0;
    visibility: hidden;
    z-index: -1;
    position: absolute;
}

.reviews-filter__input:checked + .reviews-filter__span:after {
    left: 20px;
    background: var(--color-main);
}

.reviews-filter__span {
    position: relative;
    padding-left: 53px;
    display: block;
}

.reviews-filter__span:before {
    position: absolute;
    content: '';
    top: 3px;
    left: 0;
    width: 34px;
    height: 14px;
    border-radius: 10px;
    background: var(--color-light-periwinkle-crayola);
}

.reviews-filter__span:after {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    background: var(--color-white);
    border-radius: 50%;
    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.15), 0px 1px 1px rgba(0, 0, 0, 0.16);
    transition: left .2s linear, background .2s linear;
}

.reviews-list {
    height: calc(100vh - 300px);
    overflow-y: auto;
}

.reviews-item {
    padding-bottom: 24px;
    margin-bottom: 24px;
    border-bottom: 1px solid var(--color-light-periwinkle-crayola);
}

.reviews-item:last-child {
    margin-bottom: 0;
    border-bottom: none;
}

.reviews-item__top {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
}

@media screen and (max-width: 380px) {
    .reviews-item__top {
        flex-wrap: wrap;
    }
}

.reviews-item__name {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
    font-family: "RalewaySemiBold";
    display: flex;
    align-items: center;
}

.reviews-item__name svg {
    width: 24px;
    height: 24px;
    margin-right: 4px;
}

.reviews-item__date {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
    position: relative;
    margin-left: 4px;
}

.reviews-item__date:before {
    content: '•';
    margin-right: 4px;
}

.reviews-item__status {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
    margin-left: 12px;
}

.reviews-item__status svg {
    width: 12px;
    height: 12px;
    margin-right: 4px;
}

.reviews-item__info {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
}

@media screen and (max-width: 440px) {
    .reviews-item__info {
        flex-direction: column;
        align-items: flex-start;
    }
}

.reviews-item__rating {
    display: flex;
    align-items: center;
    margin-right: 4px;
}

.reviews-item__rating svg {
    width: 16px;
    height: 16px;
}

.reviews-item__term {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
}

@media screen and (max-width: 576px) {
    .reviews-item__term {
        margin-top: 8px;
    }
}

.reviews-item__term span {
    color: var(--color-blackberry);
}

.reviews-item__plus {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
    margin-bottom: 4px;
}

.reviews-item__plus span {
    color: var(--color-blackberry);
}

.reviews-item__minus {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
    margin-bottom: 3px;
}

.reviews-item__minus span {
    color: var(--color-blackberry);
}

.reviews-item__text {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
}

.reviews-more {
    margin-top: 24px;
    display: block;
    width: 100%;
    font-size: 16px;
    line-height: 24px;
    font-family: "RalewaySemiBold";
    color: var(--color-main);
    text-align: center;
    padding: 8px 0;
    border: 1px solid var(--color-pale-blue);
    border-radius: 4px;
}

.reviews-empty {
    margin-top: 24px;
    font-size: 18px;
    line-height: 28px;
    color: var(--color-blackberry);
}

.reviews-info {
    font-size: 14px;
    line-height: 20px;
    color: var(--color-granite);
    margin-top: 27px;
    margin-bottom: 36px;
}

@media screen and (max-width: 1024px) {
    .reviews-info {
        margin-top: 16px;
    }
}

.reviews-info__list {
    padding: 0;
    margin: 0;
}

.reviews-info__item {
    list-style-type: none;
    position: relative;
}

.reviews-info__item:before {
    content: '—';
    margin-right: 4px;
}

.reviews-rating__wrap {
    margin-bottom: 15px;
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
    display: flex;
    align-items: center;
}

.reviews-rating__wrap #ratingbar {
    width: 124px;
    height: 25px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) repeat;
    background-size: 25px auto;
}

.reviews-rating__wrap #ratingbar::-webkit-progress-bar {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) repeat;
    background-size: 25px auto;
}

.reviews-rating__wrap #ratingbar::-webkit-progress-value {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) repeat;
    background-size: contain;
}

.reviews-form__wrap {
    display: flex;
    justify-content: space-between;
}

@media screen and (max-width: 576px) {
    .reviews-form__wrap {
        flex-direction: column;
        align-items: flex-start;
    }
}

.reviews-form__wrap .reviews-form__label {
    width: calc(50% - 8px);
}

@media screen and (max-width: 576px) {
    .reviews-form__wrap .reviews-form__label {
        width: 100%;
    }
}

.reviews-form__wrap .reviews-form__textarea {
    height: 144px;
}

.reviews-form__label {
    display: block;
    width: 100%;
    margin-bottom: 16px;
    position: relative;
}

.reviews-form__label._error .reviews-form__input {
    border: 1px solid var(--color-error);
}

.reviews-form__label._error .reviews-form__textarea {
    border: 1px solid var(--color-error);
}

.reviews-form__title {
    font-size: 16px;
    line-height: 22px;
    color: var(--color-granite);
    margin-bottom: 8px;
}

.reviews-form__input {
    height: 40px;
    width: 100%;
    display: block;
    background: var(--color-light-periwinkle-crayola);
    border-radius: 4px;
    border: none;
    padding: 8px 12px;
    font-size: 16px;
    line-height: 22px;
    color: var(--color-blackberry);
}

.reviews-form__input:focus {
    outline: none;
}

.reviews-form__input:active {
    outline: none;
}

.reviews-form__textarea {
    width: 100%;
    display: block;
    background: var(--color-light-periwinkle-crayola);
    border-radius: 4px;
    height: 96px;
    border: none;
    padding: 8px 12px;
    font-size: 16px;
    line-height: 22px;
    color: var(--color-blackberry);
}

.reviews-form__textarea:focus {
    outline: none;
}

.reviews-form__textarea:active {
    outline: none;
}

.reviews-form__count {
    position: absolute;
    top: 3px;
    right: 0;
    font-size: 12px;
    line-height: 16px;
    color: var(--color-blackberry);
}

.reviews-form .catalog-filter__title {
    border: none;
    background: var(--color-light-periwinkle-crayola);
    width: 290px;
    height: 40px;
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
}

@media screen and (max-width: 576px) {
    .reviews-form .catalog-filter__title {
        width: 100%;
    }
}

.reviews-form .catalog-filter__title:after {
    position: absolute;
    content: '';
    top: 50%;
    right: 16px;
    width: 24px;
    height: 24px;
    -webkit-transform: translateY(-50%) scale(1);
    transform: translateY(-50%) scale(1);
    background: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat;
    background-size: contain;
}

.reviews-form__btn {
    border: none;
    height: 56px;
    width: 240px;
    font-size: 18px;
    line-height: 24px;
    color: var(--color-white);
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 24px 0;
}

@media screen and (max-width: 1024px) {
    .reviews-form__btn {
        width: 100%;
    }
}

.reviews-form__btn:focus {
    outline: none;
}

.reviews-form__btn:active {
    outline: none;
}

.reviews-add .curtain-title span {
    margin-right: 16px;
}

@media screen and (max-width: 1024px) {
    .reviews-add .curtain-title span {
        margin-right: 0;
    }
}

.reviews-add .reviews-filter__label {
    margin-top: 26px;
}

.reviews-send .comment-send__check {
    margin-right: 12px;
}

.reviews-send__check {
    margin-right: 12px;
}

@media screen and (max-width: 1024px) {
    .reviews-send__check {
        width: 20px;
        height: 20px;
    }
}

.reviews-send__info {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
    margin: 33px 0 32px 0;
}

@media screen and (max-width: 1024px) {
    .reviews-send__info {
        margin: 25px 0 32px 0;
    }
}

.reviews-send__back {
    margin-right: 38px;
}

@media screen and (max-width: 1024px) {
    .reviews-send__back {
        margin-right: 16px;
    }
}

.reviews-all {
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 24px;
    color: var(--color-main);
}

.reviews-all svg {
    margin-left: 8px;
}

/* /BLOCK REVIEWS */
/* QUESTIONS */
.questions .curtain-title span {
    margin-left: 12px;
}

.questions .reviews-list {
    margin-top: 32px;
    height: calc(100vh - 160px);
}

.questions .reviews-item {
    border-bottom: none;
    margin-bottom: 16px;
}

.questions .reviews-item__top {
    margin-bottom: 8px;
}

.questions-answer {
    padding: 8px;
    border-radius: 4px;
    background: var(--color-periwinkle-crayola);
    margin-top: 16px;
}

.questions-answer__name svg {
    width: 18px;
    height: 18px;
    margin-right: 8px;
    margin-left: 4px;
}

.questions-add .curtain-back {
    margin-right: 18px;
}

@media screen and (max-width: 1024px) {
    .questions-add .curtain-back {
        margin-right: 0;
    }
}

.questions-add .reviews-filter__label {
    margin-top: 24px;
}

@media screen and (max-width: 1024px) {
    .questions-add .reviews-filter__label {
        margin-top: 18px;
    }
}

@media screen and (max-width: 1024px) {
    .questions-add .reviews-form__btn {
        margin: 19px 0 24px 0;
    }
}

.questions-add__form {
    margin-top: 36px;
}

@media screen and (max-width: 1024px) {
    .questions-add__form {
        margin-top: 18px;
    }
}

.questions-send .reviews-send__info {
    margin: 29px 0 32px 0;
}

/* /QUESTIONS */
/* MODAL SLIDER */
.modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    opacity: 0;
    visibility: hidden;
    overflow: hidden;
    background: var(--color-white);
    z-index: 50;
}

.modal._active {
    opacity: 1;
    visibility: visible;
}

.modal-wrap {
    position: relative;
}

.modal-close {
    position: fixed;
    top: 24px;
    right: 24px;
    width: 64px;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background: var(--color-white);
    cursor: pointer;
    z-index: 51;
}

@media screen and (max-width: 767px) {
    .modal-close {
        width: 32px;
        height: 32px;
        top: 16px;
        right: 16px;
    }
}

.modal-slider,
.modal .detail-slider {
    overflow: hidden;
}

.modal-over,
.modal .detail-over {
    position: fixed;
    top: 50%;
    left: 200px;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    z-index: 51;
}

@media screen and (max-width: 1024px) {
    .modal-over,
    .modal .detail-over {
        top: initial;
        left: 50%;
        bottom: 24px;
        -webkit-transform: translate(-50%, 0);
        transform: translate(-50%, 0);
    }
}

.modal-full,
.modal .detail-full {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow-y: auto;
}

@media screen and (max-width: 480px) {
    .modal-full a._active,
    .modal .detail-full a._active {
        display: flex;
        align-items: center;
        height: 100%;
    }
}

.modal-full img,
.modal .detail-full img {
    width: 100vw;
    height: auto;
    max-width: 100%;
}

.modal-full .detail-full__video,
.modal .detail-full .detail-full__video {
    width: 100vw;
    height: auto;
    max-width: 100%;
}

.modal-full__prev,
.modal-full .detail-full__prev,
.modal .detail-full__prev,
.modal .detail-full .detail-full__prev {
    position: fixed;
    top: 50%;
    left: 24px;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    background: var(--color-white);
    border-radius: 50%;
    width: 64px;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    z-index: 2;
}

@media screen and (max-width: 767px) {
    .modal-full__prev,
    .modal-full .detail-full__prev,
    .modal .detail-full__prev,
    .modal .detail-full .detail-full__prev {
        display: none;
    }
}

.modal-full__prev svg,
.modal-full .detail-full__prev svg,
.modal .detail-full__prev svg,
.modal .detail-full .detail-full__prev svg {
    width: 24px;
    height: 24px;
}

.modal-full__prev svg path,
.modal-full .detail-full__prev svg path,
.modal .detail-full__prev svg path,
.modal .detail-full .detail-full__prev svg path {
    fill: var(--color-blackberry);
}

.modal-full__next,
.modal-full .detail-full__next,
.modal .detail-full__next,
.modal .detail-full .detail-full__next {
    position: fixed;
    top: 50%;
    right: 24px;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    background: var(--color-white);
    border-radius: 50%;
    width: 64px;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    z-index: 2;
}

@media screen and (max-width: 767px) {
    .modal-full__next,
    .modal-full .detail-full__next,
    .modal .detail-full__next,
    .modal .detail-full .detail-full__next {
        display: none;
    }
}

.modal-full__next svg,
.modal-full .detail-full__next svg,
.modal .detail-full__next svg,
.modal .detail-full .detail-full__next svg {
    width: 24px;
    height: 24px;
}

.modal-full__next svg path,
.modal-full .detail-full__next svg path,
.modal .detail-full__next svg path,
.modal .detail-full .detail-full__next svg path {
    fill: var(--color-blackberry);
}

/* /MODAL SLIDER */
/* INFO */
.info {
    margin: 80px 0;
    background: var(--color-periwinkle-crayola);
    overflow-x: auto;
}

@media screen and (max-width: 1024px) {
    .info {
        margin: 54px 0;
    }
}

.info-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;
}

@media screen and (max-width: 1024px) {
    .info-wrap {
        justify-content: flex-start;
        margin: 0 24px;
        width: 1000px;
    }
}

.info-link {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 60px;
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
}

@media screen and (max-width: 1024px) {
    .info-link {
        margin-right: 40px;
    }
}

.info-link svg:first-child {
    margin-right: 10px;
}

.info-link svg:last-child {
    margin-left: 10px;
}

.info-link:last-child {
    margin-right: 0;
}

/* /INFO */
/* BASKET */
.basket {
    margin-top: 50px;
}

@media screen and (max-width: 1024px) {
    .basket {
        margin-top: 22px;
    }
}

.basket .container {
    max-width: 1200px;
}

.basket-h1 {
    font-size: 32px;
    line-height: 40px;
    font-family: "RalewaySemiBold";
    color: var(--color-granite);
    margin-bottom: 16px;
}

@media screen and (max-width: 1024px) {
    .basket-h1 {
        font-size: 20px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }
}

@media screen and (max-width: 576px) {
    .basket-empty {
        text-align: center;
    }
}

.basket-empty__text {
    font-size: 18px;
    line-height: 28px;
    color: var(--color-blackberry);
    margin-bottom: 16px;
}

.basket-empty__list {
    display: flex;
    padding: 0;
    margin: 0;
}

@media screen and (max-width: 576px) {
    .basket-empty__list {
        flex-direction: column;
        align-items: center;
    }
}

.basket-empty__item {
    margin-right: 24px;
}

@media screen and (max-width: 576px) {
    .basket-empty__item {
        margin-right: 0;
    }
}

.basket-empty__link {
    font-size: 18px;
    line-height: 28px;
    color: var(--color-main);
}

.basket-wrap {
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
}

@media screen and (max-width: 1024px) {
    .basket-wrap {
        flex-direction: column-reverse;
        max-width: 500px;
        margin: 0 auto;
    }
}

.basket-list {
    width: calc(100% - 370px);
}

@media screen and (max-width: 1024px) {
    .basket-list {
        width: 100%;
    }
}

.basket-list__clear {
    font-size: 14px;
    line-height: 20px;
    color: var(--color-blackberry);
    position: relative;
    display: flex;
    align-items: center;
    margin-top: 20px;
}

@media screen and (max-width: 1024px) {
    .basket-list__clear {
        justify-content: center;
    }
}

.basket-list__clear:before {
    content: '';
    width: 24px;
    height: 24px;
    display: block;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat;
    background-size: contain;
    margin-right: 8px;
}

.basket-mobile__title {
    display: none;
    text-align: center;
    font-size: 16px;
    line-height: 20px;
    font-family: "RalewaySemiBold";
    color: var(--color-granite);
    margin-bottom: 20px;
}

@media screen and (max-width: 1024px) {
    .basket-mobile__title {
        display: block;
        margin-bottom: 41px;
    }
}

.basket-item {
    border-bottom: 1px solid var(--color-light-periwinkle-crayola);
    padding-bottom: 16px;
    margin-bottom: 16px;
    display: flex;
    position: relative;
    outline: none !important;
}

@media screen and (max-width: 1024px) {
    .basket-item {
        padding-bottom: 20px;
        margin-bottom: 21px;
    }
}

.basket-item._remove {
    display: none;
}

.basket-item__img {
    width: 120px;
    height: 180px;
    -o-object-fit: cover;
    object-fit: cover;
    display: block;
}

@media screen and (max-width: 1024px) {
    .basket-item__img {
        width: 48px;
        height: 73px;
    }
}

.basket-item__body {
    margin-left: 16px;
    width: 100%;
}

@media screen and (max-width: 1024px) {
    .basket-item__body {
        margin-left: 12px;
    }
}

.basket-item__title {
    font-size: 18px;
    line-height: 22px;
    color: var(--color-granite) !important;
    margin-bottom: 4px;
    font-weight: 700;
    text-transform: uppercase;
    outline: none !important;
    cursor: pointer;
    text-decoration: underline;
}

@media screen and (max-width: 1024px) {
    .basket-item__title {
        font-size: 16px;
        line-height: 22px;
        margin-bottom: 4px;
    }
}

.basket-item__info {
    margin-bottom: 16px;
}

.basket-item__info-line {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blackberry);
}

.basket-item__value:after {
    content: ';';
}

.basket-item__value:last-child:after {
    content: '';
}

@media screen and (max-width: 1024px) {
    .basket-item__info-line {
        font-size: 14px;
        line-height: 18px;
    }
}

.basket-item__bottom {
    display: flex;
    align-items: center;
}

@media screen and (max-width: 1024px) {
    .basket-item__bottom {
        align-items: baseline;
    }
}

.basket-item__favorite {
    display: flex;
    align-items: center;
    position: relative;
    font-size: 14px;
    line-height: 20px;
    color: var(--color-blackberry);
    margin-right: 16px;
}

@media screen and (max-width: 1024px) {
    .basket-item__favorite {
        margin-right: 15px;
    }
}

.basket-item__favorite._active {
    color: var(--color-blue-steel);
}

.basket-item__favorite._active:before {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat;
}

.basket-item__favorite:before {
    content: '';
    width: 24px;
    height: 24px;
    display: inline-block;
    margin-right: 4px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat;
    background-size: contain;
}

@media screen and (max-width: 1024px) {
    .basket-item__favorite span {
        display: none;
    }
}

.basket-item__remove {
    display: flex;
    align-items: center;
    position: relative;
    font-size: 14px;
    line-height: 20px;
    cursor: pointer;
    color: var(--color-blackberry);
}

.basket-item__remove-yes {
    display: inline-block;
    margin-right: 12px;
    line-height: 22px;
    color: var(--color-error);
    font-family: "RalewaySemiBold";
}

.basket-item__remove-yes:before {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) no-repeat;
}

.basket-item__remove-no {
    line-height: 22px;
    color: var(--color-granite);
    font-family: "RalewaySemiBold";
}

.basket-item__remove:before {
    content: '';
    width: 24px;
    height: 24px;
    display: inline-block;
    margin-right: 4px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat;
    background-size: contain;
}

@media screen and (max-width: 1024px) {
    .basket-item__remove span {
        display: none;
    }
}

.basket-item__del {
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blackberry);
    position: relative;
    border-bottom: 1px solid var(--color-light-periwinkle-crayola);
    padding-bottom: 16px;
    margin-bottom: 16px;
}

.basket-item__del a {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-main);
    font-family: "RalewaySemiBold";
    margin-left: 12px;
}

.basket-item__del:before {
    content: '';
    width: 24px;
    height: 24px;
    display: inline-block;
    margin-right: 4px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat;
    background-size: contain;
}

.basket-item__calc {
    width: auto;
    /*position: absolute;*/
    top: 0;
    right: 0;
}

.basket-item__append {
    width: 112px;
}

@media screen and (max-width: 1024px) {
    .basket-item__append {
        margin-right: 26px;
    }
}

.basket-item__price-new {
    font-size: 18px;
    line-height: 22px;
    font-family: "RalewayRegular";
    color: var(--color-granite);
    font-weight: 700;
}

.basket-item__price-old {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blackberry);
    text-decoration: line-through;
}

.basket-item__wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid var(--color-pale-blue);
    border-radius: 4px;
    padding: 4px;
    margin-top: 8px;
    height: 32px;
}

.basket-item__minus {
    width: 24px;
    height: 24px;
    cursor: pointer;
}

.basket-item__minus._disabled {
    opacity: .3;
    cursor: default;
}

.basket-item__num {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
    border: none;
    display: block;
    width: 100%;
    text-align: center;
    -moz-appearance: textfield;
}

.basket-item__num:focus {
    outline: none;
}

.basket-item__num::-webkit-outer-spin-button, .basket-item__num::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

.basket-item__plus {
    width: 24px;
    height: 24px;
    cursor: pointer;
}

.basket-item__count {
    margin-top: 8px;
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blackberry);
}

@media screen and (max-width: 1024px) {
    .basket-item__count {
        font-size: 14px;
        line-height: 18px;
    }
}

.basket-order {
    width: 307px;
    flex-shrink: 0;
}

@media screen and (max-width: 1024px) {
    .basket-order {
        margin-bottom: 59px;
        width: 100%;
    }
}

.basket-order__title {
    font-size: 20px;
    line-height: 26px;
    color: var(--color-granite);
    font-family: "RalewaySemiBold";
    margin-bottom: 8px;
}

@media screen and (max-width: 1024px) {
    .basket-order__title {
        font-size: 16px;
        line-height: 20px;
        text-align: center;
        margin-bottom: 16px;
    }
}

.basket-order__text {
    font-size: 16px;
    line-height: 22px;
    color: var(--color-granite);
    margin-bottom: 4px;
}

.basket-order__auth {
    font-size: 16px;
    line-height: 22px;
    color: var(--color-main);
    font-family: "RalewaySemiBold";
    display: flex;
    align-items: center;
    position: relative;
}

.basket-order__auth:before {
    content: '';
    width: 24px;
    height: 24px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) no-repeat;
    background-size: contain;
    margin-right: 8px;
}

.basket-order__form {
    margin-top: 24px;
}

.basket-order__wrap {
    margin-bottom: 16px;
    display: block;
}

.basket-order__wrap._error .basket-order__field {
    border: 1px solid var(--color-error);
}

.basket-order__wrap._error .error {
    display: block;
}

.basket-order__wrap._error .basket-order__wrap-clear {
    display: block;
}

.basket-order__wrap-clear {
    display: none;
    position: absolute;
    top: 50%;
    right: 12px;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    cursor: pointer;
}

.basket-order__wrap-success {
    display: none;
    position: absolute;
    top: 50%;
    right: 12px;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    cursor: pointer;
}

.basket-order__wrap-success._active {
    display: block;
}

.basket-order__wrap-input {
    display: flex;
    justify-content: space-between;
    background: var(--color-light-periwinkle-crayola);
}

.basket-order__wrap-promo {
    position: relative;
    width: 100%;
}

.basket-order__wrap-apply {
    position: relative;
    flex-shrink: 0;
    min-width: 80px;
}

.basket-order__wrap-apply._active {
    display: flex;
    align-items: center;
}

.basket-order__wrap-load {
    display: none;
    width: 24px;
    height: 24px;
    margin: 0 auto;
}

.basket-order__wrap-load._active {
    display: block;
}

.basket-order__field {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blackberry);
    height: 40px;
    width: 100%;
    padding: 8px 12px;
    background: transparent;
    border: none;
}

.basket-order__field:focus {
    outline: none;
}

.basket-order__apply {
    height: 40px;
    background: transparent;
    padding: 8px 12px;
    font-size: 16px;
    line-height: 24px;
    font-family: "RalewaySemiBold";
    border: none;
    color: var(--color-main);
    cursor: pointer;
}

.basket-order__line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
}

.basket-order__line-title {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blackberry);
}

.basket-order__line-value {
    color: var(--color-granite);
}

.basket-order__line-info {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blackberry);
}

.basket-order__line-info-value {
    color: var(--color-blackberry);
}

.basket-order__total .basket-order__line-title {
    font-size: 16px;
    line-height: 24px;
    font-family: "RalewaySemiBold";
    color: var(--color-granite);
}

.basket-order__total .basket-order__line-value {
    font-size: 16px;
    line-height: 24px;
    font-family: "RalewaySemiBold";
    color: var(--color-granite);
}

.basket-order__delivery {
    font-size: 16px;
    line-height: 22px;
    color: var(--color-blackberry);
    margin-top: 4px;
    display: flex;
    align-items: center;
}

.basket-order__delivery-wrap {
    margin-top: 16px;
}

.basket-order__delivery svg {
    width: 18px;
    height: 18px;
    margin-left: 8px;
}

.basket-order__btn {
    display: block;
    width: 100%;
    text-align: center;
    padding: 14px 0;
    font-size: 18px;
    line-height: 28px;
    border: none;
    margin-top: 16px;
}

.basket-order__btn:focus {
    outline: none;
}

.basket-order__info {
    margin-top: 34px;
}

@media screen and (max-width: 1024px) {
    .basket-order__info {
        overflow-x: auto;
        margin-top: 26px;
    }
}

@media screen and (max-width: 1024px) {
    .basket-order__info-wrap {
        display: flex;
        width: 432px;
    }
}

.basket-order__info-block {
    margin-bottom: 8px;
}

@media screen and (max-width: 1024px) {
    .basket-order__info-block {
        margin-right: 20px;
    }
}

.basket-order__info-link {
    font-size: 16px;
    line-height: 22px;
    color: var(--color-main);
    position: relative;
    display: flex;
}

.basket-order__info-link:before {
    content: '';
    width: 24px;
    height: 24px;
    display: block;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) no-repeat;
    background-size: contain;
    margin-right: 4px;
}

.basket-auth .basket-order__text,
.basket-auth .basket-order__auth {
    display: none;
}

.basket-popup {
    position: absolute;
    top: 16px;
    right: 16px;
    border-radius: 16px;
    background: var(--color-main);
    width: 320px;
    height: 248px;
    padding: 20px 24px;
    display: none;
    z-index: 4;
}

.basket-popup._active {
    display: block;
}

.basket-popup__title {
    font-size: 20px;
    line-height: 26px;
    font-family: "RalewaySemiBold";
    color: var(--color-white);
}

.basket-popup__body {
    margin-top: 16px;
    display: flex;
}

.basket-popup__icon {
    width: 48px;
    height: 48px;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 16px;
    border-radius: 50%;
    background: var(--color-light-periwinkle-crayola);
}

.basket-popup__subtitle {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-gray-window);
}

.basket-popup__price {
    font-size: 20px;
    line-height: 32px;
    font-family: "RalewaySemiBold";
    color: var(--color-white);
}

.basket-popup__bottom {
    margin-top: 40px;
    display: flex;
}

.basket-popup__ok {
    border-radius: 4px;
    background: var(--color-white);
    width: 127px;
    height: 40px;
    font-size: 16px;
    line-height: 24px;
    font-family: "RalewaySemiBold";
    color: var(--color-main);
    display: flex;
    align-items: center;
    padding: 14px 16px;
}

.basket-popup__ok svg {
    margin-right: 12px;
    width: 24px;
    height: 24px;
}

.basket-popup__show {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-white);
    height: 40px;
    margin-left: 24px;
    display: flex;
    align-items: center;
}

/* /BASKET */
/* 404 PAGE */
.not-found {
    text-align: center;
    margin-bottom: 80px;
}

.not-found__h1 {
    font-size: 32px;
    line-height: 40px;
    color: var(--color-granite);
    margin-bottom: 16px;
}

@media screen and (max-width: 576px) {
    .not-found__h1 {
        font-size: 20px;
        line-height: 26px;
    }
}

.not-found__error {
    font-size: 18px;
    line-height: 28px;
    color: var(--color-gray-window);
    font-family: "RalewaySemiBold";
    margin-bottom: 16px;
}

@media screen and (max-width: 576px) {
    .not-found__error {
        font-size: 16px;
        line-height: 24px;
    }
}

.not-found__text {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
    max-width: 484px;
    width: 100%;
    margin: 0 auto;
}

/* /404 PAGE */
/* 500 ERROR */
.five-500 {
    margin-top: 32px;
    text-align: center;
}

.five-500__logo {
    display: inline-block;
    margin-bottom: 70px;
}

@media screen and (max-width: 576px) {
    .five-500__logo {
        margin-bottom: 40px;
    }
}

.five-500__icon {
    display: block;
    margin: 0 auto;
}

.five-500__h1 {
    font-size: 32px;
    line-height: 40px;
    color: var(--color-granite);
    text-align: center;
    margin-bottom: 8px;
}

@media screen and (max-width: 576px) {
    .five-500__h1 {
        font-size: 20px;
        line-height: 26px;
    }
}

.five-500__subtitle {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
    text-align: center;
    margin-bottom: 32px;
}

.five-500__reload {
    font-size: 18px;
    line-height: 28px;
    color: var(--color-white);
    text-align: center;
    padding: 14px 20px;
    display: inline-block;
    margin-bottom: 40px;
    background: var(--color-main);
    border-radius: 4px;
}

.five-500 .connection-list {
    margin-top: 0;
}

/* /500 ERROR */
/* ORDERING */
.ordering {
    margin-top: 46px;
}

@media screen and (max-width: 1024px) {
    .ordering {
        margin-top: 24px;
    }
}

.ordering h1 {
    margin-top: 12px;
    text-align: center;
    font-size: 32px;
    line-height: 40px;
    color: var(--color-granite);
}

.ordering .info-payment {
    text-align: center;
}

@media screen and (max-width: 1024px) {
    .ordering h1 {
        font-size: 20px;
        line-height: 26px;
    }
}

/* SELECT */
.select {
    position: relative;
    width: calc(50% - 8px);
}

@media screen and (max-width: 576px) {
    .select {
        width: 100%;
        margin-top: 8px;
    }
}

.select-top {
    position: relative;
}

.select-top:after {
    position: absolute;
    content: '';
    top: 50%;
    right: 16px;
    width: 24px;
    height: 24px;
    -webkit-transform: translateY(-50%) scale(1);
    transform: translateY(-50%) scale(1);
    background: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat;
    background-size: contain;
}

.select-top__input {
    padding: 4px 12px 4px 9px;
    height: 40px;
    font-size: 14px;
    line-height: 20px;
    color: var(--color-main);
    border: 1px solid var(--color-light-periwinkle-crayola);
    background: var(--color-light-periwinkle-crayola);
    border-radius: 4px;
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;
}

.select-top__input:focus {
    outline: none;
}

.select-start, .select-choose, .select-empty {
    font-size: 16px;
    line-height: 22px;
    color: var(--color-blackberry);
    display: flex;
    align-items: center;
}

.select-start._hide, .select-choose._hide, .select-empty._hide {
    display: none;
}

.select-start svg, .select-choose svg, .select-empty svg {
    margin-right: 8px;
}

.select-choose svg {
    margin-right: 12px;
}

.select-empty svg {
    margin-right: 10px;
}

.select-list {
    display: none;
    position: absolute;
    top: 45px;
    left: 0;
    width: 100%;
    background: var(--color-white);
    border-radius: 4px;
    padding: 16px 8px 16px 12px;
    box-shadow: 0px 4px 16px rgba(8, 11, 48, 0.2);
    z-index: 2;
}

.select-list._active {
    display: block;
}

.select-label {
    display: block;
    margin-top: 18px;
    position: relative;
}

.select-label._hide {
    display: none;
}

.select-label._active .select-text:after {
    display: block;
}

.select-label:last-child {
    margin-bottom: 0;
}

.select-radio {
    position: absolute;
    z-index: -1;
    opacity: 0;
    margin: 10px 0 0 20px;
}

.select-text {
    font-size: 16px;
    line-height: 22px;
    color: var(--color-granite);
    width: 100%;
    display: block;
    position: relative;
}

.select-text:after {
    position: absolute;
    content: '';
    display: none;
    right: 0;
    top: 0;
    width: 24px;
    height: 24px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) no-repeat;
    background-size: contain;
}

.select-prompt {
    position: relative;
    background: var(--color-blue-alice);
    padding: 8px 46px 8px 12px;
    font-size: 16px;
    line-height: 22px;
    color: var(--color-granite);
    display: none;
    align-items: center;
    margin-top: 24px;
    width: 100%;
    height: 40px;
}

@media screen and (max-width: 576px) {
    .select-prompt {
        height: auto;
    }
}

.select-prompt._active {
    display: flex;
}

.select-prompt:before {
    position: absolute;
    content: '';
    top: -12px;
    left: 70%;
    border-left: 15px solid transparent;
    border-bottom: 12px solid var(--color-blue-alice);
    border-right: 15px solid transparent;
}

@media screen and (max-width: 576px) {
    .select-prompt:before {
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
    }
}

.select-prompt__close {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    right: 14px;
    display: block;
    height: 24px;
}

/* /SELECT */
/* MAGAZINE */
.magazine {
    margin: 80px 0;
}

@media screen and (max-width: 1024px) {
    .magazine {
        margin: 64px 0 40px 0;
        padding-bottom: 25px;
    }
}

.magazine h2 {
    font-size: 32px;
    line-height: 40px;
    text-align: center;
    font-family: "RalewaySemiBold";
    color: var(--color-granite);
    margin-bottom: 32px;
}

@media screen and (max-width: 1024px) {
    .magazine h2 {
        font-size: 24px;
        line-height: 32px;
        margin-bottom: 24px;
    }
}

@media screen and (max-width: 1024px) {
    .magazine-over {
        overflow-x: auto;
        padding-bottom: 20px;
    }
}

.magazine-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 30px;
    flex-direction: row;
}

@media screen and (max-width: 1024px) {
    .magazine-wrap {
        /*width: 1050px;*/
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: nowrap;
        gap: 30px;
        overflow-x: scroll;
    }
}

.magazine-item {
    width: 23%;
}

@media screen and (max-width: 1024px) {
    .magazine-item {
        width: 240px;
        flex-shrink: 0;
    }
}

.magazine-item__img {
    width: 100%;
    height: 324px;
    -o-object-fit: cover;
    object-fit: cover;
    display: block;
}

@media screen and (max-width: 1350px) {
    .magazine-item__img {
        height: 280px;
        object-fit: contain;
    }
}

@media screen and (max-width: 1024px) {
    .magazine-item__img {
        width: 240px;
        height: 240px;
        object-fit: contain;
    }
}

.magazine-item__title {
    margin-top: 16px;
    font-size: 18px;
    line-height: 24px;
    color: var(--color-granite);
}

.magazine-item__date {
    margin-top: 8px;
    font-size: 12px;
    line-height: 16px;
    color: var(--color-blackberry);
}

/* /MAGAZINE */
/* INDEX PAGE */


.index-full__block {
    position: absolute;
    top: 40%;
    left: 50%;
    max-width: 530px;
}

@media screen and (max-width: 1024px) {
    .index-full__block {
        display: none;
    }
}

.index-full__block-title {
    font-size: 56px;
    line-height: 64px;
    font-family: "RalewaySemiBold";
    color: var(--color-granite);
    margin-bottom: 32px;
}

@media screen and (max-width: 1024px) {
    .index-full__block-title {
        font-size: 24px;
        line-height: 32px;
        text-align: center;
        margin-bottom: 16px;
    }
}

.index-full__block-show {
    padding: 12px 20px;
    font-size: 16px;
    line-height: 24px;
    font-family: "RalewaySemiBold";
    color: var(--color-white);
    border-radius: 4px;
    background: var(--color-main);
    display: inline-block;
}

.index-dots {
    position: absolute;
    left: 0;
    bottom: 24px !important;
    z-index: 2;
    width: 100%;
    display: flex;
    justify-content: center;
}

.index-stocks {
    /*margin: 32px 0;*/
    box-shadow: 0 10px 20px #999;
    z-index: 8;
}

@media screen and (max-width: 1024px) {
    .index-stocks {
        /*margin: 20px 0;*/
    }
}

.index-stocks__wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

@media screen and (max-width: 1024px) {
    .index-stocks__wrap {
        flex-direction: column;
    }
}

.index-stocks__item {
    display: block;
    /*width: calc(50% - 16px);*/
    /*height: 400px;*/
}

.index-stocks__item {

}

@media screen and (max-width: 1024px) {
    .index-stocks__item {
        /*height: 226px;*/
        width: 100%;
        /*margin-bottom: 20px;*/
        box-shadow: none;
    }

    .index-stocks__item:first-child {
        margin-bottom: 0;
        box-shadow: 0 10px 20px #999;
        z-index: 5;
    }

    .index-stocks__item:last-child {
        margin-bottom: 0;
        box-shadow: 0 10px 20px #999;
        z-index: 3;
    }
}

.index-stocks > .container {
    margin: 0;
    padding: 0;
}

.index-stocks__img {
    width: 100%;
    height: 100%;
    display: block;
    -o-object-fit: cover;
    object-fit: cover;
}

.index-category {
    margin-top: 64px;
    margin-bottom: 80px;
}

@media screen and (max-width: 1024px) {
    .index-category {
        margin: 48px 0;
    }
}

.index-category__h2 {
    font-size: 32px;
    line-height: 40px;
    font-family: "RalewaySemiBold";
    color: var(--color-granite);
    margin-bottom: 32px;
    text-align: center;
}

@media screen and (max-width: 1024px) {
    .index-category__h2 {
        font-size: 24px;
        line-height: 32px;
        margin-bottom: 24px;
    }
}

@media screen and (max-width: 1024px) {
    .index-category__over {
        overflow-x: auto;
    }
}

.index-category__wrap {
    display: flex;
    justify-content: space-around;
    align-items: start;
    gap: 30px;
    flex-wrap: wrap;
}

@media screen and (max-width: 1024px) {
    .index-category__wrap {
        display: block;
        text-align: center;
    }
}

.index-category__block {
    flex: 0 1 calc(25% - 60px);
    max-width: 80%;
}

@media screen and (max-width: 1024px) {
    .index-category__block {
        width: 240px;
        display: inline-block;
        margin-bottom: 30px;
    }
}

.index-category__img {
    max-width: 100%;
    display: block;
    -o-object-fit: cover;
    object-fit: cover;
    margin-bottom: 24px;
}

@media screen and (max-width: 1024px) {
    .index-category__img {
        width: 240px;
        height: 240px;
        margin-bottom: 20px;
    }
}

.index-category__link {
    display: block;
    outline: none !important;
    text-decoration: none !important;
}

.index-category__title {
    font-size: 24px;
    line-height: 32px;
    color: var(--color-granite);
    font-family: "RalewaySemiBold";
    margin-bottom: 8px;
}

.index-category__list {
    padding-left: 0;
    margin: 0;
}

.index-category__item {
    margin-bottom: 8px;
}

.index-category__item:last-child {
    margin-bottom: 0;
}

.index-category__link {
    font-size: 16px;
    line-height: 22px;
    color: var(--color-granite);
}

.index-category__link-last {
    font-family: "RalewaySemiBold";
    line-height: 24px;
}

.index-category__other {
    margin-top: 48px;
}

@media screen and (max-width: 1024px) {
    .index-category__other {
        margin-top: 36px;
    }
}

.index-category__other-list {
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--color-periwinkle-crayola);
    padding: 28px 20px;
}

@media screen and (max-width: 1024px) {
    .index-category__other-list {
        margin: 0 auto;
    }
}

@media screen and (max-width: 420px) {
    .index-category__other-list {
        width: 400px;
    }
}

@media screen and (max-width: 380px) {
    .index-category__other-list {
        justify-content: flex-start;
    }
}

.index-category__other-item {
    font-size: 18px;
    line-height: 24px;
    color: var(--color-granite);
    font-family: "RalewaySemiBold";
    display: flex;
    align-items: center;
    margin-right: 50px;
}

.index-category__other-item:last-child {
    margin-right: 0;
}

.index-category__other-item svg {
    margin-right: 8px;
}

.index-popular {
    margin-top: 72px;
    margin-bottom: 78px;
}

@media screen and (max-width: 1024px) {
    .index-popular {
        margin: 64px 0;
    }
}

.index-popular .liked-container {
    margin: 0 -16px;
}

.index-popular__title {
    font-size: 32px;
    line-height: 40px;
    font-family: "RalewaySemiBold";
    color: var(--color-granite);
}

@media screen and (max-width: 1024px) {
    .index-popular__title {
        font-size: 24px;
        line-height: 32px;
    }
}


.index-popular .product-item {
    width: 324px;
}

@media screen and (max-width: 1350px) {
    .index-popular .product-item {
        width: 100%;
    }
}

.index-popular .product-item img {
    height: 494px;
}

@media screen and (max-width: 1024px) {
    .index-popular .product-item img {
        height: 366px;
    }
}


.index-liked {
    margin-top: 72px;
    margin-bottom: 78px;
}

@media screen and (max-width: 1024px) {
    .index-liked {
        margin-bottom: 40px;
    }
}

.index-liked .product-item__img {
    height: 312px;
}

@media screen and (max-width: 1024px) {
    .index-liked .product-item__img {
        height: 272px;
    }
}

.index-banner {
    /*margin-top: 82px;*/
    box-shadow: 0 10px 20px #999;
}

@media screen and (max-width: 1024px) {
    .index-banner {
        /*margin-top: 68px;*/
    }
}

.index-banner > .container {
    margin: 0;
    padding: 0;
}

.index-banner__block {
    display: block;
}

.index-banner__img {
    width: 100%;
    height: auto;
    display: block;
    -o-object-fit: contain;
    object-fit: contain;
}

@media screen and (max-width: 480px) {
    .index-banner__img {
        display: none;
    }
}

.index-banner__img-mobile {
    display: none;
}

@media screen and (max-width: 480px) {
    .index-banner__img-mobile {
        width: 100%;
        height: auto;
        display: block;
        -o-object-fit: cover;
        object-fit: cover;
    }
}

.index-advantages {
    margin: 80px 0;
    padding: 43px 0 47px 0;
    background: var(--color-periwinkle-crayola);
}

@media screen and (max-width: 1024px) {
    .index-advantages {
        overflow-x: auto;
        margin: 40px 0 66px 0;
    }
}

.index-advantages__wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1140px;
    margin: 0 auto;
}

@media screen and (max-width: 1024px) {
    .index-advantages__wrap {
        width: 980px;
    }
}

.index-advantages__item {
    width: 200px;
}

.index-advantages__icon {
    border-radius: 50%;
    width: 33px;
    height: 33px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
}

.index-advantages__title {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
    font-family: "RalewaySemiBold";
    text-align: center;
    margin-top: 12px;
    margin-bottom: 8px;
}

.index-advantages__text {
    font-size: 14px;
    line-height: 18px;
    color: var(--color-blue-steel);
    text-align: center;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: flex-end;
}

.index-advantages__text:after {
    content: '';
    display: block;
    width: 14px;
    height: 14px;
    margin-left: 6px;
    margin-bottom: 1px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) no-repeat;
    background-size: contain;
}

.index-info h2 {
    font-size: 32px;
    line-height: 40px;
    text-align: center;
    font-family: "RalewaySemiBold";
    color: var(--color-granite);
    margin-bottom: 34px;
}

@media screen and (max-width: 1024px) {
    .index-info h2 {
        font-size: 24px;
        line-height: 32px;
    }
}

.index-info__wrap {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    max-width: 1103px;
    width: 100%;
    margin: 0 auto;
    gap: 30px;
    text-align: justify;
}

@media screen and (max-width: 1024px) {
    .index-info__wrap {
        flex-direction: column;
    }
}

.index-info__text {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
    max-width: 520px;
    width: 100%;
}

@media screen and (max-width: 1024px) {
    .index-info__text {
        max-width: 100%;
        margin-bottom: 20px;
    }

    .index-info__text:last-child {
        margin-bottom: 0;
    }
}

.index-info__text p {
    margin-top: 0;
    margin-bottom: 11px;
}

.index-news {
    margin: 36px 0 78px 0;
}

@media screen and (max-width: 1024px) {
    .index-news {
        margin: 48px 0 64px 0;
    }
}

.index-news .container {
    overflow: hidden;
}

.index-news .slider-wrap {
    padding: 0;
}

@media screen and (max-width: 1440px) {
    .index-news .slider-next {
        right: -20px;
    }
}

@media screen and (max-width: 1440px) {
    .index-news .slider-prev {
        left: -20px;
    }
}

.index-news__item {
    display: block;
    max-width: 443px;
    width: 100%;
    flex-shrink: 0;
}

@media screen and (max-width: 1024px) {
    .index-news__item {
        padding: 0 8px;
    }
}

.index-news__img {
    width: 100%;
    height: 249px !important;
    -o-object-fit: cover;
    object-fit: cover;
    display: block;
}

.index-news__title {
    font-size: 20px;
    line-height: 26px;
    color: var(--color-granite);
    margin-top: 16px;
}

/* /INDEX PAGE */

/* FAVORITE */
.favorite {
    margin-top: 70px;
}

@media screen and (max-width: 1024px) {
    .favorite {
        margin-top: 36px;
    }
}

.favorite-empty__title {
    font-size: 24px;
    line-height: 32px;
    color: var(--color-granite);
    margin-bottom: 16px;
}

.favorite-empty__text {
    font-size: 18px;
    line-height: 28px;
    color: var(--color-blackberry);
    margin-bottom: 16px;
}

.favorite-empty__link {
    font-size: 18px;
    line-height: 28px;
    color: var(--color-main);
    margin-right: 24px;
}

.favorite-empty__link:last-child {
    margin-right: 0;
}

.curtain .aside-all {
    text-align: left;
    border: none;
    background: var(--color-light-periwinkle-crayola);
}

.curtain .aside-subtitle,
.curtain .accordion {
    display: block;
}

.curtain .accordion-top {
    display: flex;
}

.curtain .accordion-body {
    display: none;
}

.curtain .accordion-block {
    display: block;
}

.curtain .accordion-list {
    display: block;
    width: 100%;
}

.curtain .accordion-item {
    margin-bottom: 18px;
}

.curtain .accordion-item:before {
    content: '';
}

/* /FAVORITE */
/* STOCKS */
.stocks {
    margin-top: 48px;
}

@media screen and (max-width: 1024px) {
    .stocks {
        margin-top: 14px;
    }
}

.stocks .container {
    max-width: 1920px;
}

.stocks-h1 {
    text-align: center;
    font-size: 56px;
    line-height: 64px;
    color: var(--color-granite);
    font-family: "RalewaySemiBold";
    margin-bottom: 40px;
}

@media screen and (max-width: 1024px) {
    .stocks-h1 {
        font-size: 20px;
        line-height: 26px;
        margin-bottom: 24px;
    }
}

.stocks-list {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
}

.stocks-item {
    width: calc(50% - 16px);
    height: 400px;
    display: flex;
    margin-bottom: 32px;
}

@media screen and (max-width: 1024px) {
    .stocks-item {
        flex-direction: column;
        height: auto;
    }
}

@media screen and (max-width: 576px) {
    .stocks-item {
        width: 100%;
        margin-bottom: 16px;
    }
}

.stocks-item__left {
    width: 50%;
    flex-shrink: 0;
}

@media screen and (max-width: 1024px) {
    .stocks-item__left {
        width: 100%;
    }
}

.stocks-item__img {
    width: 100%;
    height: 100%;
    display: block;
    -o-object-fit: cover;
    object-fit: cover;
}

@media screen and (max-width: 1024px) {
    .stocks-item__img {
        height: 360px;
    }
}

.stocks-item__right {
    width: 50%;
    flex-shrink: 0;
    padding: 40px;
    position: relative;
}

@media screen and (max-width: 1024px) {
    .stocks-item__right {
        padding: 32px 32px 20px 32px;
        width: 100%;
    }
}

.stocks-item__title {
    font-size: 20px;
    line-height: 26px;
    color: var(--color-granite);
    display: block;
    font-family: "RalewaySemiBold";
    margin-bottom: 16px;
}

.stocks-item__text {
    font-size: 16px;
    line-height: 22px;
    color: var(--color-granite);
}

.stocks-item__bottom {
    position: absolute;
    bottom: 32px;
    left: 40px;
    display: flex;
    flex-direction: column;
}

@media screen and (max-width: 1024px) {
    .stocks-item__bottom {
        position: relative;
        bottom: initial;
        left: initial;
        margin-top: 24px;
    }
}

.stocks-item__more {
    font-size: 16px;
    line-height: 22px;
    color: var(--color-granite);
    display: inline-block;
}

@media screen and (max-width: 1024px) {
    .stocks-item__more {
        margin-bottom: 10px;
    }
}

.stocks-text {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
    margin: 66px auto 80px;
    max-width: 680px;
    width: 100%;
}

@media screen and (max-width: 1024px) {
    .stocks-text {
        margin: 48px auto 48px;
    }
}

.stocks-text ul {
    padding-left: 20px;
}

.stocks-text ul li {
    list-style-type: initial;
}

.stocks-text a {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
    text-decoration: underline;
}

.stocks-detail {
    margin: 48px 0 80px 0;
}

@media screen and (max-width: 1024px) {
    .stocks-detail {
        margin: 14px 0 40px 0;
    }
}

.stocks-detail .container {
    max-width: 956px;
}

.stocks-detail__block {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 64px;
    overflow: hidden;
}

@media screen and (max-width: 576px) {
    .stocks-detail__block {
        flex-direction: column;
        margin-bottom: 48px;
    }
}

.stocks-detail__img {
    max-width: 444px;
    width: 100%;
    height: 498px;
    -o-object-fit: cover;
    object-fit: cover;
    display: block;
    flex-shrink: 0;
}

@media screen and (max-width: 1024px) {
    .stocks-detail__img {
        flex-shrink: initial;
        width: 50%;
    }
}

@media screen and (max-width: 576px) {
    .stocks-detail__img {
        width: 100%;
        margin-bottom: 24px;
        height: 360px;
    }
}

.stocks-detail__right {
    width: 50%;
    flex-shrink: 0;
    padding: 0 0 0 32px;
}

@media screen and (max-width: 1024px) {
    .stocks-detail__right {
        flex-shrink: initial;
    }
}

@media screen and (max-width: 576px) {
    .stocks-detail__right {
        width: 100%;
        padding: 0;
    }
}

.stocks-detail__title {
    font-size: 32px;
    line-height: 40px;
    font-family: "RalewaySemiBold";
    margin-bottom: 24px;
}

@media screen and (max-width: 767px) {
    .stocks-detail__title {
        font-size: 24px;
        line-height: 32px;
        margin-bottom: 16px;
    }
}

.stocks-detail__text {
    font-size: 18px;
    line-height: 28px;
    color: var(--color-blackberry);
    margin-bottom: 32px;
}

@media screen and (max-width: 576px) {
    .stocks-detail__text {
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 25px;
    }
}

.stocks-detail__link {
    font-size: 16px;
    line-height: 24px;
    padding: 12px 20px;
    display: inline-block;
}

.stocks-detail__bottom {
    margin-top: 48px;
}

.stocks-detail__other {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-main) !important;
    font-family: "RalewaySemiBold";
    padding: 12px 20px;
    border-radius: 4px;
    border: 1px solid var(--color-pale-blue);
    text-decoration: none !important;
    display: inline-block;
}

/* /STOCKS */


/*# sourceMappingURL=main.css.map */

.text-strikeout {
    text-decoration: line-through;
    text-decoration-color: #dd0000;
}

/* промокод ------------------------- */

.promocode__wrapper{
    margin-bottom: 20px;
}

.promocode {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: stretch;
    color: var(--color-blackberry);
    /* background-color: var(--color-blackberry); */
    border: 3px solid #dddddd;
    border-radius: 6px;
    overflow: hidden;
    height: 36px;
}

.promocode__code-wrapper {
    flex: 0 0 50%;
    justify-content: stretch;
    color: var(--color-blackberry);
    display: flex;
    align-items: center;
    flex-direction: row;
}

.promocode__code {
    padding: 0 15px;
    text-align: center;
    font-size: 1em;
    text-transform: uppercase;
}

.promocode__button-wrapper {
    flex: 0 0 50%;
    justify-content: stretch;
    display: flex;
    align-items: stretch;
    flex-direction: row;
    color: var(--color-blackberry);
}

.promocode__button {
    flex: 1 1 auto;
    padding: 3px 15px;
    color: #ffffff;
    background-color: var(--color-blackberry);
    border: 0;
    border-left: 1px solid var(--color-blackberry);
    /* border-radius: 6px; */
    cursor: pointer;
    text-transform: uppercase;
    text-align: center;
}

.promocode__input-wrapper {
    flex: 0 0 50%;
    color: var(--color-blackberry);
    display: flex;
    align-items: center;
    justify-content: stretch;
    flex-direction: row;
}

.promocode__input {
    display: block;
    border: none !important;
    padding: 0 16px;
    width: 100%;
    box-sizing: border-box;
    outline-width: 0 !important;
    font-size: 1em;
    /*text-transform: uppercase;*/
}
.promocode__input:focus-visible,
.promocode__input:focus{
    border:none !important;
    outline-width: 0 !important;
}

`, "",{"version":3,"sources":["webpack://./resources/assets/site/css/site.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB,aAAa;AACb;IACI,YAAY;IACZ,2CAA2C;IAC3C,eAAe;IACf,6BAA6B;IAC7B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,6DAA6C;IAC7C,wBAAwB;IACxB,eAAe;AACnB;;;AAGA,UAAU;AACV;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,2CAA2C;IAC3C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA,YAAY;AACZ;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,kCAAkC;IAClC,0BAA0B;IAC1B,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI;QACI,WAAW;QACX,SAAS;QACT,SAAS;QACT,0BAA0B;QAC1B,kBAAkB;IACtB;AACJ;;AAEA;IACI,SAAS;IACT,WAAW;IACX,eAAe;IACf,WAAW;AACf;;AAEA;IACI;QACI,SAAS;QACT,WAAW;QACX,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;QACjB,UAAU;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA,aAAa;AACb,QAAQ;AACR;IACI,aAAa;AACjB;;AAEA,SAAS;AACT,WAAW;AACX;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,UAAU;IACV,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI;QACI,uBAAuB;QACvB,qBAAqB;IACzB;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,4BAA4B;IAC5B,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;;IAEI,gCAAgC;IAChC,wBAAwB;IACxB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,gDAA8B;IAC9B,YAAY;IACZ,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;;AAEA;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,iDAAiD;IACjD,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;;AAGA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;AACA;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;IAC9B,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,6BAA6B;IAC7B,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI;QACI,UAAU;QACV,WAAW;IACf;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA,YAAY;AACZ,gBAAgB;AAChB;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,8BAA8B;IAC9B,4CAA4C;IAC5C,UAAU;IACV,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA,iBAAiB;AACjB,SAAS;AACT;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,8BAA8B;IAC9B,6CAA6C;IAC7C,kBAAkB;IAClB,4BAA4B;IAC5B,UAAU;IACV,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI;QACI,aAAa;QACb,QAAQ;IACZ;AACJ;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sEAAsD;IACtD,0BAA0B;AAC9B;;AAEA,UAAU;;AAEV,oBAAoB;AACpB;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,qBAAqB;AACrB,gBAAgB;AAChB;IACI,eAAe;IACf,OAAO;IACP,SAAS;IACT,WAAW;IACX,YAAY;IACZ,iDAAiD;IACjD,aAAa;IACb,UAAU;IACV,sBAAsB;AAC1B;;AAEA;AACA;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI;QACI,UAAU;QACV,mBAAmB;QACnB,cAAc;QACd,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,4BAA4B;IAC5B,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,6DAAsD;AAC1D;;AAEA;IACI,6DAA8C;AAClD;;AAEA;IACI,6DAAmD;AACvD;;AAEA;IACI,6DAAyD;AAC7D;;AAEA;IACI,6DAA4C;AAChD;;;AAGA,sBAAsB;;AAEtB,QAAQ;;;AAGR,SAAS;AACT,WAAW;AACX;IACI,oBAAoB;AACxB;;AAEA;IACI;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI;QACI,YAAY;QACZ,YAAY;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,cAAc;IAClB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,2CAA2C;IAC3C,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI;QACI,YAAY;QACZ,kBAAkB;IACtB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,6DAAqD;IACrD,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,uBAAuB;IACvB,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2CAA2C;IAC3C,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA,YAAY;AACZ,gBAAgB;AAChB;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,6DAAqD;IACrD,wBAAwB;AAC5B;;AAEA,iBAAiB;AACjB,YAAY;AACZ;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;QACf,MAAM;QACN,OAAO;QACP,WAAW;QACX,YAAY;QACZ,8BAA8B;QAC9B,WAAW;QACX,aAAa;IACjB;;IAEA;;;;;MAKE;AACN;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAkqBC;AACD;IACI,aAAa;IACb,mBAAmB;IACnB,uDAAuD;IACvD,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iDAAiD;AACrD;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,YAAY;AACZ;IACI,6BAA6B;AACjC;;AAEA;IACI;QACI,6BAA6B;QAC7B,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,sBAAsB;IAC1B;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;IACI;;QAEI,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ;;AAEA;IACI;;QAEI,6BAA6B;QAC7B,sBAAsB;IAC1B;AACJ;;AAEA;IACI;;QAEI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;;QAEI,sBAAsB;QACtB,sBAAsB;IAC1B;AACJ;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI;;QAEI,aAAa;IACjB;AACJ;;AAEA;IACI;;QAEI,aAAa;IACjB;AACJ;;AAEA;IACI;;QAEI,aAAa;IACjB;AACJ;;AAEA;IACI;;QAEI,aAAa;IACjB;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,kBAAkB;QAClB,YAAY;QACZ,cAAc;QACd,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,cAAc;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;IACb,WAAW;IACX,YAAY;IACZ,6DAAyD;IACzD,wBAAwB;IACxB,UAAU;AACd;;AAEA;IACI;QACI,SAAS;QACT,WAAW;IACf;AACJ;;AAEA;IACI,8DAAmE;IACnE,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;AACd;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,yBAAyB;AAC7B;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,QAAQ;QACR,SAAS;QACT,cAAc;IAClB;AACJ;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI;IACA;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI;QACI,kBAAkB;QAClB,YAAY;QACZ,cAAc;QACd,eAAe;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI;QACI,iBAAiB;QACjB,cAAc;IAClB;AACJ;;AAEA;IACI,iDAAiD;IACjD,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,mCAAmC;IACnC,2BAA2B;IAC3B,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,oCAAoC;IACpC,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI;QACI,sBAAsB;QACtB,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,aAAa;QACb,oBAAoB;QACpB,iBAAiB;IACrB;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;;IAEI,WAAW;IACX,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,iDAAiD;IACjD,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,wBAAwB;IACxB,WAAW;AACf;;AAEA,aAAa;AACb,UAAU;AACV;IACI,gBAAgB;IAChB,WAAW;IACX,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,kBAAkB;IACtB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,2BAA2B;IAC3B,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,2BAA2B;IAC3B,cAAc;IACd,gBAAgB;IAChB,iDAAiD;IACjD,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI;QACI,kBAAkB;QAClB,8BAA8B;QAC9B,wCAAwC;QACxC,wBAAwB;QACxB,gBAAgB;IACpB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,8BAA8B;IAC9B,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,6BAA6B;AACjC;;AAEA,WAAW;AACX,cAAc;AACd;IACI,cAAc;AAClB;;AAEA;IACI;QACI,aAAa;QACb,kBAAkB;IACtB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,cAAc;QACd,gBAAgB;IACpB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,aAAa;QACb,mBAAmB;QACnB,aAAa;QACb,eAAe;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,gBAAgB;IAChB,cAAc;AAClB;;AAEA,eAAe;AACf,gBAAgB;AAChB;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,wCAAwC;IACxC,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,wCAAwC;IACxC,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,mCAAmC;IACnC,6BAA6B;AACjC;;AAEA,iBAAiB;AACjB,UAAU;AACV;IACI,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA,WAAW;AACX,WAAW;AACX;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,mCAAmC;IACnC,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;IAC9B,4CAA4C;IAC5C,UAAU;AACd;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,mCAAmC;IACnC,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;IAC9B,4CAA4C;IAC5C,UAAU;AACd;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI;QACI,YAAY;QACZ,cAAc;IAClB;AACJ;;AAEA,YAAY;AACZ,wBAAwB;;;AAGxB,yBAAyB;AACzB,gBAAgB;AAChB;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI;QACI,sBAAsB;QACtB,gBAAgB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;QACf,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,8BAA8B;IAC9B,wCAAwC;IACxC,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;QACf,mBAAmB;IACvB;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,8BAA8B;AAClC;;AAEA,iBAAiB;AACjB,6BAA6B;AAC7B;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA,8BAA8B;AAC9B,uBAAuB;AACvB;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,WAAW;IACX,WAAW;IACX,YAAY;IACZ,4CAA4C;IAC5C,oCAAoC;IACpC,8DAA0D;IAC1D,wBAAwB;AAC5B;;AAEA;IACI,6CAA6C;IAC7C,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,iDAAiD;AACrD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;;IAEI,YAAY;IACZ,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI;;QAEI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,2DAA2D;IAC3D,4DAA4D;IAC5D,6DAA6D;IAC7D,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,8DAA8D;AAClE;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,4BAA4B;IAC5B,YAAY;IACZ,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,wCAAwC;AAC5C;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,2CAA2C;IAC3C,mCAAmC;AACvC;;AAEA;IACI,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,8BAA8B;IAC9B,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,wBAAwB;AACxB,sBAAsB;AACtB;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,8DAA8D;AAClE;;AAEA;IACI;QACI,sBAAsB;QACtB,oBAAoB;IACxB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI;QACI,mBAAmB;QACnB,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,iDAAiD;IACjD,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,gFAAqE;IACrE,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iDAAiD;AACrD;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,YAAY;IACZ,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA,uBAAuB;AACvB,kBAAkB;AAClB;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,YAAY;QACZ,oBAAoB;IACxB;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI;QACI,YAAY;QACZ,aAAa;QACb,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA,mBAAmB;AACnB,iBAAiB;AACjB;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,6BAA6B;IAC7B,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI;QACI,YAAY;QACZ,aAAa;QACb,qBAAqB;IACzB;AACJ;;AAEA,kBAAkB;AAClB,eAAe;AACf;IACI,aAAa;AACjB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB,gCAAgC;AAChC;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,uDAAuD;IAC3D;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;IACpB;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,OAAO;IACP,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iDAAiD;AACrD;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;IAClB,4EAA4E;IAC5E,kDAAkD;AACtD;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,8DAA8D;AAClE;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,wBAAwB;IACxB,kBAAkB;IAClB,cAAc;IACd,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,UAAU;IACV,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,2DAAiD;IACjD,0BAA0B;AAC9B;;AAEA;IACI,2DAAiD;IACjD,0BAA0B;AAC9B;;AAEA;IACI,2DAA+C;IAC/C,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,cAAc;IACd,iDAAiD;IACjD,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,iDAAiD;IACjD,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,iDAAiD;IACjD,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,WAAW;IACX,WAAW;IACX,YAAY;IACZ,4CAA4C;IAC5C,oCAAoC;IACpC,8DAA0D;IAC1D,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB,cAAc;AACd;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA,eAAe;AACf,iBAAiB;AACjB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;IAC9B,eAAe;IACf,WAAW;AACf;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,SAAS;QACT,WAAW;IACf;AACJ;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,QAAQ;IACR,WAAW;IACX,mCAAmC;IACnC,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI;;QAEI,YAAY;QACZ,SAAS;QACT,YAAY;QACZ,qCAAqC;QACrC,6BAA6B;IACjC;AACJ;;AAEA;;IAEI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI;;QAEI,aAAa;QACb,mBAAmB;QACnB,YAAY;IAChB;AACJ;;AAEA;;IAEI,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;;IAEI,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;;;;IAII,eAAe;IACf,QAAQ;IACR,UAAU;IACV,mCAAmC;IACnC,2BAA2B;IAC3B,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,UAAU;AACd;;AAEA;IACI;;;;QAII,aAAa;IACjB;AACJ;;AAEA;;;;IAII,WAAW;IACX,YAAY;AAChB;;AAEA;;;;IAII,6BAA6B;AACjC;;AAEA;;;;IAII,eAAe;IACf,QAAQ;IACR,WAAW;IACX,mCAAmC;IACnC,2BAA2B;IAC3B,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,UAAU;AACd;;AAEA;IACI;;;;QAII,aAAa;IACjB;AACJ;;AAEA;;;;IAII,WAAW;IACX,YAAY;AAChB;;AAEA;;;;IAII,6BAA6B;AACjC;;AAEA,kBAAkB;AAClB,SAAS;AACT;IACI,cAAc;IACd,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI;QACI,2BAA2B;QAC3B,cAAc;QACd,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA,UAAU;AACV,WAAW;AACX;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,SAAS;AACb;;AAEA;IACI;QACI,sBAAsB;QACtB,mBAAmB;IACvB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI;QACI,8BAA8B;QAC9B,gBAAgB;QAChB,cAAc;IAClB;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,cAAc;IACd,8DAAwD;IACxD,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;QACd,mBAAmB;IACvB;AACJ;;AAEA;IACI,8DAA8D;IAC9D,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI;QACI,oBAAoB;QACpB,mBAAmB;IACvB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,wBAAwB;IACxB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8DAAmE;AACvE;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;IACjB,6DAAyD;IACzD,wBAAwB;AAC5B;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;IACjB,8DAAwD;IACxD,wBAAwB;AAC5B;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,kBAAkB;IAClB,8DAA8D;IAC9D,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;IACjB,8DAAwD;IACxD,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,MAAM;IACN,QAAQ;AACZ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,YAAY;IACZ,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI;QACI,mBAAmB;QACnB,WAAW;IACf;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,8DAAwD;IACxD,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,mCAAmC;IACnC,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,mCAAmC;IACnC,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iDAAiD;AACrD;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,YAAY;IACZ,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;QAChB,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,YAAY;IAChB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,cAAc;IACd,8DAAgE;IAChE,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,iDAAiD;AACrD;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;AAEA,YAAY;AACZ,aAAa;AACb;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,gBAAgB;IAChB,WAAW;IACX,cAAc;AAClB;;AAEA,cAAc;AACd,cAAc;AACd;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA,eAAe;AACf,aAAa;AACb;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA,WAAW;AACX;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI;QACI,WAAW;QACX,eAAe;IACnB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,WAAW;IACX,WAAW;IACX,YAAY;IACZ,4CAA4C;IAC5C,oCAAoC;IACpC,8DAA0D;IAC1D,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,uDAAuD;IACvD,iDAAiD;IACjD,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;IAClB,2BAA2B;IAC3B,6CAA6C;IAC7C,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,QAAQ;IACR,MAAM;IACN,WAAW;IACX,YAAY;IACZ,8DAAkD;IAClD,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,mCAAmC;IACnC,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,SAAS;IACT,mCAAmC;IACnC,iDAAiD;IACjD,oCAAoC;AACxC;;AAEA;IACI;QACI,SAAS;QACT,mCAAmC;QACnC,2BAA2B;IAC/B;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,mCAAmC;IACnC,2BAA2B;IAC3B,WAAW;IACX,cAAc;IACd,YAAY;AAChB;;AAEA,YAAY;AACZ,aAAa;AACb;IACI,cAAc;AAClB;;AAEA;IACI;QACI,qBAAqB;QACrB,oBAAoB;IACxB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;IAC9B,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,oBAAoB;IACxB;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI;QACI,iBAAiB;QACjB,aAAa;QACb,2BAA2B;QAC3B,mBAAmB;QACnB,iBAAiB;QACjB,SAAS;QACT,kBAAkB;IACtB;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,YAAY;QACZ,cAAc;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI;QACI,aAAa;QACb,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,aAAa;QACb,mBAAmB;IACvB;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA,cAAc;AACd,eAAe;;;AAGf;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,yBAAyB;IACzB,kBAAkB;IAClB,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,uBAAuB;IACvB,UAAU;IACV,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,UAAU;AACd;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,cAAc;IACd,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;;AAEA;;AAEA;IACI;QACI,iBAAiB;QACjB,WAAW;QACX,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,4BAA4B;QAC5B,UAAU;IACd;;IAEA;QACI,gBAAgB;QAChB,4BAA4B;QAC5B,UAAU;IACd;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,kBAAkB;IAClB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI;QACI,cAAc;QACd,kBAAkB;IACtB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI;QACI,YAAY;QACZ,qBAAqB;QACrB,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI;QACI,YAAY;QACZ,aAAa;QACb,mBAAmB;IACvB;AACJ;;AAEA;IACI,cAAc;IACd,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,2CAA2C;IAC3C,kBAAkB;AACtB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;;AAGA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;;AAGA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,oBAAoB;IACpB,4BAA4B;AAChC;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,cAAc;QACd,oBAAoB;QACpB,iBAAiB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,2CAA2C;AAC/C;;AAEA;IACI;QACI,gBAAgB;QAChB,qBAAqB;IACzB;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,8DAA+D;IAC/D,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;IAC9B,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,wBAAwB;IACxB,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA,gBAAgB;;AAEhB,aAAa;AACb;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iDAAiD;AACrD;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA,cAAc;AACd,WAAW;AACX;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;QACI,sBAAsB;QACtB,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,mBAAmB;IACvB;AACJ;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,UAAU;IACV,cAAc;IACd,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI;QACI,4BAA4B;QAC5B,WAAW;IACf;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,cAAc;IACd,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI;QACI,kBAAkB;QAClB,eAAe;QACf,aAAa;QACb,gBAAgB;IACpB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI;QACI,sBAAsB;QACtB,mBAAmB;IACvB;AACJ;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI;QACI,oBAAoB;QACpB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,WAAW;QACX,mBAAmB;QACnB,aAAa;IACjB;AACJ;;AAEA;IACI,UAAU;IACV,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,UAAU;IACd;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mCAAmC;IACnC,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,wCAAwC;IACxC,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA,YAAY;;;AAGZ,mCAAmC;;AAEnC;IACI,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA,uCAAuC;;AAEvC;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,wBAAwB;IACxB,8BAA8B;IAC9B,+CAA+C;IAC/C,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,wBAAwB;IACxB,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,wBAAwB;IACxB,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,SAAS;IACT,8CAA8C;IAC9C,wBAAwB;IACxB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,2BAA2B;IAC3B,cAAc;IACd,6BAA6B;AACjC;AACA;;IAEI,sBAAsB;IACtB,2BAA2B;AAC/B","sourcesContent":["@charset \"UTF-8\";\n\n/* TOP SALE */\n.top {\n    height: 32px;\n    background: var(--color-periwinkle-crayola);\n    font-size: 12px;\n    font-family: \"RalewayRegular\";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n}\n\n@media screen and (max-width: 1024px) {\n    .top {\n        display: none;\n    }\n}\n\n.top-close {\n    position: absolute;\n    top: 10px;\n    right: 15px;\n    width: 12px;\n    height: 12px;\n    background: url(\"../svg/union.svg\") no-repeat;\n    background-size: contain;\n    cursor: pointer;\n}\n\n\n/* CLOSE */\n.close {\n    position: absolute;\n    width: 48px;\n    height: 48px;\n    cursor: pointer;\n    border-radius: 50%;\n    background: var(--color-periwinkle-crayola);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.overlay {\n    opacity: 0;\n    visibility: hidden;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 10;\n}\n\n.overlay._active {\n    opacity: 1;\n    visibility: visible;\n}\n\n/* CURTAIN */\n.curtain {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(255, 255, 255, 0.2);\n    -webkit-backdrop-filter: blur(4px);\n    backdrop-filter: blur(4px);\n    z-index: 11;\n    overflow: hidden;\n    opacity: 0;\n    visibility: hidden;\n}\n\n.curtain._active {\n    opacity: 1;\n    visibility: visible;\n}\n\n.curtain-wrap {\n    position: fixed;\n    top: 0;\n    right: 0;\n    width: 728px;\n    height: 100vh;\n    background: var(--color-white);\n    padding: 32px 64px 0 64px;\n    overflow-y: auto;\n}\n\n@media screen and (max-width: 1024px) {\n    .curtain-wrap {\n        width: 100%;\n        top: 32px;\n        bottom: 0;\n        height: calc(100% - 100px);\n        padding: 16px 20px;\n    }\n}\n\n.curtain-close {\n    top: 24px;\n    right: 28px;\n    cursor: pointer;\n    z-index: 11;\n}\n\n@media screen and (max-width: 1024px) {\n    .curtain-close {\n        top: 12px;\n        right: 16px;\n        width: 32px;\n        height: 32px;\n    }\n}\n\n.curtain-back {\n    width: 40px;\n    height: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-right: 24px;\n    cursor: pointer;\n}\n\n.curtain-back svg {\n    width: 30px;\n    height: 30px;\n}\n\n@media screen and (max-width: 1024px) {\n    .curtain-back svg {\n        width: 24px;\n        height: 24px;\n    }\n}\n\n.curtain-title {\n    font-size: 24px;\n    line-height: 32px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-granite);\n    display: flex;\n    align-items: center;\n}\n\n.curtain-title span {\n    font-size: 18px;\n    line-height: 28px;\n    font-family: \"RalewayRegular\";\n}\n\n@media screen and (max-width: 1024px) {\n    .curtain-title {\n        font-size: 20px;\n        line-height: 26px;\n        width: 90%;\n    }\n}\n\n.curtain .detail-left {\n    max-height: 467px;\n    height: 100%;\n}\n\n/* /CURTAIN */\n/* MAP */\n.ymaps-2-1-78-controls__toolbar_right {\n    display: none;\n}\n\n/* /MAP */\n/* HEADER */\n.header {\n    position: relative;\n    z-index: 30;\n}\n\n.header-wrapper {\n    /*background: rgba(255, 255, 255, 0.5);*/\n    background-color: #ffffff;\n    z-index: 100;\n}\n\n.header-top {\n    /*padding: 25px 0 10px 0;*/\n    padding: 0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n@media screen and (max-width: 1024px) {\n    .header-top {\n        justify-content: center;\n        /*padding-top: 20px;*/\n    }\n}\n\n.header-mobile__back {\n    display: none;\n    position: absolute;\n    top: 15px;\n    left: 21px;\n    width: 24px;\n    height: 24px;\n}\n\n@media screen and (max-width: 1024px) {\n    .header-mobile__back {\n        display: block;\n    }\n}\n\n.header-left {\n    display: flex;\n    align-items: center;\n    width: 256px;\n    /*padding: 25px 0 10px 7px;*/\n    padding: 0 0 0 7px;\n    white-space: nowrap;\n    gap: 15px;\n}\n\n@media screen and (max-width: 1024px) {\n    .header-left {\n        display: none;\n    }\n}\n\n\n.header-lang {\n    position: relative;\n}\n\n.header-lang a {\n    font-size: 12px;\n    line-height: 24px;\n    color: #6F707A;\n    height: 24px;\n    margin-right: 24px;\n    display: flex;\n    align-items: center;\n}\n\n@media screen and (max-width: 1024px) {\n    .header-lang a {\n        margin-right: 14px;\n    }\n}\n\n.header-lang a svg {\n    margin-right: 2px;\n}\n\n@media screen and (max-width: 1024px) {\n    .header-lang a svg {\n        margin-right: 5px;\n    }\n}\n\n.header-back {\n    display: flex;\n    flex-direction: column;\n}\n\n.header-back__mobile {\n    padding: 20px;\n    gap: 15px;\n    align-items: center;\n}\n\n.header-back__mobile > div,\n.header-back__mobile > a {\n    text-decoration: none !important;\n    outline: none !important;\n    cursor: pointer;\n    display: block;\n}\n\n.header-back__phone {\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-main);\n    font-family: \"RalewayBold\";\n}\n\n.header-back__all {\n    font-size: 12px;\n    line-height: 16px;\n    color: #6F707A;\n}\n\n.header-back__all svg {\n    display: none;\n}\n\n.header-logo {\n    display: block;\n    margin-top: 7px;\n}\n\n@media screen and (max-width: 1024px) {\n    .header-logo {\n        margin-top: 0;\n    }\n}\n\n.header-logo__img {\n    width: 165px;\n    /*height: 24px;*/\n}\n\n@media screen and (max-width: 1024px) {\n    .header-logo__img {\n        width: 100px;\n    }\n}\n\n.header-right {\n    position: relative;\n    padding: 0;\n}\n\n.header-right__pc {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    width: 256px;\n    position: relative;\n}\n\n@media screen and (max-width: 1024px) {\n    .header-right__pc {\n        display: none;\n    }\n}\n\n.header-lk {\n    width: 24px;\n    height: 24px;\n    margin-right: 23px;\n    position: relative;\n}\n\n.header-lk-auth {\n    font-size: 12px;\n    line-height: 16px;\n    color: var(--color-white);\n    position: absolute;\n    top: -10px;\n    height: 16px;\n    min-width: 16px;\n    right: -10px;\n    text-align: center;\n}\n\n.header-lk-auth:before {\n    content: url(../img/check.svg);\n    height: 16px;\n    width: 16px;\n    display: inline-block;\n}\n\n.header-favorite {\n    width: 24px;\n    height: 24px;\n    position: relative;\n    margin-right: 25px;\n}\n\n.header-auth__wrap {\n    width: 400px;\n    max-width: 100%;\n    margin: 40px auto 0;\n}\n\n.header-auth__container {\n    padding: 20px;\n}\n\n.user-menu {\n\n}\n\n.user-menu__item {\n    box-sizing: border-box;\n    cursor: pointer;\n    padding-top: 20px;\n    padding-bottom: 15px;\n}\n\n.header-auth__wrap .checkout-label__text {\n    font-size: 14px;\n    line-height: 18px;\n}\n\n.header-auth__wrap .checkout-label__text a {\n    color: var(--color-blackberry);\n}\n\n@media screen and (max-width: 1024px) {\n    .header-auth__wrap .checkout-label {\n        display: block;\n    }\n}\n\n.header-auth__label {\n    background: var(--color-light-periwinkle-crayola);\n    border-radius: 4px;\n    display: flex;\n    flex-direction: row;\n}\n\n\n.header-auth__title {\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-granite);\n    margin-bottom: 16px;\n}\n\n.header-auth__title-comment {\n    font-size: 0.8em;\n    color: var(--color-blackberry);\n}\n\n.header-auth__title {\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-granite);\n    margin-bottom: 16px;\n}\n\n.header-auth__title a {\n    color: var(--color-blue-steel);\n}\n\n.header-auth__input {\n    border-radius: 4px;\n    width: 100%;\n    height: 40px;\n    padding: 8px 8px 8px 0;\n    border: none;\n    position: relative;\n    background: transparent;\n    display: inline-block;\n    box-sizing: border-box;\n    font-size: 20px;\n}\n\n@media screen and (max-width: 1024px) {\n}\n\n.header-auth__input:focus {\n    outline: none;\n}\n\n.header-auth__text {\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-blackberry);\n    margin-top: 16px;\n}\n\n.header-auth__btn {\n    display: block;\n    width: 100%;\n    border: none;\n    font-size: 16px;\n    line-height: 24px;\n    text-align: center;\n    font-family: \"RalewaySemiBold\";\n    margin: 16px 0;\n    padding: 8px 0;\n}\n\n.header-auth__email {\n    display: inline-block;\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-blue-steel);\n}\n\n.header-auth__success {\n    position: fixed;\n    top: 16px;\n    right: 16px;\n    border-radius: 16px;\n    background: var(--color-main);\n    width: 320px;\n    height: 92px;\n    padding: 20px 24px;\n    display: none;\n}\n\n@media screen and (max-width: 360px) {\n    .header-auth__success {\n        left: 16px;\n        width: auto;\n    }\n}\n\n.header-auth__success._active {\n    display: block;\n    z-index: 10;\n}\n\n.header-auth__success-close {\n    position: absolute;\n    top: 14px;\n    right: 14px;\n}\n\n.header-auth__success-close svg path {\n    fill: var(--color-white);\n}\n\n.header-auth__success-text {\n    font-size: 20px;\n    line-height: 26px;\n    color: var(--color-white);\n    font-family: \"RalewaySemiBold\";\n}\n\n/* /HEADER */\n/* BURGER MENU */\n.burger {\n    position: absolute;\n    top: 80px;\n    left: 0;\n    width: 100%;\n    background: var(--color-white);\n    box-shadow: 0px 1px 4px rgba(8, 11, 48, 0.2);\n    opacity: 0;\n    visibility: hidden;\n    z-index: 11;\n}\n\n.burger._active {\n    opacity: 1;\n    visibility: visible;\n}\n\n.burger:before {\n    position: absolute;\n    content: '';\n    top: -3px;\n    left: 0;\n    width: 100%;\n    height: 3px;\n    background: var(--color-white);\n}\n\n.burger-menu {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    /*height: 520px;*/\n    /*width: 864px;*/\n    margin: 0 auto;\n    justify-content: center;\n    padding: 20px;\n}\n\n.burger-list {\n    margin-bottom: 27px;\n    margin-right: 48px;\n    width: 180px;\n    margin-top: 20px;\n}\n\n.burger-list:last-child {\n    margin-right: 0;\n}\n\n.burger-item {\n    margin-bottom: 12px;\n}\n\n.burger-item:first-child {\n    font-size: 16px;\n    line-height: 22px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-blackberry);\n}\n\n.burger-item:last-child {\n    margin-bottom: 0;\n}\n\n.burger-link {\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-granite);\n}\n\n/* /BURGER MENU */\n/* LANG */\n.lang {\n    position: absolute;\n    top: 30px;\n    left: 0;\n    width: 160px;\n    background: var(--color-white);\n    box-shadow: 0px 4px 16px rgba(8, 11, 48, 0.2);\n    border-radius: 4px;\n    padding: 16px 22px 16px 20px;\n    opacity: 0;\n    visibility: hidden;\n    z-index: 11;\n}\n\n.lang._active {\n    opacity: 1;\n    visibility: visible;\n}\n\n@media screen and (max-width: 1024px) {\n    .lang {\n        left: initial;\n        right: 0;\n    }\n}\n\n.lang-link {\n    display: block;\n    font-size: 16px !important;\n    line-height: 24px;\n    color: var(--color-granite);\n    padding-left: 36px;\n    margin-bottom: 16px;\n}\n\n.lang-link:last-child {\n    margin-bottom: 0;\n}\n\n.lang-link._active {\n    background: url(\"../svg/check.svg\") no-repeat top left;\n    background-size: 22px 28px;\n}\n\n/* /LANG */\n\n/* ALL CONNECTIONS */\n.connection-list {\n    margin: 64px auto;\n    width: 200px;\n}\n\n.connection-item {\n    margin-bottom: 24px;\n}\n\n.connection-link {\n    font-size: 18px;\n    line-height: 28px;\n    color: var(--color-granite);\n    display: flex;\n    align-items: center;\n}\n\n.connection-link svg {\n    margin-right: 20px;\n}\n\n/* /ALL CONNECTIONS */\n/* MENU MOBILE */\n.menu {\n    position: fixed;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    height: 68px;\n    background: var(--color-light-periwinkle-crayola);\n    display: none;\n    opacity: 0;\n    /*visibility: hidden;*/\n}\n\n.menu-mobile-bottom {\n}\n\n.menu-mobile-bottom .icon {\n    position: relative;\n}\n\n.menu-mobile-bottom .header-count {\n    top: -10px;\n    right: -10px;\n}\n\n@media screen and (max-width: 1024px) {\n    .menu {\n        opacity: 1;\n        visibility: visible;\n        display: block;\n        z-index: 1000;\n    }\n}\n\n.menu-list {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.menu-item {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    min-width: 70px;\n    height: 68px;\n}\n\n@Media screen and (max-width: 350px) {\n    .menu-item {\n        min-width: 60px;\n    }\n}\n\n.menu-item._active {\n    background: var(--color-main);\n}\n\n.menu-item._active .menu-link {\n    color: var(--color-white);\n}\n\n.menu-item._active svg path {\n    fill: #fff;\n}\n\n.menu-item__avatar {\n    border-radius: 50%;\n}\n\n.menu-icon {\n    width: 24px;\n    height: 24px;\n    margin: 0 auto 8px;\n    background-size: contain;\n}\n\n.menu-link {\n    font-size: 10px;\n    line-height: 12px;\n    font-family: \"RalewayMedium\";\n    text-align: center;\n    color: var(--color-blackberry);\n}\n\n.menu-burger {\n    background: url(\"../svg/menu_hamburger.svg\") no-repeat;\n}\n\n.menu-search {\n    background: url(\"../img/search.svg\") no-repeat;\n}\n\n.menu-lk {\n    background: url(\"../svg/user_circle.svg\") no-repeat;\n}\n\n.menu-favorite {\n    background: url(\"../svg/heart_fav_outline.svg\") no-repeat;\n}\n\n.menu-basket {\n    background: url(\"../svg/cart.svg\") no-repeat;\n}\n\n\n/* /OPEN MOBILE MENU */\n\n/* NAV */\n\n\n/* /NAV */\n/* FOOTER */\n.footer {\n    padding-bottom: 54px;\n}\n\n@media screen and (max-width: 1024px) {\n    .footer {\n        padding-bottom: 132px;\n    }\n}\n\n.footer-logo {\n    text-align: center;\n    margin-bottom: 29px;\n}\n\n.footer-menu {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    /*height: 518px;*/\n    /*width: 864px;*/\n    margin: 0 auto;\n    justify-content: center;\n    z-index: 100;\n}\n\n@media screen and (max-width: 1024px) {\n    .footer-menu {\n        width: 180px;\n        height: auto;\n    }\n}\n\n.footer-list {\n    margin-bottom: 32px;\n    margin-right: 48px;\n    width: 180px;\n}\n\n.footer-list__mobile {\n    margin-bottom: 0;\n    margin-right: 0;\n    width: auto;\n}\n\n@media screen and (max-width: 1024px) {\n    .footer-list {\n        display: none;\n    }\n\n    .footer-list:nth-child(3) {\n        margin-right: 0;\n        text-align: center;\n        display: block;\n    }\n}\n\n.footer-list:last-child {\n    margin-right: 0;\n}\n\n.footer-item {\n    margin-bottom: 12px;\n}\n\n.footer-item:first-child {\n    font-size: 16px;\n    line-height: 22px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-blackberry);\n}\n\n.footer-item:last-child {\n    margin-bottom: 0;\n}\n\n.footer-link {\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-granite);\n}\n\n.footer-subscription {\n    text-align: center;\n    height: 198px;\n    background: var(--color-periwinkle-crayola);\n    padding-top: 32px;\n    margin-bottom: 50px;\n}\n\n@media screen and (max-width: 1024px) {\n    .footer-subscription {\n        height: auto;\n        padding: 32px 20px;\n    }\n}\n\n.footer-subscription__title {\n    font-size: 16px;\n    line-height: 22px;\n    font-family: \"RalewaySemiBold\";\n    margin-bottom: 4px;\n    color: var(--color-granite);\n}\n\n.footer-subscription__text {\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--color-blackberry);\n    margin-bottom: 15px;\n}\n\n.footer-subscription__condition {\n    font-size: 12px;\n    line-height: 16px;\n    color: var(--color-blackberry);\n    margin-top: 16px;\n}\n\n.footer-subscription__condition a {\n    font-size: 12px;\n    line-height: 16px;\n    color: var(--color-blackberry);\n    text-decoration: underline;\n}\n\n.footer-form {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.footer-form__label {\n    width: 320px;\n    position: relative;\n}\n\n.footer-form__label:before {\n    position: absolute;\n    content: '';\n    left: 12px;\n    top: 8px;\n    width: 24px;\n    height: 24px;\n    background: url(\"../svg/mail_envelope.svg\") no-repeat;\n    background-size: contain;\n}\n\n.footer-form__input {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blackberry);\n    padding: 8px 0 8px 44px;\n    font-family: \"RalewayRegular\";\n    width: 100%;\n    height: 40px;\n    border-radius: 4px;\n    background: var(--color-white);\n    border: none;\n}\n\n.footer-form__input:focus {\n    outline: none;\n}\n\n.footer-form__btn {\n    flex-shrink: 0;\n    width: 40px;\n    height: 40px;\n    border: none;\n    margin-left: 8px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.footer-form__btn:focus {\n    outline: none;\n}\n\n.footer-soc {\n    margin: 16px 0 48px 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.footer-soc__link {\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    background: var(--color-periwinkle-crayola);\n    margin-right: 16px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n@media screen and (max-width: 767px) {\n    .footer-soc__link {\n        width: 44px;\n        height: 44px;\n        margin-right: 8px;\n    }\n}\n\n.footer-soc__link:last-child {\n    margin-right: 0;\n}\n\n.footer-bottom {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n@media screen and (max-width: 767px) {\n    .footer-bottom {\n        flex-direction: column;\n    }\n}\n\n.footer-bottom__item {\n    margin-right: 24px;\n}\n\n@media screen and (max-width: 767px) {\n    .footer-bottom__item {\n        margin-right: 0;\n    }\n}\n\n.footer-bottom__item:last-child {\n    margin-right: 0;\n}\n\n.footer-bottom__link {\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--color-blackberry);\n}\n\n.footer-copy {\n    margin-top: 16px;\n    text-align: center;\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--color-blackberry);\n    text-transform: uppercase;\n}\n\n/* /FOOTER */\n/* BREADCRUMBS */\n.breadcrumbs {\n    font-size: 12px;\n    line-height: 20px;\n    color: var(--color-blackberry);\n    text-align: center;\n    margin-top: 13px;\n}\n\n@media screen and (max-width: 1024px) {\n    .breadcrumbs {\n        display: none;\n    }\n}\n\n.breadcrumbs-link {\n    margin-right: 20px;\n    color: var(--color-blackberry);\n}\n\n.breadcrumbs-arrow {\n    position: relative;\n}\n\n.breadcrumbs-arrow:after {\n    position: absolute;\n    content: '';\n    top: 2px;\n    right: -15px;\n    width: 10px;\n    height: 10px;\n    background: url(\"../svg/chevron_right.svg\") no-repeat;\n    background-size: contain;\n}\n\n/* /BREADCRUMBS */\n/* CATALOG */\n.catalog {\n    margin-top: 56px;\n}\n\n@media screen and (max-width: 1024px) {\n    .catalog {\n        margin-top: 22px;\n    }\n}\n\n.catalog-wrap {\n    display: flex;\n}\n\n@media screen and (max-width: 1024px) {\n    .catalog-wrap {\n        flex-direction: column;\n    }\n}\n\n.catalog-right {\n    width: 100%;\n    margin-left: 60px;\n}\n\n@media screen and (max-width: 1170px) {\n    .catalog-right {\n        margin-left: 30px;\n    }\n}\n\n@media screen and (max-width: 1024px) {\n    .catalog-right {\n        margin-left: 0;\n    }\n}\n\n.catalog-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n@media screen and (max-width: 1024px) {\n    .catalog-top._fixed {\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 32px;\n        background: var(--color-white);\n        z-index: 11;\n        padding: 15px;\n    }\n\n    /*\n        .catalog-top._fixed .catalog-filter {\n            margin-top: 0;\n        }\n\n     */\n}\n\n/*\n.catalog-filter {\n    display: flex;\n    align-items: center;\n}\n\n@media screen and (max-width: 1024px) {\n    .catalog-filter {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        width: 100%;\n        margin-top: 42px;\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .catalog-filter {\n        margin-top: 13px;\n    }\n}\n\n.catalog-filter__item {\n    position: relative;\n    display: inline-block;\n    cursor: pointer;\n    margin-right: 8px;\n}\n\n@media screen and (max-width: 1024px) {\n    .catalog-filter__item {\n        display: block;\n        flex-shrink: 0;\n    }\n}\n\n.catalog-filter__item:first-child .catalog-filter__title {\n    padding: 4px 12px 4px 9px;\n}\n\n@media screen and (max-width: 1024px) {\n    .catalog-filter__item:first-child .catalog-filter__title {\n        border: none;\n        margin-right: 0;\n    }\n}\n\n.catalog-filter__item:first-child .catalog-filter__wrap {\n    width: 240px;\n}\n\n.catalog-filter__item:last-child {\n    margin-right: 0;\n}\n\n.catalog-filter__item:last-child._active span:first-child {\n    display: none;\n}\n\n.catalog-filter__item:last-child._active .catalog-filter__count {\n    font-size: 14px;\n    line-height: 20px;\n    font-family: \"RalewayRegular\";\n    background: transparent;\n    color: var(--color-main);\n    margin-left: 0;\n}\n\n@media screen and (max-width: 1024px) {\n    .catalog-filter__item:last-child._active .catalog-filter__count {\n        font-size: 16px;\n        line-height: 22px;\n        font-family: \"RalewayRegular\";\n        color: var(--color-blackberry);\n    }\n}\n\n.catalog-filter__item._active {\n    background: var(--color-light-periwinkle-crayola);\n}\n\n@media screen and (max-width: 1024px) {\n    .catalog-filter__item._active {\n        background: var(--color-white);\n    }\n}\n\n.catalog-filter__link {\n    display: none;\n    font-size: 14px;\n    line-height: 22px;\n    color: var(--color-main);\n}\n\n.catalog-filter__link svg {\n    width: 18px;\n    height: 16px;\n    margin-right: 11px;\n}\n\n.catalog-filter__link svg path {\n    fill: var(--color-gray-window);\n}\n\n@media screen and (max-width: 1024px) {\n    .catalog-filter__link {\n        display: flex;\n        align-items: center;\n        margin-left: 42px;\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .catalog-filter__link {\n        margin-left: 15px;\n    }\n}\n\n.catalog-filter__mobile {\n    display: flex;\n}\n\n@media screen and (max-width: 1024px) {\n    .catalog-filter__mobile {\n        display: none;\n        opacity: 0;\n        visibility: hidden;\n        position: fixed;\n        bottom: 0;\n        left: 0;\n        height: calc(100vh - 32px);\n        width: 100%;\n        background: var(--color-white);\n        box-shadow: 0px 4px 16px rgba(8, 11, 48, 0.2);\n        padding: 12px 16px 16px 20px;\n        z-index: 51;\n    }\n\n    .catalog-filter__mobile._active {\n        display: block;\n        opacity: 1;\n        visibility: visible;\n    }\n\n    .catalog-filter__mobile .catalog-filter__item {\n        border-bottom: 1px solid var(--color-light-periwinkle-crayola);\n    }\n\n    .catalog-filter__mobile .catalog-filter__item:first-child {\n        border-top: 1px solid var(--color-light-periwinkle-crayola);\n    }\n\n    .catalog-filter__mobile .catalog-filter__title {\n        font-size: 20px;\n        line-height: 22px;\n        font-family: \"RalewaySemiBold\";\n        border: none;\n        padding: 15px 0;\n        display: flex;\n        align-items: center;\n        height: auto;\n    }\n\n    .catalog-filter__mobile .catalog-filter__title svg {\n        width: 18px;\n        height: 18px;\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .catalog-filter__mobile .catalog-filter__title {\n        font-size: 16px;\n        line-height: 22px;\n        padding: 18px 0 12px 0;\n    }\n}\n\n.catalog-filter__mobile-top {\n    display: none;\n}\n\n@media screen and (max-width: 1024px) {\n    .catalog-filter__mobile-top {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 40px;\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .catalog-filter__mobile-top {\n        margin-bottom: 27px;\n    }\n}\n\n.catalog-filter__mobile-title {\n    font-size: 20px;\n    line-height: 26px;\n    color: var(--color-granite);\n    font-family: \"RalewaySemiBold\";\n}\n\n.catalog-filter__mobile-close {\n    width: 32px;\n    height: 32px;\n    cursor: pointer;\n    border-radius: 50%;\n    background: var(--color-periwinkle-crayola);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-right: 20px;\n}\n\n.catalog-filter__mobile .catalog-filter__text {\n    padding-left: 29px;\n}\n\n.catalog-filter__title {\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--color-main);\n    padding: 4px 12px 4px 12px;\n    border: 1px solid var(--color-light-periwinkle-crayola);\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    height: 30px;\n    position: relative;\n}\n\n.catalog-filter__title svg {\n    width: 24px;\n    height: 24px;\n    margin-right: 2px;\n}\n\n.catalog-filter__count {\n    font-size: 10px;\n    line-height: 16px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-white);\n    background: var(--color-main);\n    border-radius: 50%;\n    display: none;\n    margin-left: 8px;\n    padding: 0 5px 0 4px;\n    text-align: center;\n    width: 100%;\n}\n\n@media screen and (max-width: 1024px) {\n    .catalog-filter__count {\n        padding: 0 4px;\n    }\n}\n\n.catalog-filter__count._active {\n    display: inline-block;\n}\n\n@media screen and (max-width: 1024px) {\n    .catalog-filter__count._active {\n        width: auto;\n    }\n}\n\n.catalog-filter__wrap {\n    display: none;\n    background: var(--color-white);\n    box-shadow: 0px 4px 16px rgba(8, 11, 48, 0.2);\n    border-radius: 4px;\n    position: absolute;\n    top: 40px;\n    left: 0;\n    width: 260px;\n    padding: 16px 16px 16px 20px;\n    z-index: 5;\n}\n\n@media screen and (max-width: 1024px) {\n    .catalog-filter__wrap {\n        position: fixed;\n        bottom: 0;\n        left: 0;\n        width: 100% !important;\n        height: calc(100vh - 32px);\n        z-index: 51;\n    }\n}\n\n.catalog-filter__wrap._active {\n    display: block;\n}\n\n.catalog-filter__wrap-max {\n    width: 260px;\n    height: 400px;\n    overflow: hidden;\n    padding: 0 0 16px 20px;\n}\n\n@media screen and (max-width: 1024px) {\n    .catalog-filter__wrap-max {\n        width: 100%;\n        top: 32px;\n        height: calc(100vh - 32px);\n    }\n}\n\n.catalog-filter__wrap-max .catalog-filter__text:before {\n    position: absolute;\n    content: '';\n    left: 0;\n    top: 2px;\n    width: 20px;\n    height: 20px;\n    background: var(--color-light-periwinkle-crayola);\n    border-radius: 3px;\n}\n\n.catalog-filter__wrap-back {\n    display: none;\n}\n\n@media screen and (max-width: 1024px) {\n    .catalog-filter__wrap-back {\n        display: flex;\n        align-items: center;\n        font-size: 20px;\n        line-height: 26px;\n        color: var(--color-granite);\n        margin-top: 18px;\n    }\n\n    .catalog-filter__wrap-back svg {\n        width: 21px;\n        height: 21px;\n        margin-right: 21px;\n    }\n}\n\n.catalog-filter__wrap-count {\n    display: none;\n}\n\n@media screen and (max-width: 1024px) {\n    .catalog-filter__wrap-count {\n        display: inline-block;\n        font-size: 18px;\n        line-height: 24px;\n        color: var(--color-blackberry);\n        margin-left: 10px;\n    }\n}\n\n.catalog-filter__scroll {\n    height: 344px;\n    overflow-y: auto;\n    padding-top: 16px;\n    padding-right: 16px;\n    padding-bottom: 16px;\n}\n\n@media screen and (max-width: 1024px) {\n    .catalog-filter__scroll {\n        height: 100%;\n    }\n}\n\n.catalog-filter__min {\n    height: 200px;\n}\n\n@media screen and (max-width: 1024px) {\n    .catalog-filter__min {\n        padding-top: 16px;\n    }\n}\n\n.catalog-filter__label {\n    display: block;\n    width: 100%;\n    margin-bottom: 8px;\n}\n\n.catalog-filter__label:last-child {\n    margin-bottom: 0;\n}\n\n.catalog-filter__radio {\n    opacity: 0;\n    visibility: hidden;\n    z-index: -1;\n    position: absolute;\n}\n\n.catalog-filter__radio:checked + .catalog-filter__text:after {\n    position: absolute;\n    content: '';\n    left: -4px;\n    top: 0;\n    width: 24px;\n    height: 24px;\n    background: url(\"../svg/check-main.svg\") no-repeat;\n    background-size: contain;\n}\n\n.catalog-filter__check {\n    opacity: 0;\n    visibility: hidden;\n    z-index: -1;\n    position: absolute;\n}\n\n.catalog-filter__check:checked + .catalog-filter__text:after {\n    position: absolute;\n    content: '';\n    left: 0;\n    top: 1px;\n    width: 20px;\n    height: 20px;\n    background: url(\"../svg/check-white.svg\") no-repeat var(--color-main);\n    background-size: contain;\n    border-radius: 3px;\n}\n\n.catalog-filter__check-clear {\n    width: 20px;\n    height: 20px;\n    display: none;\n    margin-left: 10px;\n}\n\n.catalog-filter__check-clear svg {\n    width: 20px;\n    height: 20px;\n}\n\n.catalog-filter__check-clear._active {\n    display: block;\n    z-index: 2;\n}\n\n@media screen and (max-width: 1024px) {\n    .catalog-filter__check-clear._active {\n        position: absolute;\n        right: 24px;\n        top: 50%;\n        -webkit-transform: translateY(-50%);\n        transform: translateY(-50%);\n        width: 18px;\n        height: 18px;\n    }\n}\n\n.catalog-filter__text {\n    position: relative;\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n    padding-left: 36px;\n    display: flex;\n    align-items: center;\n}\n\n.catalog-filter__color {\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    display: inline-block;\n    margin-right: 8px;\n}\n\n.catalog-filter__buttons {\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    height: 56px;\n    background: var(--color-white);\n    border-top: 1px solid var(--color-light-periwinkle-crayola);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.catalog-filter__success {\n    font-size: 14px;\n    line-height: 22px;\n    border: 1px solid var(--color-main);\n    height: 32px;\n    width: 106px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-right: 8px;\n}\n\n.catalog-filter__clear {\n    font-size: 14px;\n    line-height: 22px;\n    color: var(--color-main);\n    background: var(--color-white);\n    border: 1px solid var(--color-pale-blue);\n    border-radius: 4px;\n    height: 32px;\n    width: 106px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.catalog-filter__search {\n    position: relative;\n    display: block;\n    margin-bottom: 18px;\n}\n\n.catalog-filter__search:before {\n    position: absolute;\n    content: '';\n    top: 8px;\n    left: 10px;\n    width: 24px;\n    height: 24px;\n    background: url(\"../svg/search.svg\") no-repeat;\n    background-size: contain;\n}\n\n.catalog-filter__search-input {\n    border-radius: 4px;\n    background: var(--color-light-periwinkle-crayola);\n    height: 40px;\n    width: 100%;\n    padding: 8px 8px 8px 44px;\n    display: block;\n    border: none;\n}\n\n.catalog-filter__search-input:focus {\n    outline: none;\n}\n\n.catalog-filter__search-input:active {\n    outline: none;\n}\n\n.catalog-filter__search-clear {\n    position: absolute;\n    top: 7px;\n    right: 12px;\n    opacity: 0;\n    visibility: hidden;\n}\n\n.catalog-filter__search-clear._active {\n    opacity: 1;\n    visibility: visible;\n}\n\n.catalog-filter__price {\n    margin-top: 8px;\n    margin-bottom: 34px;\n}\n\n.catalog-filter__price-input {\n    background: var(--color-light-periwinkle-crayola);\n    border-radius: 4px;\n    border: none;\n    padding: 8px 12px;\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-gray-window);\n    height: 40px;\n    width: 87px;\n}\n\n.catalog-filter__price-input::-webkit-outer-spin-button, .catalog-filter__price-input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.catalog-filter__price-input:focus {\n    outline: none;\n}\n\n.catalog-filter__price-input:active {\n    outline: none;\n}\n\n@media screen and (max-width: 1024px) {\n    .catalog-filter__price-input {\n        width: 44%;\n    }\n}\n\n@media screen and (max-width: 440px) {\n    .catalog-filter__price-input {\n        width: 42%;\n    }\n}\n\n@media screen and (max-width: 340px) {\n    .catalog-filter__price-input {\n        width: 41%;\n    }\n}\n\n.catalog-filter__price-min {\n    margin-right: 4px;\n}\n\n.catalog-filter__price-max {\n    margin: 0 4px;\n}\n\n.catalog-filter__range {\n    position: relative;\n    margin-bottom: 20px;\n    display: block;\n    padding-bottom: 20px;\n}\n\n.catalog-filter__range-input {\n    pointer-events: none;\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    outline: none;\n    margin: 0;\n    padding: 0;\n    border-radius: 8px;\n    -webkit-appearance: none;\n    height: 4px;\n    background: var(--color-main);\n}\n\n.catalog-filter__range-input::-webkit-slider-thumb {\n    pointer-events: all;\n    position: relative;\n    z-index: 1;\n    outline: 0;\n    -webkit-appearance: none;\n    height: 16px;\n    width: 16px;\n    border-radius: 12px;\n}\n\n.catalog-filter__range-input::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    appearance: none;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    border: 2px solid #fff;\n    background: var(--color-white);\n    cursor: pointer;\n    box-shadow: 0px 1px 4px rgba(8, 11, 48, 0.2);\n}\n\n.catalog-filter__range-input::-webkit-scrollbar-button {\n    width: 4px;\n}\n\n.catalog-filter__range-input::-webkit-resizer {\n    width: 3px;\n}\n\n.catalog-filter__range-input::-webkit-scrollbar {\n    width: 3px;\n}\n*/\n.catalog-grid {\n    display: flex;\n    align-items: center;\n    border: 1px solid var(--color-light-periwinkle-crayola);\n    border-radius: 4px;\n}\n\n@media screen and (max-width: 1024px) {\n    .catalog-grid {\n        display: none;\n    }\n}\n\n.catalog-grid__item {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 40px;\n    height: 32px;\n    cursor: pointer;\n}\n\n.catalog-grid__item svg {\n    width: 20px;\n    height: 20px;\n}\n\n.catalog-grid__item._active {\n    cursor: initial;\n    background: var(--color-light-periwinkle-crayola);\n}\n\n.catalog-grid__item._active svg path {\n    fill: var(--color-granite);\n}\n\n/* PRODUCT */\n.product-grid__3 .product-item {\n    width: calc(33.33333% - 32px);\n}\n\n@media screen and (max-width: 1300px) {\n    .product-grid__3 .product-item {\n        width: calc(33.33333% - 16px);\n        margin: 0 8px 16px 8px;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .product-grid__3 .product-item {\n        width: calc(50% - 16px);\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .product-grid__3 .product-item {\n        width: calc(50% - 8px);\n        margin: 0 4px 16px 4px;\n    }\n}\n\n.product-grid__3 .product-item__img {\n    height: 494px;\n}\n\n@media screen and (max-width: 1300px) {\n    .product-grid__3 .product-item__img {\n        height: 440px;\n    }\n}\n\n@media screen and (max-width: 1200px) {\n    .product-grid__3 .product-item__img {\n        height: 380px;\n    }\n}\n\n@media screen and (max-width: 440px) {\n    .product-grid__3 .product-item__img {\n        height: 260px;\n    }\n}\n\n.product-grid__3 .product-banner {\n    width: calc(33.33333% - 32px);\n}\n\n@media screen and (max-width: 767px) {\n    .product-grid__3 .product-banner {\n        width: calc(50% - 32px);\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .product-grid__3 .product-banner {\n        width: calc(50% - 8px);\n    }\n}\n\n.product-grid__3 .product-banner__img {\n    height: 494px;\n}\n\n@media screen and (max-width: 1300px) {\n    .product-grid__3 .product-banner__img {\n        height: 440px;\n    }\n}\n\n@media screen and (max-width: 1200px) {\n    .product-grid__3 .product-banner__img {\n        height: 380px;\n    }\n}\n\n@media screen and (max-width: 440px) {\n    .product-grid__3 .product-banner__img {\n        height: 260px;\n    }\n}\n\n.product-grid__4 .product-item,\n.product-grid__4 .product-banner {\n    width: calc(25% - 32px);\n}\n\n@media screen and (max-width: 1350px) {\n    .product-grid__4 .product-item,\n    .product-grid__4 .product-banner {\n        margin: 0 8px 32px 8px;\n        width: calc(25% - 16px);\n    }\n}\n\n@media screen and (max-width: 1024px) {\n    .product-grid__4 .product-item,\n    .product-grid__4 .product-banner {\n        width: calc(33.33333% - 16px);\n        margin: 0 8px 32px 8px;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .product-grid__4 .product-item,\n    .product-grid__4 .product-banner {\n        width: calc(50% - 16px);\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .product-grid__4 .product-item,\n    .product-grid__4 .product-banner {\n        width: calc(50% - 8px);\n        margin: 0 4px 32px 4px;\n    }\n}\n\n.product-grid__4 .product-item__img,\n.product-grid__4 .product-banner__img {\n    height: 360px;\n}\n\n@media screen and (max-width: 1300px) {\n    .product-grid__4 .product-item__img,\n    .product-grid__4 .product-banner__img {\n        height: 320px;\n    }\n}\n\n@media screen and (max-width: 1200px) {\n    .product-grid__4 .product-item__img,\n    .product-grid__4 .product-banner__img {\n        height: 280px;\n    }\n}\n\n@media screen and (max-width: 1024px) {\n    .product-grid__4 .product-item__img,\n    .product-grid__4 .product-banner__img {\n        height: 380px;\n    }\n}\n\n@media screen and (max-width: 440px) {\n    .product-grid__4 .product-item__img,\n    .product-grid__4 .product-banner__img {\n        height: 260px;\n    }\n}\n\n.product-grid__4 .product-banner__full img {\n    height: 100%;\n}\n\n@media screen and (max-width: 1440px) {\n    .product-grid__4 .product-item__color {\n        position: relative;\n        top: initial;\n        right: initial;\n        margin-top: 4px;\n    }\n}\n\n@media screen and (max-width: 1440px) {\n    .product-grid__4 .product-item__color-item {\n        margin-right: 6px;\n        margin-left: 0;\n    }\n}\n\n.product-list {\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: 30px;\n}\n\n@media screen and (max-width: 576px) {\n    .product-list {\n        margin-top: 15px;\n    }\n}\n\n.product-item {\n    position: relative;\n    display: block;\n    margin: 0 16px 32px 16px;\n}\n\n@media screen and (max-width: 576px) {\n    .product-item {\n        margin: 0 4px 32px 4px;\n    }\n}\n\n.product-item:hover .product-item__favorite {\n    display: block;\n}\n\n.product-item:hover .product-item__fast {\n    display: flex;\n}\n\n.product-item__favorite {\n    position: absolute;\n    top: 24px;\n    right: 24px;\n    display: none;\n    width: 24px;\n    height: 24px;\n    background: url(\"../svg/heart_fav_outline.svg\") no-repeat;\n    background-size: contain;\n    z-index: 2;\n}\n\n@media screen and (max-width: 576px) {\n    .product-item__favorite {\n        top: 14px;\n        right: 14px;\n    }\n}\n\n.product-item__favorite._active {\n    background: url(\"../svg/heart_fav_solid-active-blue.svg\") no-repeat;\n    background-size: contain;\n}\n\n.product-item__actions {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: 16px;\n    left: 16px;\n    z-index: 1;\n}\n\n.product-item__actions__item {\n    display: flex;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    font-size: 12px;\n    line-height: 20px;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 15px;\n}\n\n.product-item__news {\n    background: var(--color-blue-steel);\n    color: var(--color-white);\n}\n\n@media screen and (max-width: 576px) {\n    .product-item__actions__item {\n        width: 28px;\n        height: 28px;\n        top: 8px;\n        left: 8px;\n        font-size: 9px;\n    }\n}\n\n.product-item__discount {\n    background: var(--color-yellow-pink);\n    color: var(--color-white);\n}\n\n@media screen and (max-width: 576px) {\n    .product-item__discount {\n    }\n}\n\n.product-item__wrapper {\n    position: relative;\n}\n\n.product-item__link {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n    text-align: center;\n}\n\n.product-item__img {\n    width: 100%;\n    height: auto;\n    -o-object-fit: contain;\n    object-fit: contain;\n    display: block;\n}\n\n@media screen and (max-width: 576px) {\n    .product-item__img {\n        height: 260px;\n    }\n}\n\n.product-item__body {\n    margin-top: 16px;\n    position: relative;\n}\n\n@media screen and (max-width: 576px) {\n    .product-item__body {\n        margin-top: 12px;\n    }\n}\n\n.product-item__color {\n    display: flex;\n    align-items: center;\n    margin-top: 4px;\n    justify-content: center;\n}\n\n@media screen and (max-width: 1140px) {\n    .product-item__color {\n        position: relative;\n        top: initial;\n        right: initial;\n        margin-top: 4px;\n    }\n}\n\n.product-item__color-item {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    margin-right: 6px;\n    border: 1px solid #bbbbbb;\n}\n\n@media screen and (max-width: 1140px) {\n    .product-item__color-item {\n        margin-right: 6px;\n        margin-left: 0;\n    }\n}\n\n.product-item__color-more {\n    background: var(--color-light-periwinkle-crayola);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.product-item__prices {\n    display: flex;\n    align-items: center;\n    margin-top: 4px;\n    justify-content: center;\n}\n\n.product-item__new {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n    font-family: \"RalewaySemiBold\";\n    margin-right: 8px;\n}\n\n.product-item__old {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blackberry);\n    text-decoration: line-through;\n}\n\n.product-item__size {\n    margin-top: 4px;\n    font-size: 12px;\n    line-height: 20px;\n    color: var(--color-blackberry);\n    text-transform: uppercase;\n}\n\n.product-item__fast {\n    display: none;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    bottom: 32px;\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n    transform: translateX(-50%);\n    width: 185px;\n    height: 32px;\n    border-radius: 4px;\n    padding: 5px 10px;\n    background: rgba(255, 255, 255, 0.8);\n    font-size: 14px;\n    line-height: 22px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-main);\n}\n\n.product-item__fast._inactive {\n    display: none !important;\n}\n\n.product-item__fast svg {\n    margin-right: 8px;\n}\n\n.product-banner {\n    margin: 0 16px;\n}\n\n@media screen and (max-width: 576px) {\n    .product-banner {\n        margin: 0 4px;\n    }\n}\n\n.product-banner__full {\n    width: 100%;\n    height: 140px;\n    margin: 16px 16px 49px 16px;\n    overflow: hidden;\n}\n\n@media screen and (max-width: 1024px) {\n    .product-banner__full {\n        margin: 0 4px 32px 4px;\n        height: 200px;\n    }\n}\n\n.product-banner__full .product-banner__img {\n    height: 140px;\n}\n\n.product-banner__full .product-banner__img:last-child {\n    display: none;\n}\n\n@media screen and (max-width: 576px) {\n    .product-banner__full .product-banner__img:first-child {\n        display: none;\n    }\n\n    .product-banner__full .product-banner__img:last-child {\n        display: block;\n        height: 200px;\n        -o-object-fit: cover;\n        object-fit: cover;\n    }\n}\n\n.product-banner__fix {\n    height: 92px;\n}\n\n.product-banner__img {\n    display: block;\n    width: 100%;\n    max-height: 576px;\n    height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover;\n}\n\n@media screen and (max-width: 1600px) {\n    .product-banner__img {\n        height: 494px;\n    }\n}\n\n@media screen and (max-width: 1300px) {\n    .product-banner__img {\n        height: 440px;\n    }\n}\n\n@media screen and (max-width: 1200px) {\n    .product-banner__img {\n        height: 380px;\n    }\n}\n\n@media screen and (max-width: 440px) {\n    .product-banner__img {\n        height: 260px;\n    }\n}\n\n.product .curtain-wrap {\n    width: 800px;\n    padding-bottom: 100px;\n}\n\n@media screen and (max-width: 1024px) {\n    .product .curtain-wrap {\n        width: 100%;\n    }\n}\n\n.product-wrap {\n    display: flex;\n    position: relative;\n}\n\n@media screen and (max-width: 767px) {\n    .product-wrap {\n        flex-direction: column;\n    }\n}\n\n.product-wrap .detail-left {\n    width: 66%;\n}\n\n.product-wrap .detail-right {\n    width: 34%;\n}\n\n@media screen and (max-width: 767px) {\n    .product-wrap .detail-right {\n        margin: 0 auto;\n    }\n}\n\n.product-wrap .detail-full img,\n.product-wrap .detail-full .detail-full__video {\n    width: 100%;\n    max-width: 312px;\n    height: 467px;\n}\n\n.product-wrap .detail-informations {\n    margin-left: 0;\n}\n\n.product-wrap .detail-prices {\n    flex-wrap: wrap;\n}\n\n.product-wrap .detail-full__prev {\n    left: 0;\n}\n\n.product-wrap .detail-full__next {\n    right: 0;\n}\n\n.product-more {\n    position: fixed;\n    bottom: 32px;\n    right: 64px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 4px;\n    background: var(--color-light-periwinkle-crayola);\n    height: 48px;\n    max-width: 672px;\n    width: 100%;\n    font-size: 16px;\n    line-height: 24px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-main);\n    z-index: 10;\n}\n\n/* /CATALOG */\n/* ASIDE */\n.aside {\n    max-width: 180px;\n    width: 100%;\n    align-self: baseline;\n    flex-shrink: 0;\n}\n\n@media screen and (max-width: 1170px) {\n    .aside {\n        max-width: 180px;\n    }\n}\n\n@media screen and (max-width: 1024px) {\n    .aside {\n        max-width: 100%;\n        text-align: center;\n    }\n}\n\n.aside-title {\n    font-size: 24px;\n    line-height: 32px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-granite);\n    margin-bottom: 4px;\n    padding: 0 8px;\n}\n\n@media screen and (max-width: 576px) {\n    .aside-title {\n        font-size: 20px;\n        line-height: 26px;\n        margin-bottom: 8px;\n    }\n}\n\n.aside-count {\n    font-size: 12px;\n    line-height: 20px;\n    color: var(--color-blackberry);\n    padding: 0 8px;\n}\n\n@media screen and (max-width: 1024px) {\n    .aside-count {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n}\n\n.aside-all {\n    font-size: 16px;\n    line-height: 24px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-granite);\n    display: block;\n    padding: 4px 8px;\n    background: var(--color-light-periwinkle-crayola);\n    border-radius: 4px;\n    margin: 24px 8px 32px 8px;\n}\n\n@media screen and (max-width: 1024px) {\n    .aside-all {\n        text-align: center;\n        background: var(--color-white);\n        border: 1px solid var(--color-pale-blue);\n        margin: 20px 8px 8px 8px;\n        padding: 7px 8px;\n    }\n}\n\n.aside-all span {\n    font-size: 12px;\n    line-height: 20px;\n    color: var(--color-gray-window);\n    font-family: \"RalewayRegular\";\n}\n\n.aside-subtitle {\n    font-size: 16px;\n    line-height: 22px;\n    font-weight: 500;\n    color: var(--color-blackberry);\n    text-transform: uppercase;\n    padding: 0 8px;\n}\n\n@media screen and (max-width: 1024px) {\n    .aside-subtitle {\n        display: none;\n    }\n}\n\n.aside-other .aside-mobile {\n    height: calc(100vh - 60px);\n}\n\n.aside-other .aside-mobile .curtain-wrap {\n    height: 100%;\n    padding-bottom: 36px;\n}\n\n.aside-other .accordion {\n    margin: 16px 8px 32px 8px;\n}\n\n@media screen and (max-width: 1024px) {\n    .aside-other .accordion {\n        display: none;\n    }\n}\n\n.aside-other .aside-subtitle {\n    padding: 0 16px;\n}\n\n.aside-other .accordion-title span,\n.aside-other .accordion-link span {\n    font-size: 12px;\n    line-height: 20px;\n    color: var(--color-gray-window);\n    font-family: \"RalewayRegular\";\n}\n\n/* /ASIDE */\n/* ACCORDION */\n.accordion {\n    margin: 32px 0;\n}\n\n@media screen and (max-width: 1024px) {\n    .accordion {\n        margin-top: 0;\n        margin-bottom: 8px;\n    }\n}\n\n.accordion-block {\n    margin-bottom: 8px;\n}\n\n.accordion-block._active .accordion-arrow {\n    -webkit-transform: scaleY(-1);\n    transform: scaleY(-1);\n    margin-right: 4px;\n}\n\n.accordion-block._active .accordion-body {\n    display: block;\n}\n\n@media screen and (max-width: 1024px) {\n    .accordion-block {\n        display: none;\n    }\n\n    .accordion-block:first-child {\n        display: block;\n    }\n}\n\n.accordion-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-radius: 4px;\n}\n\n@media screen and (max-width: 1024px) {\n    .accordion-top {\n        display: none;\n    }\n}\n\n.accordion-top._active {\n    background: var(--color-light-periwinkle-crayola);\n}\n\n.accordion-title {\n    padding: 4px 8px;\n    font-size: 16px;\n    line-height: 22px;\n}\n\n.accordion-down {\n    font-size: 16px;\n    line-height: 24px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-granite);\n}\n\n.accordion-arrow {\n    -webkit-transform: scaleY(1);\n    transform: scaleY(1);\n    cursor: pointer;\n    transition: all .3s linear;\n}\n\n.accordion-body {\n    display: none;\n}\n\n@media screen and (max-width: 1024px) {\n    .accordion-body {\n        display: block;\n        overflow-x: auto;\n    }\n}\n\n.accordion-list {\n    margin-top: 13px;\n}\n\n@media screen and (max-width: 1024px) {\n    .accordion-list {\n        display: flex;\n        align-items: center;\n        width: 1000px;\n        margin-top: 6px;\n    }\n}\n\n.accordion-item {\n    margin-bottom: 18px;\n    position: relative;\n    border-radius: 4px;\n}\n\n@media screen and (max-width: 1024px) {\n    .accordion-item {\n        margin-bottom: 0;\n    }\n\n    .accordion-item:before {\n        content: '•';\n    }\n\n    .accordion-item:first-child:before {\n        display: none;\n    }\n}\n\n.accordion-item._active {\n    background: var(--color-light-periwinkle-crayola);\n}\n\n.accordion-item:last-child {\n    margin-bottom: 0;\n}\n\n.accordion-link {\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-granite);\n    padding: 5px 8px;\n    display: block;\n}\n\n/* /ACCORDION */\n/* PAGINATIONS */\n.paginations-more {\n    display: block;\n    width: 100%;\n    font-size: 16px;\n    line-height: 24px;\n    text-align: center;\n    color: var(--color-main);\n    padding: 12px 0;\n    border: 1px solid var(--color-pale-blue);\n    border-radius: 4px;\n    margin-bottom: 15px;\n}\n\n@media screen and (max-width: 576px) {\n    .paginations-more {\n        margin-bottom: 20px;\n    }\n}\n\n.paginations {\n    margin-top: 15px;\n    margin-bottom: 15px;\n}\n\n.paginations-wrap {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n}\n\n.paginations-prev, .paginations-next {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-gray-blue);\n    border: 1px solid var(--color-pale-blue);\n    border-radius: 4px;\n    padding: 4px 8px;\n    height: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n@media screen and (max-width: 767px) {\n    .paginations-prev {\n        display: none;\n    }\n}\n\n.paginations-prev svg {\n    margin-right: 12px;\n}\n\n@media screen and (max-width: 767px) {\n    .paginations-next {\n        display: none;\n    }\n}\n\n.paginations-next svg {\n    margin-left: 12px;\n}\n\n.paginations-list {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 0;\n}\n\n@media screen and (max-width: 767px) {\n    .paginations-list {\n        width: 100%;\n    }\n}\n\n.paginations-item {\n    margin-right: 8px;\n}\n\n.paginations-item:last-child {\n    margin-right: 0;\n}\n\n.paginations-item__ellipsis .paginations-link {\n    width: 20px;\n    border: none;\n}\n\n.paginations-link {\n    font-size: 16px;\n    line-height: 25px;\n    color: var(--color-gray-blue);\n    border-radius: 4px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid var(--color-pale-blue);\n    width: 40px;\n    height: 40px;\n}\n\n.paginations-link._active {\n    color: var(--color-white);\n    border: 1px solid var(--color-main);\n    background: var(--color-main);\n}\n\n/* /PAGINATIONS */\n/* LIKED */\n.liked {\n    position: relative;\n    margin: 144px 0 120px 0;\n    overflow: hidden;\n}\n\n@media screen and (max-width: 1024px) {\n    .liked {\n        margin: 63px 0;\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .liked {\n        margin: 50px 0;\n    }\n}\n\n.liked .product-item__favorite {\n    top: 9px;\n    right: 7px;\n}\n\n.liked .container {\n    overflow: hidden;\n}\n\n/* /LIKED */\n/* SLIDER */\n.slider {\n    position: relative;\n}\n\n.slider._noslider .slider-container {\n    justify-content: center;\n}\n\n.slider._noslider .slider-prev,\n.slider._noslider .slider-next {\n    display: none;\n}\n\n.slider-title {\n    font-size: 32px;\n    line-height: 40px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-granite);\n    margin-bottom: 32px;\n    text-align: center;\n}\n\n@media screen and (max-width: 1024px) {\n    .slider-title {\n        font-size: 24px;\n        line-height: 32px;\n        margin-bottom: 24px;\n    }\n}\n\n.slider-prev {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    position: absolute;\n    top: 50%;\n    left: -20px;\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    overflow: hidden;\n    background: var(--color-white);\n    box-shadow: 0px 1px 4px rgba(8, 11, 48, 0.2);\n    z-index: 2;\n}\n\n.slider-prev._disabled {\n    opacity: .5;\n    cursor: default;\n}\n\n@media screen and (max-width: 1024px) {\n    .slider-prev {\n        display: none;\n    }\n}\n\n.slider-next {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    position: absolute;\n    top: 50%;\n    right: -20px;\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    overflow: hidden;\n    background: var(--color-white);\n    box-shadow: 0px 1px 4px rgba(8, 11, 48, 0.2);\n    z-index: 2;\n}\n\n.slider-next._disabled {\n    opacity: .5;\n    cursor: default;\n}\n\n@media screen and (max-width: 1024px) {\n    .slider-next {\n        display: none;\n    }\n}\n\n.slider-wrap {\n    overflow: hidden;\n    margin: 0 -16px;\n    padding: 0 16px;\n}\n\n.slider .product-item {\n    margin: 0;\n}\n\n@media screen and (max-width: 576px) {\n    .slider .product-item {\n        width: 180px;\n        display: block;\n    }\n}\n\n/* /SLIDER */\n/* DETAIL PAGE PRODUCT */\n\n\n/* /DETAIL PAGE PRODUCT */\n/* DETAIL CART */\n.cart .success-images {\n    margin-top: 48px;\n}\n\n@media screen and (max-width: 1024px) {\n    .cart .success-images {\n        margin-top: 36px;\n    }\n\n    .cart .success-images__title {\n        font-size: 18px;\n        line-height: 24px;\n    }\n}\n\n.cart .success-images:last-child {\n    margin-top: 40px;\n}\n\n.cart-wrap {\n    margin-top: 24px;\n}\n\n@media screen and (max-width: 1024px) {\n    .cart-wrap {\n        margin-top: 31px;\n    }\n}\n\n.cart-wrap__bottom {\n    display: flex;\n    align-items: center;\n    margin-top: 20px;\n}\n\n@media screen and (max-width: 576px) {\n    .cart-wrap__bottom {\n        flex-direction: column;\n        margin-top: 15px;\n    }\n}\n\n.cart-wrap__btn {\n    border-radius: 4px;\n    background: var(--color-main);\n    height: 48px;\n    border: none;\n    font-size: 16px;\n    line-height: 24px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-white);\n    padding: 12px 20px;\n    margin-right: 12px;\n}\n\n@media screen and (max-width: 576px) {\n    .cart-wrap__btn {\n        width: 100%;\n        height: 40px;\n        padding: 8px 20px;\n        text-align: center;\n        margin-right: 0;\n        margin-bottom: 12px;\n    }\n}\n\n.cart-wrap__link {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-main);\n    font-family: \"RalewaySemiBold\";\n    border: 1px solid var(--color-pale-blue);\n    border-radius: 4px;\n    height: 48px;\n    padding: 12px 20px;\n    display: block;\n}\n\n@media screen and (max-width: 576px) {\n    .cart-wrap__link {\n        width: 100%;\n        height: 40px;\n        padding: 8px 20px;\n        text-align: center;\n        margin-right: 0;\n        margin-bottom: 12px;\n    }\n}\n\n.cart-item {\n    display: flex;\n    position: relative;\n    margin-bottom: 32px;\n}\n\n.cart-item__img {\n    width: 80px;\n    height: 120px;\n    -o-object-fit: cover;\n    object-fit: cover;\n    display: block;\n}\n\n.cart-item__body {\n    margin-left: 16px;\n}\n\n.cart-item__title {\n    font-size: 14px;\n    line-height: 18px;\n    color: var(--color-granite);\n    margin-bottom: 4px;\n}\n\n.cart-calc {\n    width: 112px;\n}\n\n.cart-total {\n    font-size: 18px;\n    line-height: 28px;\n    color: var(--color-granite);\n    display: flex;\n    align-items: center;\n}\n\n.cart-total__basket {\n    position: relative;\n    margin-right: 8px;\n    width: 24px;\n    height: 24px;\n}\n\n.cart-total__count {\n    position: absolute;\n    top: 4px;\n    right: -4px;\n    width: auto;\n    height: 16px;\n    border-radius: 50%;\n    background: var(--color-yellow-pink);\n    font-size: 10px;\n    line-height: 16px;\n    color: var(--color-white);\n    padding: 0 4px;\n}\n\n.cart-total span {\n    font-family: \"RalewaySemiBold\";\n}\n\n/* /DETAIL CART */\n/* DETAIL SLIDER COMPLEMENT */\n.complement {\n    margin: 80px 0;\n    overflow: hidden;\n}\n\n@media screen and (max-width: 1024px) {\n    .complement {\n        margin: 50px 0;\n    }\n}\n\n.complement .container {\n    overflow: hidden;\n}\n\n.complement-title {\n    font-size: 24px;\n    line-height: 32px;\n}\n\n/* /DETAIL SLIDER COMPLEMENT */\n/* BLOCK AVAILABILITY */\n.availability .detail-color:after {\n    right: 9px;\n}\n\n.availability .detail-size:after {\n    right: 9px;\n}\n\n.availability-wrap {\n    margin-top: 32px;\n}\n\n@media screen and (max-width: 1024px) {\n    .availability-wrap {\n        margin-top: 25px;\n    }\n}\n\n.availability-city {\n    position: relative;\n    cursor: pointer;\n}\n\n.availability-city:after {\n    position: absolute;\n    content: '';\n    top: 50%;\n    right: 16px;\n    width: 24px;\n    height: 24px;\n    -webkit-transform: translateY(-50%) scale(1);\n    transform: translateY(-50%) scale(1);\n    background: url(\"../svg/chevron_down_small.svg\") no-repeat;\n    background-size: contain;\n}\n\n.availability-city._active:after {\n    -webkit-transform: translateY(-50%) scale(-1);\n    transform: translateY(-50%) scale(-1);\n}\n\n.availability-city._active .detail-color__body {\n    display: block;\n    opacity: 1;\n    visibility: visible;\n}\n\n.availability-city .detail-size__top {\n    height: 40px;\n    background: var(--color-light-periwinkle-crayola);\n}\n\n.availability-options {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 16px;\n}\n\n@media screen and (max-width: 576px) {\n    .availability-options {\n        flex-direction: column;\n    }\n}\n\n.availability-options .detail-color,\n.availability-options .detail-size {\n    height: 56px;\n    width: calc(50% - 8px);\n    margin: 0;\n}\n\n@media screen and (max-width: 576px) {\n    .availability-options .detail-color,\n    .availability-options .detail-size {\n        width: 100%;\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .availability-options .detail-color {\n        margin-bottom: 16px;\n    }\n}\n\n.availability-options .detail-color__top-img {\n    height: 54px;\n}\n\n.availability-list {\n    margin-top: 32px;\n}\n\n.availability-item {\n    padding: 15px 12px;\n    border-top: 1px solid var(--color-light-periwinkle-crayola);\n    border-left: 1px solid var(--color-light-periwinkle-crayola);\n    border-right: 1px solid var(--color-light-periwinkle-crayola);\n    cursor: pointer;\n}\n\n.availability-item._active .availability-item__body {\n    display: block;\n    opacity: 1;\n    visibility: visible;\n}\n\n.availability-item:first-child {\n    border-radius: 4px 4px 0px 0px;\n}\n\n.availability-item:last-child {\n    border-radius: 0px 0px 4px 4px;\n    border-bottom: 1px solid var(--color-light-periwinkle-crayola);\n}\n\n.availability-item__title {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n}\n\n.availability-item__body {\n    display: none;\n    opacity: 0;\n    visibility: hidden;\n    margin: 16px -4px 0 -4px;\n}\n\n.availability-item__body-title {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n    font-family: \"RalewaySemiBold\";\n    margin: 8px 0 16px 4px;\n}\n\n@media screen and (max-width: 1024px) {\n    .availability-item__body-title {\n        margin: 8px 0 11px 4px;\n    }\n}\n\n.availability-item__body-title span {\n    font-family: \"RalewayRegular\";\n    color: var(--color-blackberry);\n}\n\n.availability-item__body-wrap {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n}\n\n.availability-item__size {\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-granite);\n    font-family: \"RalewayMedium\";\n    width: 108px;\n    height: 48px;\n    background: var(--color-white);\n    border-radius: 4px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 4px;\n    cursor: pointer;\n    border: 1px solid var(--color-pale-blue);\n}\n\n@media screen and (max-width: 1024px) {\n    .availability-item__size {\n        width: 92px;\n    }\n}\n\n.availability-item__size._active {\n    background: var(--color-periwinkle-crayola);\n    border: 1px solid var(--color-main);\n}\n\n.availability-item__size._not {\n    color: var(--color-gray-window);\n    cursor: default;\n}\n\n.availability-item__reservation {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-white);\n    font-family: \"RalewaySemiBold\";\n    background: var(--color-main);\n    padding: 8px 16px;\n    border-radius: 4px;\n    display: inline-block;\n    margin-top: 16px;\n    margin-left: 4px;\n}\n\n/* /BLOCK AVAILABILITY */\n/* BLOCK RESERVATION */\n.reservation {\n    z-index: 12;\n}\n\n.reservation-top {\n    display: flex;\n    padding-bottom: 24px;\n    border-bottom: 1px solid var(--color-light-periwinkle-crayola);\n}\n\n@media screen and (max-width: 767px) {\n    .reservation-top {\n        flex-direction: column;\n        padding-bottom: 29px;\n    }\n}\n\n.reservation-top__title {\n    font-size: 20px;\n    line-height: 26px;\n    color: var(--color-granite);\n    margin-bottom: 8px;\n}\n\n.reservation-top__address {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n    margin-bottom: 8px;\n}\n\n.reservation-top__link {\n    display: inline-block;\n    font-size: 16px;\n    line-height: 25px;\n    color: var(--color-blue-steel);\n}\n\n.reservation-shop {\n    margin-right: 24px;\n    max-width: 253px;\n    width: 100%;\n}\n\n@media screen and (max-width: 767px) {\n    .reservation-shop {\n        margin-bottom: 32px;\n        max-width: 100%;\n    }\n}\n\n.reservation-product__wrap {\n    display: flex;\n}\n\n.reservation-product__img {\n    width: 120px;\n    height: 180px;\n    -o-object-fit: cover;\n    object-fit: cover;\n    display: block;\n}\n\n.reservation-product__info {\n    margin-left: 16px;\n}\n\n.reservation-product__title {\n    font-size: 20px;\n    line-height: 26px;\n    color: var(--color-granite);\n    margin-bottom: 8px;\n}\n\n.reservation-product__text {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blackberry);\n}\n\n.reservation-product__price-new {\n    margin-top: 8px;\n    font-size: 16px;\n    line-height: 24px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-granite);\n}\n\n.reservation-product__price-old {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blackberry);\n    text-decoration: line-through;\n}\n\n.reservation-form {\n    margin-top: 24px;\n}\n\n.reservation-form__text {\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-granite);\n    margin-bottom: 8px;\n}\n\n.reservation-form__input {\n    background: var(--color-light-periwinkle-crayola);\n    height: 40px;\n    max-width: 320px;\n    width: 100%;\n    margin-bottom: 16px;\n    display: block;\n    border-radius: 4px;\n    border: none;\n    padding: 8px 12px;\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blackberry);\n}\n\n.reservation-form__input:focus {\n    outline: none;\n}\n\n.reservation-form__input:active {\n    outline: none;\n}\n\n.reservation-form__label {\n    position: relative;\n    margin-top: 25px;\n    display: block;\n}\n\n.reservation-form__check {\n    opacity: 0;\n    visibility: hidden;\n    z-index: -1;\n    position: absolute;\n}\n\n.reservation-form__check:checked + .reservation-form__span:after {\n    position: absolute;\n    content: '';\n    left: 0;\n    top: 1px;\n    width: 20px;\n    height: 20px;\n    background: url(\"../svg/check-white.svg\") no-repeat var(--color-main);\n    background-size: contain;\n    border-radius: 3px;\n}\n\n.reservation-form__span {\n    position: relative;\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n    padding-left: 30px;\n}\n\n.reservation-form__span:before {\n    position: absolute;\n    content: '';\n    left: 0;\n    top: 0;\n    width: 20px;\n    height: 20px;\n    border-radius: 3px;\n    background: var(--color-light-periwinkle-crayola);\n}\n\n.reservation-form__btn {\n    font-size: 18px;\n    line-height: 28px;\n    color: var(--color-white);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 56px;\n    border-radius: 4px;\n    background: var(--color-main);\n    width: 240px;\n    margin: 24px 0;\n    border: none;\n}\n\n.reservation-form__info {\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--color-blackberry);\n}\n\n.reservation-form__info a {\n    text-decoration: underline;\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--color-blackberry);\n}\n\n/* /BLOCK RESERVATION */\n/* BLOCK SUCCESS */\n.success-wrap {\n    margin-top: 25px;\n}\n\n.success .curtain-back {\n    border: none;\n    width: 24px;\n    height: 24px;\n    margin-right: 12px;\n}\n\n.success-text {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n    margin-top: 24px;\n    margin-bottom: 32px;\n}\n\n.success-images {\n    margin-top: 32px;\n}\n\n.success-images__wrap {\n    overflow-x: auto;\n}\n\n.success-images__title {\n    font-size: 18px;\n    line-height: 24px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-granite);\n    margin-bottom: 16px;\n}\n\n@media screen and (max-width: 1024px) {\n    .success-images__title {\n        font-size: 24px;\n        line-height: 32px;\n    }\n}\n\n.success-images__list {\n    display: flex;\n}\n\n@media screen and (max-width: 767px) {\n    .success-images__list {\n        width: 650px;\n        padding-bottom: 15px;\n    }\n}\n\n.success-images__item {\n    margin-right: 24px;\n    display: flex;\n}\n\n@media screen and (max-width: 1024px) {\n    .success-images__item {\n        flex-direction: column;\n    }\n}\n\n.success-images__item:last-child {\n    margin-right: 0;\n}\n\n.success-images__img {\n    width: 80px;\n    height: 120px;\n    -o-object-fit: cover;\n    object-fit: cover;\n    display: block;\n    margin-right: 16px;\n}\n\n@media screen and (max-width: 1024px) {\n    .success-images__img {\n        width: 180px;\n        height: 272px;\n        margin-bottom: 16px;\n    }\n}\n\n.success-images__name {\n    font-size: 14px;\n    line-height: 18px;\n    color: var(--color-granite);\n    margin-bottom: 4px;\n}\n\n@media screen and (max-width: 1024px) {\n    .success-images__name {\n        font-size: 16px;\n        line-height: 22px;\n    }\n}\n\n@media screen and (max-width: 1024px) {\n    .success-images__price {\n        display: flex;\n    }\n}\n\n.success-images__price-new {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n    font-family: \"RalewaySemiBold\";\n}\n\n@media screen and (max-width: 1024px) {\n    .success-images__price-new {\n        margin-right: 12px;\n    }\n}\n\n.success-images__price-old {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blackberry);\n    text-decoration: line-through;\n}\n\n/* /BLOCK SUCCESS */\n/* BLOCK IMAGES */\n.images .curtain-title {\n    display: flex;\n    align-items: center;\n}\n\n.images .curtain-title span {\n    font-size: 18px;\n    line-height: 28px;\n    color: var(--color-blackberry);\n    font-family: \"RalewayRegular\";\n    display: inline-block;\n    margin-left: 8px;\n}\n\n.images-wrap {\n    display: flex;\n    flex-wrap: wrap;\n    margin: 32px -16px 0 -16px;\n}\n\n@media screen and (max-width: 1024px) {\n    .images-wrap {\n        margin: 24px -8px 0 -8px;\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .images-wrap {\n        margin: 24px -16px 0 -16px;\n    }\n}\n\n.images-link {\n    display: block;\n}\n\n.images-img {\n    width: 178px;\n    height: 268px;\n    -o-object-fit: cover;\n    object-fit: cover;\n    display: block;\n    margin: 0 16px 32px 16px;\n}\n\n@media screen and (max-width: 1024px) {\n    .images-img {\n        width: 168px;\n        height: 252px;\n        margin: 0 4px 8px 4px;\n    }\n}\n\n/* /BLOCK IMAGES */\n/* TABLE SIEZ */\n.size-wrap {\n    width: 1018px;\n}\n\n@media screen and (max-width: 1024px) {\n    .size-wrap {\n        width: 100%;\n    }\n}\n\n.size-wrap__scroll {\n    overflow-y: auto;\n}\n\n.size-wrap__block {\n    width: 890px;\n}\n\n.size-img {\n    width: 100%;\n    height: 750px;\n    -o-object-fit: contain;\n    object-fit: contain;\n    display: block;\n    margin-top: 34px;\n}\n\n/* /TABLE SIEZ */\n/* BLOCK REVIEWS / REVIEWS-ADD */\n.reviews .curtain-title span {\n    font-size: 14px;\n    line-height: 22px;\n    font-family: \"RalewaySemiBold\";\n    color: #6F707A;\n}\n\n.reviews .curtain-title svg {\n    margin: 0 6px;\n    width: 18px;\n    height: 18px;\n}\n\n.reviews .reviews-filter__label {\n    margin-left: 10px;\n}\n\n.reviews .reviews-filter__span {\n    font-size: 14px;\n    line-height: 20px;\n    padding-left: 44px;\n}\n\n.reviews-top {\n    margin-top: 24px;\n    display: flex;\n    align-items: center;\n}\n\n@media screen and (max-width: 576px) {\n    .reviews-top {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n}\n\n.reviews-top__add {\n    font-size: 14px;\n    line-height: 22px;\n    padding: 4px 12px;\n    margin-right: 24px;\n    height: 32px;\n    display: block;\n}\n\n.reviews-top__bonus {\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--color-blackberry);\n    display: flex;\n    align-items: center;\n}\n\n@media screen and (max-width: 576px) {\n    .reviews-top__bonus {\n        margin-top: 10px;\n    }\n}\n\n.reviews-top__bonus svg {\n    width: 20px;\n    height: 20px;\n}\n\n.reviews-filter {\n    display: flex;\n    align-items: center;\n    margin-top: 40px;\n    margin-bottom: 24px;\n}\n\n@media screen and (max-width: 576px) {\n    .reviews-filter {\n        flex-wrap: wrap;\n        margin-top: 34px;\n    }\n}\n\n@media screen and (max-width: 380px) {\n    .reviews-filter .catalog-filter__item {\n        margin-right: 4px;\n    }\n}\n\n@media screen and (max-width: 1024px) {\n    .reviews-filter .catalog-filter__item .catalog-filter__title {\n        border: 1px solid var(--color-light-periwinkle-crayola);\n    }\n}\n\n.reviews-filter__label {\n    position: relative;\n    display: block;\n    margin-bottom: 1px;\n}\n\n@media screen and (max-width: 576px) {\n    .reviews-filter__label {\n        display: block;\n        width: 100%;\n        margin-top: 16px;\n    }\n}\n\n.reviews-filter__input {\n    opacity: 0;\n    visibility: hidden;\n    z-index: -1;\n    position: absolute;\n}\n\n.reviews-filter__input:checked + .reviews-filter__span:after {\n    left: 20px;\n    background: var(--color-main);\n}\n\n.reviews-filter__span {\n    position: relative;\n    padding-left: 53px;\n    display: block;\n}\n\n.reviews-filter__span:before {\n    position: absolute;\n    content: '';\n    top: 3px;\n    left: 0;\n    width: 34px;\n    height: 14px;\n    border-radius: 10px;\n    background: var(--color-light-periwinkle-crayola);\n}\n\n.reviews-filter__span:after {\n    position: absolute;\n    content: '';\n    top: 0;\n    left: 0;\n    width: 20px;\n    height: 20px;\n    background: var(--color-white);\n    border-radius: 50%;\n    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.15), 0px 1px 1px rgba(0, 0, 0, 0.16);\n    transition: left .2s linear, background .2s linear;\n}\n\n.reviews-list {\n    height: calc(100vh - 300px);\n    overflow-y: auto;\n}\n\n.reviews-item {\n    padding-bottom: 24px;\n    margin-bottom: 24px;\n    border-bottom: 1px solid var(--color-light-periwinkle-crayola);\n}\n\n.reviews-item:last-child {\n    margin-bottom: 0;\n    border-bottom: none;\n}\n\n.reviews-item__top {\n    display: flex;\n    align-items: center;\n    margin-bottom: 5px;\n}\n\n@media screen and (max-width: 380px) {\n    .reviews-item__top {\n        flex-wrap: wrap;\n    }\n}\n\n.reviews-item__name {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n    font-family: \"RalewaySemiBold\";\n    display: flex;\n    align-items: center;\n}\n\n.reviews-item__name svg {\n    width: 24px;\n    height: 24px;\n    margin-right: 4px;\n}\n\n.reviews-item__date {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n    position: relative;\n    margin-left: 4px;\n}\n\n.reviews-item__date:before {\n    content: '•';\n    margin-right: 4px;\n}\n\n.reviews-item__status {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n    margin-left: 12px;\n}\n\n.reviews-item__status svg {\n    width: 12px;\n    height: 12px;\n    margin-right: 4px;\n}\n\n.reviews-item__info {\n    display: flex;\n    align-items: center;\n    margin-bottom: 5px;\n}\n\n@media screen and (max-width: 440px) {\n    .reviews-item__info {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n}\n\n.reviews-item__rating {\n    display: flex;\n    align-items: center;\n    margin-right: 4px;\n}\n\n.reviews-item__rating svg {\n    width: 16px;\n    height: 16px;\n}\n\n.reviews-item__term {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n}\n\n@media screen and (max-width: 576px) {\n    .reviews-item__term {\n        margin-top: 8px;\n    }\n}\n\n.reviews-item__term span {\n    color: var(--color-blackberry);\n}\n\n.reviews-item__plus {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n    margin-bottom: 4px;\n}\n\n.reviews-item__plus span {\n    color: var(--color-blackberry);\n}\n\n.reviews-item__minus {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n    margin-bottom: 3px;\n}\n\n.reviews-item__minus span {\n    color: var(--color-blackberry);\n}\n\n.reviews-item__text {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n}\n\n.reviews-more {\n    margin-top: 24px;\n    display: block;\n    width: 100%;\n    font-size: 16px;\n    line-height: 24px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-main);\n    text-align: center;\n    padding: 8px 0;\n    border: 1px solid var(--color-pale-blue);\n    border-radius: 4px;\n}\n\n.reviews-empty {\n    margin-top: 24px;\n    font-size: 18px;\n    line-height: 28px;\n    color: var(--color-blackberry);\n}\n\n.reviews-info {\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--color-granite);\n    margin-top: 27px;\n    margin-bottom: 36px;\n}\n\n@media screen and (max-width: 1024px) {\n    .reviews-info {\n        margin-top: 16px;\n    }\n}\n\n.reviews-info__list {\n    padding: 0;\n    margin: 0;\n}\n\n.reviews-info__item {\n    list-style-type: none;\n    position: relative;\n}\n\n.reviews-info__item:before {\n    content: '—';\n    margin-right: 4px;\n}\n\n.reviews-rating__wrap {\n    margin-bottom: 15px;\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n    display: flex;\n    align-items: center;\n}\n\n.reviews-rating__wrap #ratingbar {\n    width: 124px;\n    height: 25px;\n    background: url(\"../svg/star_outline.svg\") repeat;\n    background-size: 25px auto;\n}\n\n.reviews-rating__wrap #ratingbar::-webkit-progress-bar {\n    background: url(\"../svg/star_outline.svg\") repeat;\n    background-size: 25px auto;\n}\n\n.reviews-rating__wrap #ratingbar::-webkit-progress-value {\n    background: url(\"../svg/star_solid.svg\") repeat;\n    background-size: contain;\n}\n\n.reviews-form__wrap {\n    display: flex;\n    justify-content: space-between;\n}\n\n@media screen and (max-width: 576px) {\n    .reviews-form__wrap {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n}\n\n.reviews-form__wrap .reviews-form__label {\n    width: calc(50% - 8px);\n}\n\n@media screen and (max-width: 576px) {\n    .reviews-form__wrap .reviews-form__label {\n        width: 100%;\n    }\n}\n\n.reviews-form__wrap .reviews-form__textarea {\n    height: 144px;\n}\n\n.reviews-form__label {\n    display: block;\n    width: 100%;\n    margin-bottom: 16px;\n    position: relative;\n}\n\n.reviews-form__label._error .reviews-form__input {\n    border: 1px solid var(--color-error);\n}\n\n.reviews-form__label._error .reviews-form__textarea {\n    border: 1px solid var(--color-error);\n}\n\n.reviews-form__title {\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-granite);\n    margin-bottom: 8px;\n}\n\n.reviews-form__input {\n    height: 40px;\n    width: 100%;\n    display: block;\n    background: var(--color-light-periwinkle-crayola);\n    border-radius: 4px;\n    border: none;\n    padding: 8px 12px;\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-blackberry);\n}\n\n.reviews-form__input:focus {\n    outline: none;\n}\n\n.reviews-form__input:active {\n    outline: none;\n}\n\n.reviews-form__textarea {\n    width: 100%;\n    display: block;\n    background: var(--color-light-periwinkle-crayola);\n    border-radius: 4px;\n    height: 96px;\n    border: none;\n    padding: 8px 12px;\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-blackberry);\n}\n\n.reviews-form__textarea:focus {\n    outline: none;\n}\n\n.reviews-form__textarea:active {\n    outline: none;\n}\n\n.reviews-form__count {\n    position: absolute;\n    top: 3px;\n    right: 0;\n    font-size: 12px;\n    line-height: 16px;\n    color: var(--color-blackberry);\n}\n\n.reviews-form .catalog-filter__title {\n    border: none;\n    background: var(--color-light-periwinkle-crayola);\n    width: 290px;\n    height: 40px;\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n}\n\n@media screen and (max-width: 576px) {\n    .reviews-form .catalog-filter__title {\n        width: 100%;\n    }\n}\n\n.reviews-form .catalog-filter__title:after {\n    position: absolute;\n    content: '';\n    top: 50%;\n    right: 16px;\n    width: 24px;\n    height: 24px;\n    -webkit-transform: translateY(-50%) scale(1);\n    transform: translateY(-50%) scale(1);\n    background: url(\"../svg/chevron_down_small.svg\") no-repeat;\n    background-size: contain;\n}\n\n.reviews-form__btn {\n    border: none;\n    height: 56px;\n    width: 240px;\n    font-size: 18px;\n    line-height: 24px;\n    color: var(--color-white);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 24px 0;\n}\n\n@media screen and (max-width: 1024px) {\n    .reviews-form__btn {\n        width: 100%;\n    }\n}\n\n.reviews-form__btn:focus {\n    outline: none;\n}\n\n.reviews-form__btn:active {\n    outline: none;\n}\n\n.reviews-add .curtain-title span {\n    margin-right: 16px;\n}\n\n@media screen and (max-width: 1024px) {\n    .reviews-add .curtain-title span {\n        margin-right: 0;\n    }\n}\n\n.reviews-add .reviews-filter__label {\n    margin-top: 26px;\n}\n\n.reviews-send .comment-send__check {\n    margin-right: 12px;\n}\n\n.reviews-send__check {\n    margin-right: 12px;\n}\n\n@media screen and (max-width: 1024px) {\n    .reviews-send__check {\n        width: 20px;\n        height: 20px;\n    }\n}\n\n.reviews-send__info {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n    margin: 33px 0 32px 0;\n}\n\n@media screen and (max-width: 1024px) {\n    .reviews-send__info {\n        margin: 25px 0 32px 0;\n    }\n}\n\n.reviews-send__back {\n    margin-right: 38px;\n}\n\n@media screen and (max-width: 1024px) {\n    .reviews-send__back {\n        margin-right: 16px;\n    }\n}\n\n.reviews-all {\n    display: flex;\n    align-items: center;\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-main);\n}\n\n.reviews-all svg {\n    margin-left: 8px;\n}\n\n/* /BLOCK REVIEWS */\n/* QUESTIONS */\n.questions .curtain-title span {\n    margin-left: 12px;\n}\n\n.questions .reviews-list {\n    margin-top: 32px;\n    height: calc(100vh - 160px);\n}\n\n.questions .reviews-item {\n    border-bottom: none;\n    margin-bottom: 16px;\n}\n\n.questions .reviews-item__top {\n    margin-bottom: 8px;\n}\n\n.questions-answer {\n    padding: 8px;\n    border-radius: 4px;\n    background: var(--color-periwinkle-crayola);\n    margin-top: 16px;\n}\n\n.questions-answer__name svg {\n    width: 18px;\n    height: 18px;\n    margin-right: 8px;\n    margin-left: 4px;\n}\n\n.questions-add .curtain-back {\n    margin-right: 18px;\n}\n\n@media screen and (max-width: 1024px) {\n    .questions-add .curtain-back {\n        margin-right: 0;\n    }\n}\n\n.questions-add .reviews-filter__label {\n    margin-top: 24px;\n}\n\n@media screen and (max-width: 1024px) {\n    .questions-add .reviews-filter__label {\n        margin-top: 18px;\n    }\n}\n\n@media screen and (max-width: 1024px) {\n    .questions-add .reviews-form__btn {\n        margin: 19px 0 24px 0;\n    }\n}\n\n.questions-add__form {\n    margin-top: 36px;\n}\n\n@media screen and (max-width: 1024px) {\n    .questions-add__form {\n        margin-top: 18px;\n    }\n}\n\n.questions-send .reviews-send__info {\n    margin: 29px 0 32px 0;\n}\n\n/* /QUESTIONS */\n/* MODAL SLIDER */\n.modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    opacity: 0;\n    visibility: hidden;\n    overflow: hidden;\n    background: var(--color-white);\n    z-index: 50;\n}\n\n.modal._active {\n    opacity: 1;\n    visibility: visible;\n}\n\n.modal-wrap {\n    position: relative;\n}\n\n.modal-close {\n    position: fixed;\n    top: 24px;\n    right: 24px;\n    width: 64px;\n    height: 64px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    background: var(--color-white);\n    cursor: pointer;\n    z-index: 51;\n}\n\n@media screen and (max-width: 767px) {\n    .modal-close {\n        width: 32px;\n        height: 32px;\n        top: 16px;\n        right: 16px;\n    }\n}\n\n.modal-slider,\n.modal .detail-slider {\n    overflow: hidden;\n}\n\n.modal-over,\n.modal .detail-over {\n    position: fixed;\n    top: 50%;\n    left: 200px;\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n    z-index: 51;\n}\n\n@media screen and (max-width: 1024px) {\n    .modal-over,\n    .modal .detail-over {\n        top: initial;\n        left: 50%;\n        bottom: 24px;\n        -webkit-transform: translate(-50%, 0);\n        transform: translate(-50%, 0);\n    }\n}\n\n.modal-full,\n.modal .detail-full {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    overflow-y: auto;\n}\n\n@media screen and (max-width: 480px) {\n    .modal-full a._active,\n    .modal .detail-full a._active {\n        display: flex;\n        align-items: center;\n        height: 100%;\n    }\n}\n\n.modal-full img,\n.modal .detail-full img {\n    width: 100vw;\n    height: auto;\n    max-width: 100%;\n}\n\n.modal-full .detail-full__video,\n.modal .detail-full .detail-full__video {\n    width: 100vw;\n    height: auto;\n    max-width: 100%;\n}\n\n.modal-full__prev,\n.modal-full .detail-full__prev,\n.modal .detail-full__prev,\n.modal .detail-full .detail-full__prev {\n    position: fixed;\n    top: 50%;\n    left: 24px;\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n    background: var(--color-white);\n    border-radius: 50%;\n    width: 64px;\n    height: 64px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    z-index: 2;\n}\n\n@media screen and (max-width: 767px) {\n    .modal-full__prev,\n    .modal-full .detail-full__prev,\n    .modal .detail-full__prev,\n    .modal .detail-full .detail-full__prev {\n        display: none;\n    }\n}\n\n.modal-full__prev svg,\n.modal-full .detail-full__prev svg,\n.modal .detail-full__prev svg,\n.modal .detail-full .detail-full__prev svg {\n    width: 24px;\n    height: 24px;\n}\n\n.modal-full__prev svg path,\n.modal-full .detail-full__prev svg path,\n.modal .detail-full__prev svg path,\n.modal .detail-full .detail-full__prev svg path {\n    fill: var(--color-blackberry);\n}\n\n.modal-full__next,\n.modal-full .detail-full__next,\n.modal .detail-full__next,\n.modal .detail-full .detail-full__next {\n    position: fixed;\n    top: 50%;\n    right: 24px;\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n    background: var(--color-white);\n    border-radius: 50%;\n    width: 64px;\n    height: 64px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    z-index: 2;\n}\n\n@media screen and (max-width: 767px) {\n    .modal-full__next,\n    .modal-full .detail-full__next,\n    .modal .detail-full__next,\n    .modal .detail-full .detail-full__next {\n        display: none;\n    }\n}\n\n.modal-full__next svg,\n.modal-full .detail-full__next svg,\n.modal .detail-full__next svg,\n.modal .detail-full .detail-full__next svg {\n    width: 24px;\n    height: 24px;\n}\n\n.modal-full__next svg path,\n.modal-full .detail-full__next svg path,\n.modal .detail-full__next svg path,\n.modal .detail-full .detail-full__next svg path {\n    fill: var(--color-blackberry);\n}\n\n/* /MODAL SLIDER */\n/* INFO */\n.info {\n    margin: 80px 0;\n    background: var(--color-periwinkle-crayola);\n    overflow-x: auto;\n}\n\n@media screen and (max-width: 1024px) {\n    .info {\n        margin: 54px 0;\n    }\n}\n\n.info-wrap {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 80px;\n}\n\n@media screen and (max-width: 1024px) {\n    .info-wrap {\n        justify-content: flex-start;\n        margin: 0 24px;\n        width: 1000px;\n    }\n}\n\n.info-link {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-right: 60px;\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n}\n\n@media screen and (max-width: 1024px) {\n    .info-link {\n        margin-right: 40px;\n    }\n}\n\n.info-link svg:first-child {\n    margin-right: 10px;\n}\n\n.info-link svg:last-child {\n    margin-left: 10px;\n}\n\n.info-link:last-child {\n    margin-right: 0;\n}\n\n/* /INFO */\n/* BASKET */\n.basket {\n    margin-top: 50px;\n}\n\n@media screen and (max-width: 1024px) {\n    .basket {\n        margin-top: 22px;\n    }\n}\n\n.basket .container {\n    max-width: 1200px;\n}\n\n.basket-h1 {\n    font-size: 32px;\n    line-height: 40px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-granite);\n    margin-bottom: 16px;\n}\n\n@media screen and (max-width: 1024px) {\n    .basket-h1 {\n        font-size: 20px;\n        line-height: 26px;\n        text-align: center;\n        margin-bottom: 25px;\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .basket-empty {\n        text-align: center;\n    }\n}\n\n.basket-empty__text {\n    font-size: 18px;\n    line-height: 28px;\n    color: var(--color-blackberry);\n    margin-bottom: 16px;\n}\n\n.basket-empty__list {\n    display: flex;\n    padding: 0;\n    margin: 0;\n}\n\n@media screen and (max-width: 576px) {\n    .basket-empty__list {\n        flex-direction: column;\n        align-items: center;\n    }\n}\n\n.basket-empty__item {\n    margin-right: 24px;\n}\n\n@media screen and (max-width: 576px) {\n    .basket-empty__item {\n        margin-right: 0;\n    }\n}\n\n.basket-empty__link {\n    font-size: 18px;\n    line-height: 28px;\n    color: var(--color-main);\n}\n\n.basket-wrap {\n    margin-top: 40px;\n    display: flex;\n    justify-content: space-between;\n}\n\n@media screen and (max-width: 1024px) {\n    .basket-wrap {\n        flex-direction: column-reverse;\n        max-width: 500px;\n        margin: 0 auto;\n    }\n}\n\n.basket-list {\n    width: calc(100% - 370px);\n}\n\n@media screen and (max-width: 1024px) {\n    .basket-list {\n        width: 100%;\n    }\n}\n\n.basket-list__clear {\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--color-blackberry);\n    position: relative;\n    display: flex;\n    align-items: center;\n    margin-top: 20px;\n}\n\n@media screen and (max-width: 1024px) {\n    .basket-list__clear {\n        justify-content: center;\n    }\n}\n\n.basket-list__clear:before {\n    content: '';\n    width: 24px;\n    height: 24px;\n    display: block;\n    background: url(\"../svg/delete_trash_bin.svg\") no-repeat;\n    background-size: contain;\n    margin-right: 8px;\n}\n\n.basket-mobile__title {\n    display: none;\n    text-align: center;\n    font-size: 16px;\n    line-height: 20px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-granite);\n    margin-bottom: 20px;\n}\n\n@media screen and (max-width: 1024px) {\n    .basket-mobile__title {\n        display: block;\n        margin-bottom: 41px;\n    }\n}\n\n.basket-item {\n    border-bottom: 1px solid var(--color-light-periwinkle-crayola);\n    padding-bottom: 16px;\n    margin-bottom: 16px;\n    display: flex;\n    position: relative;\n    outline: none !important;\n}\n\n@media screen and (max-width: 1024px) {\n    .basket-item {\n        padding-bottom: 20px;\n        margin-bottom: 21px;\n    }\n}\n\n.basket-item._remove {\n    display: none;\n}\n\n.basket-item__img {\n    width: 120px;\n    height: 180px;\n    -o-object-fit: cover;\n    object-fit: cover;\n    display: block;\n}\n\n@media screen and (max-width: 1024px) {\n    .basket-item__img {\n        width: 48px;\n        height: 73px;\n    }\n}\n\n.basket-item__body {\n    margin-left: 16px;\n    width: 100%;\n}\n\n@media screen and (max-width: 1024px) {\n    .basket-item__body {\n        margin-left: 12px;\n    }\n}\n\n.basket-item__title {\n    font-size: 18px;\n    line-height: 22px;\n    color: var(--color-granite) !important;\n    margin-bottom: 4px;\n    font-weight: 700;\n    text-transform: uppercase;\n    outline: none !important;\n    cursor: pointer;\n    text-decoration: underline;\n}\n\n@media screen and (max-width: 1024px) {\n    .basket-item__title {\n        font-size: 16px;\n        line-height: 22px;\n        margin-bottom: 4px;\n    }\n}\n\n.basket-item__info {\n    margin-bottom: 16px;\n}\n\n.basket-item__info-line {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blackberry);\n}\n\n.basket-item__value:after {\n    content: ';';\n}\n\n.basket-item__value:last-child:after {\n    content: '';\n}\n\n@media screen and (max-width: 1024px) {\n    .basket-item__info-line {\n        font-size: 14px;\n        line-height: 18px;\n    }\n}\n\n.basket-item__bottom {\n    display: flex;\n    align-items: center;\n}\n\n@media screen and (max-width: 1024px) {\n    .basket-item__bottom {\n        align-items: baseline;\n    }\n}\n\n.basket-item__favorite {\n    display: flex;\n    align-items: center;\n    position: relative;\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--color-blackberry);\n    margin-right: 16px;\n}\n\n@media screen and (max-width: 1024px) {\n    .basket-item__favorite {\n        margin-right: 15px;\n    }\n}\n\n.basket-item__favorite._active {\n    color: var(--color-blue-steel);\n}\n\n.basket-item__favorite._active:before {\n    background: url(\"../svg/heart_fav_solid-active-blue.svg\") no-repeat;\n}\n\n.basket-item__favorite:before {\n    content: '';\n    width: 24px;\n    height: 24px;\n    display: inline-block;\n    margin-right: 4px;\n    background: url(\"../svg/heart_fav_outline.svg\") no-repeat;\n    background-size: contain;\n}\n\n@media screen and (max-width: 1024px) {\n    .basket-item__favorite span {\n        display: none;\n    }\n}\n\n.basket-item__remove {\n    display: flex;\n    align-items: center;\n    position: relative;\n    font-size: 14px;\n    line-height: 20px;\n    cursor: pointer;\n    color: var(--color-blackberry);\n}\n\n.basket-item__remove-yes {\n    display: inline-block;\n    margin-right: 12px;\n    line-height: 22px;\n    color: var(--color-error);\n    font-family: \"RalewaySemiBold\";\n}\n\n.basket-item__remove-yes:before {\n    background: url(\"../svg/delete_trash_bin-error.svg\") no-repeat;\n}\n\n.basket-item__remove-no {\n    line-height: 22px;\n    color: var(--color-granite);\n    font-family: \"RalewaySemiBold\";\n}\n\n.basket-item__remove:before {\n    content: '';\n    width: 24px;\n    height: 24px;\n    display: inline-block;\n    margin-right: 4px;\n    background: url(\"../svg/delete_trash_bin.svg\") no-repeat;\n    background-size: contain;\n}\n\n@media screen and (max-width: 1024px) {\n    .basket-item__remove span {\n        display: none;\n    }\n}\n\n.basket-item__del {\n    display: flex;\n    align-items: center;\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blackberry);\n    position: relative;\n    border-bottom: 1px solid var(--color-light-periwinkle-crayola);\n    padding-bottom: 16px;\n    margin-bottom: 16px;\n}\n\n.basket-item__del a {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-main);\n    font-family: \"RalewaySemiBold\";\n    margin-left: 12px;\n}\n\n.basket-item__del:before {\n    content: '';\n    width: 24px;\n    height: 24px;\n    display: inline-block;\n    margin-right: 4px;\n    background: url(\"../svg/delete_trash_bin.svg\") no-repeat;\n    background-size: contain;\n}\n\n.basket-item__calc {\n    width: auto;\n    /*position: absolute;*/\n    top: 0;\n    right: 0;\n}\n\n.basket-item__append {\n    width: 112px;\n}\n\n@media screen and (max-width: 1024px) {\n    .basket-item__append {\n        margin-right: 26px;\n    }\n}\n\n.basket-item__price-new {\n    font-size: 18px;\n    line-height: 22px;\n    font-family: \"RalewayRegular\";\n    color: var(--color-granite);\n    font-weight: 700;\n}\n\n.basket-item__price-old {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blackberry);\n    text-decoration: line-through;\n}\n\n.basket-item__wrap {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border: 1px solid var(--color-pale-blue);\n    border-radius: 4px;\n    padding: 4px;\n    margin-top: 8px;\n    height: 32px;\n}\n\n.basket-item__minus {\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n}\n\n.basket-item__minus._disabled {\n    opacity: .3;\n    cursor: default;\n}\n\n.basket-item__num {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n    border: none;\n    display: block;\n    width: 100%;\n    text-align: center;\n    -moz-appearance: textfield;\n}\n\n.basket-item__num:focus {\n    outline: none;\n}\n\n.basket-item__num::-webkit-outer-spin-button, .basket-item__num::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n}\n\n.basket-item__plus {\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n}\n\n.basket-item__count {\n    margin-top: 8px;\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blackberry);\n}\n\n@media screen and (max-width: 1024px) {\n    .basket-item__count {\n        font-size: 14px;\n        line-height: 18px;\n    }\n}\n\n.basket-order {\n    width: 307px;\n    flex-shrink: 0;\n}\n\n@media screen and (max-width: 1024px) {\n    .basket-order {\n        margin-bottom: 59px;\n        width: 100%;\n    }\n}\n\n.basket-order__title {\n    font-size: 20px;\n    line-height: 26px;\n    color: var(--color-granite);\n    font-family: \"RalewaySemiBold\";\n    margin-bottom: 8px;\n}\n\n@media screen and (max-width: 1024px) {\n    .basket-order__title {\n        font-size: 16px;\n        line-height: 20px;\n        text-align: center;\n        margin-bottom: 16px;\n    }\n}\n\n.basket-order__text {\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-granite);\n    margin-bottom: 4px;\n}\n\n.basket-order__auth {\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-main);\n    font-family: \"RalewaySemiBold\";\n    display: flex;\n    align-items: center;\n    position: relative;\n}\n\n.basket-order__auth:before {\n    content: '';\n    width: 24px;\n    height: 24px;\n    background: url(\"../svg/user_circle-main.svg\") no-repeat;\n    background-size: contain;\n    margin-right: 8px;\n}\n\n.basket-order__form {\n    margin-top: 24px;\n}\n\n.basket-order__wrap {\n    margin-bottom: 16px;\n    display: block;\n}\n\n.basket-order__wrap._error .basket-order__field {\n    border: 1px solid var(--color-error);\n}\n\n.basket-order__wrap._error .error {\n    display: block;\n}\n\n.basket-order__wrap._error .basket-order__wrap-clear {\n    display: block;\n}\n\n.basket-order__wrap-clear {\n    display: none;\n    position: absolute;\n    top: 50%;\n    right: 12px;\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n    cursor: pointer;\n}\n\n.basket-order__wrap-success {\n    display: none;\n    position: absolute;\n    top: 50%;\n    right: 12px;\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n    cursor: pointer;\n}\n\n.basket-order__wrap-success._active {\n    display: block;\n}\n\n.basket-order__wrap-input {\n    display: flex;\n    justify-content: space-between;\n    background: var(--color-light-periwinkle-crayola);\n}\n\n.basket-order__wrap-promo {\n    position: relative;\n    width: 100%;\n}\n\n.basket-order__wrap-apply {\n    position: relative;\n    flex-shrink: 0;\n    min-width: 80px;\n}\n\n.basket-order__wrap-apply._active {\n    display: flex;\n    align-items: center;\n}\n\n.basket-order__wrap-load {\n    display: none;\n    width: 24px;\n    height: 24px;\n    margin: 0 auto;\n}\n\n.basket-order__wrap-load._active {\n    display: block;\n}\n\n.basket-order__field {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blackberry);\n    height: 40px;\n    width: 100%;\n    padding: 8px 12px;\n    background: transparent;\n    border: none;\n}\n\n.basket-order__field:focus {\n    outline: none;\n}\n\n.basket-order__apply {\n    height: 40px;\n    background: transparent;\n    padding: 8px 12px;\n    font-size: 16px;\n    line-height: 24px;\n    font-family: \"RalewaySemiBold\";\n    border: none;\n    color: var(--color-main);\n    cursor: pointer;\n}\n\n.basket-order__line {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 4px;\n}\n\n.basket-order__line-title {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blackberry);\n}\n\n.basket-order__line-value {\n    color: var(--color-granite);\n}\n\n.basket-order__line-info {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blackberry);\n}\n\n.basket-order__line-info-value {\n    color: var(--color-blackberry);\n}\n\n.basket-order__total .basket-order__line-title {\n    font-size: 16px;\n    line-height: 24px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-granite);\n}\n\n.basket-order__total .basket-order__line-value {\n    font-size: 16px;\n    line-height: 24px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-granite);\n}\n\n.basket-order__delivery {\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-blackberry);\n    margin-top: 4px;\n    display: flex;\n    align-items: center;\n}\n\n.basket-order__delivery-wrap {\n    margin-top: 16px;\n}\n\n.basket-order__delivery svg {\n    width: 18px;\n    height: 18px;\n    margin-left: 8px;\n}\n\n.basket-order__btn {\n    display: block;\n    width: 100%;\n    text-align: center;\n    padding: 14px 0;\n    font-size: 18px;\n    line-height: 28px;\n    border: none;\n    margin-top: 16px;\n}\n\n.basket-order__btn:focus {\n    outline: none;\n}\n\n.basket-order__info {\n    margin-top: 34px;\n}\n\n@media screen and (max-width: 1024px) {\n    .basket-order__info {\n        overflow-x: auto;\n        margin-top: 26px;\n    }\n}\n\n@media screen and (max-width: 1024px) {\n    .basket-order__info-wrap {\n        display: flex;\n        width: 432px;\n    }\n}\n\n.basket-order__info-block {\n    margin-bottom: 8px;\n}\n\n@media screen and (max-width: 1024px) {\n    .basket-order__info-block {\n        margin-right: 20px;\n    }\n}\n\n.basket-order__info-link {\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-main);\n    position: relative;\n    display: flex;\n}\n\n.basket-order__info-link:before {\n    content: '';\n    width: 24px;\n    height: 24px;\n    display: block;\n    background: url(\"../svg/info_circle outline-grey.svg\") no-repeat;\n    background-size: contain;\n    margin-right: 4px;\n}\n\n.basket-auth .basket-order__text,\n.basket-auth .basket-order__auth {\n    display: none;\n}\n\n.basket-popup {\n    position: absolute;\n    top: 16px;\n    right: 16px;\n    border-radius: 16px;\n    background: var(--color-main);\n    width: 320px;\n    height: 248px;\n    padding: 20px 24px;\n    display: none;\n    z-index: 4;\n}\n\n.basket-popup._active {\n    display: block;\n}\n\n.basket-popup__title {\n    font-size: 20px;\n    line-height: 26px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-white);\n}\n\n.basket-popup__body {\n    margin-top: 16px;\n    display: flex;\n}\n\n.basket-popup__icon {\n    width: 48px;\n    height: 48px;\n    flex-shrink: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-right: 16px;\n    border-radius: 50%;\n    background: var(--color-light-periwinkle-crayola);\n}\n\n.basket-popup__subtitle {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-gray-window);\n}\n\n.basket-popup__price {\n    font-size: 20px;\n    line-height: 32px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-white);\n}\n\n.basket-popup__bottom {\n    margin-top: 40px;\n    display: flex;\n}\n\n.basket-popup__ok {\n    border-radius: 4px;\n    background: var(--color-white);\n    width: 127px;\n    height: 40px;\n    font-size: 16px;\n    line-height: 24px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-main);\n    display: flex;\n    align-items: center;\n    padding: 14px 16px;\n}\n\n.basket-popup__ok svg {\n    margin-right: 12px;\n    width: 24px;\n    height: 24px;\n}\n\n.basket-popup__show {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-white);\n    height: 40px;\n    margin-left: 24px;\n    display: flex;\n    align-items: center;\n}\n\n/* /BASKET */\n/* 404 PAGE */\n.not-found {\n    text-align: center;\n    margin-bottom: 80px;\n}\n\n.not-found__h1 {\n    font-size: 32px;\n    line-height: 40px;\n    color: var(--color-granite);\n    margin-bottom: 16px;\n}\n\n@media screen and (max-width: 576px) {\n    .not-found__h1 {\n        font-size: 20px;\n        line-height: 26px;\n    }\n}\n\n.not-found__error {\n    font-size: 18px;\n    line-height: 28px;\n    color: var(--color-gray-window);\n    font-family: \"RalewaySemiBold\";\n    margin-bottom: 16px;\n}\n\n@media screen and (max-width: 576px) {\n    .not-found__error {\n        font-size: 16px;\n        line-height: 24px;\n    }\n}\n\n.not-found__text {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n    max-width: 484px;\n    width: 100%;\n    margin: 0 auto;\n}\n\n/* /404 PAGE */\n/* 500 ERROR */\n.five-500 {\n    margin-top: 32px;\n    text-align: center;\n}\n\n.five-500__logo {\n    display: inline-block;\n    margin-bottom: 70px;\n}\n\n@media screen and (max-width: 576px) {\n    .five-500__logo {\n        margin-bottom: 40px;\n    }\n}\n\n.five-500__icon {\n    display: block;\n    margin: 0 auto;\n}\n\n.five-500__h1 {\n    font-size: 32px;\n    line-height: 40px;\n    color: var(--color-granite);\n    text-align: center;\n    margin-bottom: 8px;\n}\n\n@media screen and (max-width: 576px) {\n    .five-500__h1 {\n        font-size: 20px;\n        line-height: 26px;\n    }\n}\n\n.five-500__subtitle {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n    text-align: center;\n    margin-bottom: 32px;\n}\n\n.five-500__reload {\n    font-size: 18px;\n    line-height: 28px;\n    color: var(--color-white);\n    text-align: center;\n    padding: 14px 20px;\n    display: inline-block;\n    margin-bottom: 40px;\n    background: var(--color-main);\n    border-radius: 4px;\n}\n\n.five-500 .connection-list {\n    margin-top: 0;\n}\n\n/* /500 ERROR */\n/* ORDERING */\n.ordering {\n    margin-top: 46px;\n}\n\n@media screen and (max-width: 1024px) {\n    .ordering {\n        margin-top: 24px;\n    }\n}\n\n.ordering h1 {\n    margin-top: 12px;\n    text-align: center;\n    font-size: 32px;\n    line-height: 40px;\n    color: var(--color-granite);\n}\n\n.ordering .info-payment {\n    text-align: center;\n}\n\n@media screen and (max-width: 1024px) {\n    .ordering h1 {\n        font-size: 20px;\n        line-height: 26px;\n    }\n}\n\n/* SELECT */\n.select {\n    position: relative;\n    width: calc(50% - 8px);\n}\n\n@media screen and (max-width: 576px) {\n    .select {\n        width: 100%;\n        margin-top: 8px;\n    }\n}\n\n.select-top {\n    position: relative;\n}\n\n.select-top:after {\n    position: absolute;\n    content: '';\n    top: 50%;\n    right: 16px;\n    width: 24px;\n    height: 24px;\n    -webkit-transform: translateY(-50%) scale(1);\n    transform: translateY(-50%) scale(1);\n    background: url(\"../svg/chevron_down_small.svg\") no-repeat;\n    background-size: contain;\n}\n\n.select-top__input {\n    padding: 4px 12px 4px 9px;\n    height: 40px;\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--color-main);\n    border: 1px solid var(--color-light-periwinkle-crayola);\n    background: var(--color-light-periwinkle-crayola);\n    border-radius: 4px;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    position: relative;\n}\n\n.select-top__input:focus {\n    outline: none;\n}\n\n.select-start, .select-choose, .select-empty {\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-blackberry);\n    display: flex;\n    align-items: center;\n}\n\n.select-start._hide, .select-choose._hide, .select-empty._hide {\n    display: none;\n}\n\n.select-start svg, .select-choose svg, .select-empty svg {\n    margin-right: 8px;\n}\n\n.select-choose svg {\n    margin-right: 12px;\n}\n\n.select-empty svg {\n    margin-right: 10px;\n}\n\n.select-list {\n    display: none;\n    position: absolute;\n    top: 45px;\n    left: 0;\n    width: 100%;\n    background: var(--color-white);\n    border-radius: 4px;\n    padding: 16px 8px 16px 12px;\n    box-shadow: 0px 4px 16px rgba(8, 11, 48, 0.2);\n    z-index: 2;\n}\n\n.select-list._active {\n    display: block;\n}\n\n.select-label {\n    display: block;\n    margin-top: 18px;\n    position: relative;\n}\n\n.select-label._hide {\n    display: none;\n}\n\n.select-label._active .select-text:after {\n    display: block;\n}\n\n.select-label:last-child {\n    margin-bottom: 0;\n}\n\n.select-radio {\n    position: absolute;\n    z-index: -1;\n    opacity: 0;\n    margin: 10px 0 0 20px;\n}\n\n.select-text {\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-granite);\n    width: 100%;\n    display: block;\n    position: relative;\n}\n\n.select-text:after {\n    position: absolute;\n    content: '';\n    display: none;\n    right: 0;\n    top: 0;\n    width: 24px;\n    height: 24px;\n    background: url(\"../svg/check-main.svg\") no-repeat;\n    background-size: contain;\n}\n\n.select-prompt {\n    position: relative;\n    background: var(--color-blue-alice);\n    padding: 8px 46px 8px 12px;\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-granite);\n    display: none;\n    align-items: center;\n    margin-top: 24px;\n    width: 100%;\n    height: 40px;\n}\n\n@media screen and (max-width: 576px) {\n    .select-prompt {\n        height: auto;\n    }\n}\n\n.select-prompt._active {\n    display: flex;\n}\n\n.select-prompt:before {\n    position: absolute;\n    content: '';\n    top: -12px;\n    left: 70%;\n    border-left: 15px solid transparent;\n    border-bottom: 12px solid var(--color-blue-alice);\n    border-right: 15px solid transparent;\n}\n\n@media screen and (max-width: 576px) {\n    .select-prompt:before {\n        left: 50%;\n        -webkit-transform: translateX(-50%);\n        transform: translateX(-50%);\n    }\n}\n\n.select-prompt__close {\n    position: absolute;\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n    right: 14px;\n    display: block;\n    height: 24px;\n}\n\n/* /SELECT */\n/* MAGAZINE */\n.magazine {\n    margin: 80px 0;\n}\n\n@media screen and (max-width: 1024px) {\n    .magazine {\n        margin: 64px 0 40px 0;\n        padding-bottom: 25px;\n    }\n}\n\n.magazine h2 {\n    font-size: 32px;\n    line-height: 40px;\n    text-align: center;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-granite);\n    margin-bottom: 32px;\n}\n\n@media screen and (max-width: 1024px) {\n    .magazine h2 {\n        font-size: 24px;\n        line-height: 32px;\n        margin-bottom: 24px;\n    }\n}\n\n@media screen and (max-width: 1024px) {\n    .magazine-over {\n        overflow-x: auto;\n        padding-bottom: 20px;\n    }\n}\n\n.magazine-wrap {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 30px;\n    flex-direction: row;\n}\n\n@media screen and (max-width: 1024px) {\n    .magazine-wrap {\n        /*width: 1050px;*/\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n        flex-wrap: nowrap;\n        gap: 30px;\n        overflow-x: scroll;\n    }\n}\n\n.magazine-item {\n    width: 23%;\n}\n\n@media screen and (max-width: 1024px) {\n    .magazine-item {\n        width: 240px;\n        flex-shrink: 0;\n    }\n}\n\n.magazine-item__img {\n    width: 100%;\n    height: 324px;\n    -o-object-fit: cover;\n    object-fit: cover;\n    display: block;\n}\n\n@media screen and (max-width: 1350px) {\n    .magazine-item__img {\n        height: 280px;\n        object-fit: contain;\n    }\n}\n\n@media screen and (max-width: 1024px) {\n    .magazine-item__img {\n        width: 240px;\n        height: 240px;\n        object-fit: contain;\n    }\n}\n\n.magazine-item__title {\n    margin-top: 16px;\n    font-size: 18px;\n    line-height: 24px;\n    color: var(--color-granite);\n}\n\n.magazine-item__date {\n    margin-top: 8px;\n    font-size: 12px;\n    line-height: 16px;\n    color: var(--color-blackberry);\n}\n\n/* /MAGAZINE */\n/* INDEX PAGE */\n\n\n.index-full__block {\n    position: absolute;\n    top: 40%;\n    left: 50%;\n    max-width: 530px;\n}\n\n@media screen and (max-width: 1024px) {\n    .index-full__block {\n        display: none;\n    }\n}\n\n.index-full__block-title {\n    font-size: 56px;\n    line-height: 64px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-granite);\n    margin-bottom: 32px;\n}\n\n@media screen and (max-width: 1024px) {\n    .index-full__block-title {\n        font-size: 24px;\n        line-height: 32px;\n        text-align: center;\n        margin-bottom: 16px;\n    }\n}\n\n.index-full__block-show {\n    padding: 12px 20px;\n    font-size: 16px;\n    line-height: 24px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-white);\n    border-radius: 4px;\n    background: var(--color-main);\n    display: inline-block;\n}\n\n.index-dots {\n    position: absolute;\n    left: 0;\n    bottom: 24px !important;\n    z-index: 2;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n}\n\n.index-stocks {\n    /*margin: 32px 0;*/\n    box-shadow: 0 10px 20px #999;\n    z-index: 8;\n}\n\n@media screen and (max-width: 1024px) {\n    .index-stocks {\n        /*margin: 20px 0;*/\n    }\n}\n\n.index-stocks__wrap {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n@media screen and (max-width: 1024px) {\n    .index-stocks__wrap {\n        flex-direction: column;\n    }\n}\n\n.index-stocks__item {\n    display: block;\n    /*width: calc(50% - 16px);*/\n    /*height: 400px;*/\n}\n\n.index-stocks__item {\n\n}\n\n@media screen and (max-width: 1024px) {\n    .index-stocks__item {\n        /*height: 226px;*/\n        width: 100%;\n        /*margin-bottom: 20px;*/\n        box-shadow: none;\n    }\n\n    .index-stocks__item:first-child {\n        margin-bottom: 0;\n        box-shadow: 0 10px 20px #999;\n        z-index: 5;\n    }\n\n    .index-stocks__item:last-child {\n        margin-bottom: 0;\n        box-shadow: 0 10px 20px #999;\n        z-index: 3;\n    }\n}\n\n.index-stocks > .container {\n    margin: 0;\n    padding: 0;\n}\n\n.index-stocks__img {\n    width: 100%;\n    height: 100%;\n    display: block;\n    -o-object-fit: cover;\n    object-fit: cover;\n}\n\n.index-category {\n    margin-top: 64px;\n    margin-bottom: 80px;\n}\n\n@media screen and (max-width: 1024px) {\n    .index-category {\n        margin: 48px 0;\n    }\n}\n\n.index-category__h2 {\n    font-size: 32px;\n    line-height: 40px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-granite);\n    margin-bottom: 32px;\n    text-align: center;\n}\n\n@media screen and (max-width: 1024px) {\n    .index-category__h2 {\n        font-size: 24px;\n        line-height: 32px;\n        margin-bottom: 24px;\n    }\n}\n\n@media screen and (max-width: 1024px) {\n    .index-category__over {\n        overflow-x: auto;\n    }\n}\n\n.index-category__wrap {\n    display: flex;\n    justify-content: space-around;\n    align-items: start;\n    gap: 30px;\n    flex-wrap: wrap;\n}\n\n@media screen and (max-width: 1024px) {\n    .index-category__wrap {\n        display: block;\n        text-align: center;\n    }\n}\n\n.index-category__block {\n    flex: 0 1 calc(25% - 60px);\n    max-width: 80%;\n}\n\n@media screen and (max-width: 1024px) {\n    .index-category__block {\n        width: 240px;\n        display: inline-block;\n        margin-bottom: 30px;\n    }\n}\n\n.index-category__img {\n    max-width: 100%;\n    display: block;\n    -o-object-fit: cover;\n    object-fit: cover;\n    margin-bottom: 24px;\n}\n\n@media screen and (max-width: 1024px) {\n    .index-category__img {\n        width: 240px;\n        height: 240px;\n        margin-bottom: 20px;\n    }\n}\n\n.index-category__link {\n    display: block;\n    outline: none !important;\n    text-decoration: none !important;\n}\n\n.index-category__title {\n    font-size: 24px;\n    line-height: 32px;\n    color: var(--color-granite);\n    font-family: \"RalewaySemiBold\";\n    margin-bottom: 8px;\n}\n\n.index-category__list {\n    padding-left: 0;\n    margin: 0;\n}\n\n.index-category__item {\n    margin-bottom: 8px;\n}\n\n.index-category__item:last-child {\n    margin-bottom: 0;\n}\n\n.index-category__link {\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-granite);\n}\n\n.index-category__link-last {\n    font-family: \"RalewaySemiBold\";\n    line-height: 24px;\n}\n\n.index-category__other {\n    margin-top: 48px;\n}\n\n@media screen and (max-width: 1024px) {\n    .index-category__other {\n        margin-top: 36px;\n    }\n}\n\n.index-category__other-list {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: var(--color-periwinkle-crayola);\n    padding: 28px 20px;\n}\n\n@media screen and (max-width: 1024px) {\n    .index-category__other-list {\n        margin: 0 auto;\n    }\n}\n\n@media screen and (max-width: 420px) {\n    .index-category__other-list {\n        width: 400px;\n    }\n}\n\n@media screen and (max-width: 380px) {\n    .index-category__other-list {\n        justify-content: flex-start;\n    }\n}\n\n.index-category__other-item {\n    font-size: 18px;\n    line-height: 24px;\n    color: var(--color-granite);\n    font-family: \"RalewaySemiBold\";\n    display: flex;\n    align-items: center;\n    margin-right: 50px;\n}\n\n.index-category__other-item:last-child {\n    margin-right: 0;\n}\n\n.index-category__other-item svg {\n    margin-right: 8px;\n}\n\n.index-popular {\n    margin-top: 72px;\n    margin-bottom: 78px;\n}\n\n@media screen and (max-width: 1024px) {\n    .index-popular {\n        margin: 64px 0;\n    }\n}\n\n.index-popular .liked-container {\n    margin: 0 -16px;\n}\n\n.index-popular__title {\n    font-size: 32px;\n    line-height: 40px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-granite);\n}\n\n@media screen and (max-width: 1024px) {\n    .index-popular__title {\n        font-size: 24px;\n        line-height: 32px;\n    }\n}\n\n\n.index-popular .product-item {\n    width: 324px;\n}\n\n@media screen and (max-width: 1350px) {\n    .index-popular .product-item {\n        width: 100%;\n    }\n}\n\n.index-popular .product-item img {\n    height: 494px;\n}\n\n@media screen and (max-width: 1024px) {\n    .index-popular .product-item img {\n        height: 366px;\n    }\n}\n\n\n.index-liked {\n    margin-top: 72px;\n    margin-bottom: 78px;\n}\n\n@media screen and (max-width: 1024px) {\n    .index-liked {\n        margin-bottom: 40px;\n    }\n}\n\n.index-liked .product-item__img {\n    height: 312px;\n}\n\n@media screen and (max-width: 1024px) {\n    .index-liked .product-item__img {\n        height: 272px;\n    }\n}\n\n.index-banner {\n    /*margin-top: 82px;*/\n    box-shadow: 0 10px 20px #999;\n}\n\n@media screen and (max-width: 1024px) {\n    .index-banner {\n        /*margin-top: 68px;*/\n    }\n}\n\n.index-banner > .container {\n    margin: 0;\n    padding: 0;\n}\n\n.index-banner__block {\n    display: block;\n}\n\n.index-banner__img {\n    width: 100%;\n    height: auto;\n    display: block;\n    -o-object-fit: contain;\n    object-fit: contain;\n}\n\n@media screen and (max-width: 480px) {\n    .index-banner__img {\n        display: none;\n    }\n}\n\n.index-banner__img-mobile {\n    display: none;\n}\n\n@media screen and (max-width: 480px) {\n    .index-banner__img-mobile {\n        width: 100%;\n        height: auto;\n        display: block;\n        -o-object-fit: cover;\n        object-fit: cover;\n    }\n}\n\n.index-advantages {\n    margin: 80px 0;\n    padding: 43px 0 47px 0;\n    background: var(--color-periwinkle-crayola);\n}\n\n@media screen and (max-width: 1024px) {\n    .index-advantages {\n        overflow-x: auto;\n        margin: 40px 0 66px 0;\n    }\n}\n\n.index-advantages__wrap {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    max-width: 1140px;\n    margin: 0 auto;\n}\n\n@media screen and (max-width: 1024px) {\n    .index-advantages__wrap {\n        width: 980px;\n    }\n}\n\n.index-advantages__item {\n    width: 200px;\n}\n\n.index-advantages__icon {\n    border-radius: 50%;\n    width: 33px;\n    height: 33px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 0 auto;\n}\n\n.index-advantages__title {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n    font-family: \"RalewaySemiBold\";\n    text-align: center;\n    margin-top: 12px;\n    margin-bottom: 8px;\n}\n\n.index-advantages__text {\n    font-size: 14px;\n    line-height: 18px;\n    color: var(--color-blue-steel);\n    text-align: center;\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: flex-end;\n}\n\n.index-advantages__text:after {\n    content: '';\n    display: block;\n    width: 14px;\n    height: 14px;\n    margin-left: 6px;\n    margin-bottom: 1px;\n    background: url(\"../svg/chevron_right_smal-blue.svg\") no-repeat;\n    background-size: contain;\n}\n\n.index-info h2 {\n    font-size: 32px;\n    line-height: 40px;\n    text-align: center;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-granite);\n    margin-bottom: 34px;\n}\n\n@media screen and (max-width: 1024px) {\n    .index-info h2 {\n        font-size: 24px;\n        line-height: 32px;\n    }\n}\n\n.index-info__wrap {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    max-width: 1103px;\n    width: 100%;\n    margin: 0 auto;\n    gap: 30px;\n    text-align: justify;\n}\n\n@media screen and (max-width: 1024px) {\n    .index-info__wrap {\n        flex-direction: column;\n    }\n}\n\n.index-info__text {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n    max-width: 520px;\n    width: 100%;\n}\n\n@media screen and (max-width: 1024px) {\n    .index-info__text {\n        max-width: 100%;\n        margin-bottom: 20px;\n    }\n\n    .index-info__text:last-child {\n        margin-bottom: 0;\n    }\n}\n\n.index-info__text p {\n    margin-top: 0;\n    margin-bottom: 11px;\n}\n\n.index-news {\n    margin: 36px 0 78px 0;\n}\n\n@media screen and (max-width: 1024px) {\n    .index-news {\n        margin: 48px 0 64px 0;\n    }\n}\n\n.index-news .container {\n    overflow: hidden;\n}\n\n.index-news .slider-wrap {\n    padding: 0;\n}\n\n@media screen and (max-width: 1440px) {\n    .index-news .slider-next {\n        right: -20px;\n    }\n}\n\n@media screen and (max-width: 1440px) {\n    .index-news .slider-prev {\n        left: -20px;\n    }\n}\n\n.index-news__item {\n    display: block;\n    max-width: 443px;\n    width: 100%;\n    flex-shrink: 0;\n}\n\n@media screen and (max-width: 1024px) {\n    .index-news__item {\n        padding: 0 8px;\n    }\n}\n\n.index-news__img {\n    width: 100%;\n    height: 249px !important;\n    -o-object-fit: cover;\n    object-fit: cover;\n    display: block;\n}\n\n.index-news__title {\n    font-size: 20px;\n    line-height: 26px;\n    color: var(--color-granite);\n    margin-top: 16px;\n}\n\n/* /INDEX PAGE */\n\n/* FAVORITE */\n.favorite {\n    margin-top: 70px;\n}\n\n@media screen and (max-width: 1024px) {\n    .favorite {\n        margin-top: 36px;\n    }\n}\n\n.favorite-empty__title {\n    font-size: 24px;\n    line-height: 32px;\n    color: var(--color-granite);\n    margin-bottom: 16px;\n}\n\n.favorite-empty__text {\n    font-size: 18px;\n    line-height: 28px;\n    color: var(--color-blackberry);\n    margin-bottom: 16px;\n}\n\n.favorite-empty__link {\n    font-size: 18px;\n    line-height: 28px;\n    color: var(--color-main);\n    margin-right: 24px;\n}\n\n.favorite-empty__link:last-child {\n    margin-right: 0;\n}\n\n.curtain .aside-all {\n    text-align: left;\n    border: none;\n    background: var(--color-light-periwinkle-crayola);\n}\n\n.curtain .aside-subtitle,\n.curtain .accordion {\n    display: block;\n}\n\n.curtain .accordion-top {\n    display: flex;\n}\n\n.curtain .accordion-body {\n    display: none;\n}\n\n.curtain .accordion-block {\n    display: block;\n}\n\n.curtain .accordion-list {\n    display: block;\n    width: 100%;\n}\n\n.curtain .accordion-item {\n    margin-bottom: 18px;\n}\n\n.curtain .accordion-item:before {\n    content: '';\n}\n\n/* /FAVORITE */\n/* STOCKS */\n.stocks {\n    margin-top: 48px;\n}\n\n@media screen and (max-width: 1024px) {\n    .stocks {\n        margin-top: 14px;\n    }\n}\n\n.stocks .container {\n    max-width: 1920px;\n}\n\n.stocks-h1 {\n    text-align: center;\n    font-size: 56px;\n    line-height: 64px;\n    color: var(--color-granite);\n    font-family: \"RalewaySemiBold\";\n    margin-bottom: 40px;\n}\n\n@media screen and (max-width: 1024px) {\n    .stocks-h1 {\n        font-size: 20px;\n        line-height: 26px;\n        margin-bottom: 24px;\n    }\n}\n\n.stocks-list {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    flex-wrap: wrap;\n}\n\n.stocks-item {\n    width: calc(50% - 16px);\n    height: 400px;\n    display: flex;\n    margin-bottom: 32px;\n}\n\n@media screen and (max-width: 1024px) {\n    .stocks-item {\n        flex-direction: column;\n        height: auto;\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .stocks-item {\n        width: 100%;\n        margin-bottom: 16px;\n    }\n}\n\n.stocks-item__left {\n    width: 50%;\n    flex-shrink: 0;\n}\n\n@media screen and (max-width: 1024px) {\n    .stocks-item__left {\n        width: 100%;\n    }\n}\n\n.stocks-item__img {\n    width: 100%;\n    height: 100%;\n    display: block;\n    -o-object-fit: cover;\n    object-fit: cover;\n}\n\n@media screen and (max-width: 1024px) {\n    .stocks-item__img {\n        height: 360px;\n    }\n}\n\n.stocks-item__right {\n    width: 50%;\n    flex-shrink: 0;\n    padding: 40px;\n    position: relative;\n}\n\n@media screen and (max-width: 1024px) {\n    .stocks-item__right {\n        padding: 32px 32px 20px 32px;\n        width: 100%;\n    }\n}\n\n.stocks-item__title {\n    font-size: 20px;\n    line-height: 26px;\n    color: var(--color-granite);\n    display: block;\n    font-family: \"RalewaySemiBold\";\n    margin-bottom: 16px;\n}\n\n.stocks-item__text {\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-granite);\n}\n\n.stocks-item__bottom {\n    position: absolute;\n    bottom: 32px;\n    left: 40px;\n    display: flex;\n    flex-direction: column;\n}\n\n@media screen and (max-width: 1024px) {\n    .stocks-item__bottom {\n        position: relative;\n        bottom: initial;\n        left: initial;\n        margin-top: 24px;\n    }\n}\n\n.stocks-item__more {\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-granite);\n    display: inline-block;\n}\n\n@media screen and (max-width: 1024px) {\n    .stocks-item__more {\n        margin-bottom: 10px;\n    }\n}\n\n.stocks-text {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n    margin: 66px auto 80px;\n    max-width: 680px;\n    width: 100%;\n}\n\n@media screen and (max-width: 1024px) {\n    .stocks-text {\n        margin: 48px auto 48px;\n    }\n}\n\n.stocks-text ul {\n    padding-left: 20px;\n}\n\n.stocks-text ul li {\n    list-style-type: initial;\n}\n\n.stocks-text a {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n    text-decoration: underline;\n}\n\n.stocks-detail {\n    margin: 48px 0 80px 0;\n}\n\n@media screen and (max-width: 1024px) {\n    .stocks-detail {\n        margin: 14px 0 40px 0;\n    }\n}\n\n.stocks-detail .container {\n    max-width: 956px;\n}\n\n.stocks-detail__block {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 64px;\n    overflow: hidden;\n}\n\n@media screen and (max-width: 576px) {\n    .stocks-detail__block {\n        flex-direction: column;\n        margin-bottom: 48px;\n    }\n}\n\n.stocks-detail__img {\n    max-width: 444px;\n    width: 100%;\n    height: 498px;\n    -o-object-fit: cover;\n    object-fit: cover;\n    display: block;\n    flex-shrink: 0;\n}\n\n@media screen and (max-width: 1024px) {\n    .stocks-detail__img {\n        flex-shrink: initial;\n        width: 50%;\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .stocks-detail__img {\n        width: 100%;\n        margin-bottom: 24px;\n        height: 360px;\n    }\n}\n\n.stocks-detail__right {\n    width: 50%;\n    flex-shrink: 0;\n    padding: 0 0 0 32px;\n}\n\n@media screen and (max-width: 1024px) {\n    .stocks-detail__right {\n        flex-shrink: initial;\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .stocks-detail__right {\n        width: 100%;\n        padding: 0;\n    }\n}\n\n.stocks-detail__title {\n    font-size: 32px;\n    line-height: 40px;\n    font-family: \"RalewaySemiBold\";\n    margin-bottom: 24px;\n}\n\n@media screen and (max-width: 767px) {\n    .stocks-detail__title {\n        font-size: 24px;\n        line-height: 32px;\n        margin-bottom: 16px;\n    }\n}\n\n.stocks-detail__text {\n    font-size: 18px;\n    line-height: 28px;\n    color: var(--color-blackberry);\n    margin-bottom: 32px;\n}\n\n@media screen and (max-width: 576px) {\n    .stocks-detail__text {\n        font-size: 16px;\n        line-height: 24px;\n        margin-bottom: 25px;\n    }\n}\n\n.stocks-detail__link {\n    font-size: 16px;\n    line-height: 24px;\n    padding: 12px 20px;\n    display: inline-block;\n}\n\n.stocks-detail__bottom {\n    margin-top: 48px;\n}\n\n.stocks-detail__other {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-main) !important;\n    font-family: \"RalewaySemiBold\";\n    padding: 12px 20px;\n    border-radius: 4px;\n    border: 1px solid var(--color-pale-blue);\n    text-decoration: none !important;\n    display: inline-block;\n}\n\n/* /STOCKS */\n\n\n/*# sourceMappingURL=main.css.map */\n\n.text-strikeout {\n    text-decoration: line-through;\n    text-decoration-color: #dd0000;\n}\n\n/* промокод ------------------------- */\n\n.promocode__wrapper{\n    margin-bottom: 20px;\n}\n\n.promocode {\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n    justify-content: stretch;\n    color: var(--color-blackberry);\n    /* background-color: var(--color-blackberry); */\n    border: 3px solid #dddddd;\n    border-radius: 6px;\n    overflow: hidden;\n    height: 36px;\n}\n\n.promocode__code-wrapper {\n    flex: 0 0 50%;\n    justify-content: stretch;\n    color: var(--color-blackberry);\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n}\n\n.promocode__code {\n    padding: 0 15px;\n    text-align: center;\n    font-size: 1em;\n    text-transform: uppercase;\n}\n\n.promocode__button-wrapper {\n    flex: 0 0 50%;\n    justify-content: stretch;\n    display: flex;\n    align-items: stretch;\n    flex-direction: row;\n    color: var(--color-blackberry);\n}\n\n.promocode__button {\n    flex: 1 1 auto;\n    padding: 3px 15px;\n    color: #ffffff;\n    background-color: var(--color-blackberry);\n    border: 0;\n    border-left: 1px solid var(--color-blackberry);\n    /* border-radius: 6px; */\n    cursor: pointer;\n    text-transform: uppercase;\n    text-align: center;\n}\n\n.promocode__input-wrapper {\n    flex: 0 0 50%;\n    color: var(--color-blackberry);\n    display: flex;\n    align-items: center;\n    justify-content: stretch;\n    flex-direction: row;\n}\n\n.promocode__input {\n    display: block;\n    border: none !important;\n    padding: 0 16px;\n    width: 100%;\n    box-sizing: border-box;\n    outline-width: 0 !important;\n    font-size: 1em;\n    /*text-transform: uppercase;*/\n}\n.promocode__input:focus-visible,\n.promocode__input:focus{\n    border:none !important;\n    outline-width: 0 !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
